// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 280 500\"><rect width=\"280\" height=\"500\" rx=\"30\" fill=\"%23f5f5f5\" stroke=\"%23e0e0e0\" stroke-width=\"2\"/><rect x=\"10\" y=\"10\" width=\"260\" height=\"480\" rx=\"25\" fill=\"%23ffffff\"/><circle cx=\"140\" cy=\"25\" r=\"5\" fill=\"%23333\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared list / delivery UI (Sent Messages, Scheduled, WhatsApp lists) */
.sent-messages-container {
    padding: 20px;
    background-color: #f8f9fa;
    min-height: 100vh;
}

.sent-messages-header {
    margin-bottom: 30px;
}

.breadcrumb-nav {
    font-size: 14px;
    color: #6c757d;
    margin-bottom: 10px;
}

.breadcrumb-item {
    color: #6c757d;
}

.breadcrumb-separator {
    margin: 0 8px;
}

.page-title {
    font-size: 28px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 20px;
}

.filters-section {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
    padding: 15px 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-group label {
    margin: 0;
    font-weight: 500;
    color: #495057;
    font-size: 14px;
}

.filter-group .dropdown-toggle {
    min-width: 150px;
    text-align: left;
    border-color: #dee2e6;
}

.add-filter-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #6c5ce7;
    text-decoration: none;
    font-weight: 500;
    padding: 6px 12px;
}

.add-filter-btn:hover {
    color: #5b4bc4;
    text-decoration: none;
}

.message-name {
    font-weight: 500;
    color: #212529;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.status-badge.delivered {
    background-color: #d4edda;
    color: #155724;
}

.status-badge.failed {
    background-color: #f8d7da;
    color: #721c24;
}

.status-badge.pending {
    background-color: #fff3cd;
    color: #856404;
}

.status-badge.processing {
    background-color: #d1ecf1;
    color: #0c5460;
}

.status-badge.cancelled {
    background-color: #e2e3e5;
    color: #383d41;
}

.dropdown-toggle.btn-link:focus {
    box-shadow: none !important;
}

@media (max-width: 768px) {
    .sent-messages-container {
        padding: 15px;
    }

    .filters-section {
        flex-direction: column;
        align-items: flex-start;
    }

    .filter-group {
        width: 100%;
    }

    .filter-group .dropdown-toggle {
        width: 100%;
    }

    .dashboard_app_table--list-records .table_inner {
        overflow-x: auto;
    }
}


/* Users page dropdown styling */
.dashboard_table .dropdown-toggle::after,
.user-action-dropdown::after {
    display: none !important;
}

.user-action-dropdown {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

.user-action-dropdown:hover,
.user-action-dropdown:focus,
.user-action-dropdown:active {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

.dashboard_table .dropdown-menu {
    min-width: 200px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 8px 0;
    z-index: 1050;
}

.dashboard_table .dropdown-item {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    font-size: 14px;
}

.dashboard_table .dropdown-item:hover {
    background-color: #f5f5f5;
}

.dashboard_table .dropdown-item.text-danger:hover {
    background-color: #fff5f5;
}

/* =========================================================
   Global scrollbar styling (project-wide)
   Works on: Chrome/Edge/Safari (webkit) + Firefox
   ========================================================= */
:root {
    --ns-scrollbar-thumb: rgba(152, 162, 179, 0.75);
    --ns-scrollbar-thumb-hover: rgba(152, 162, 179, 0.95);
    --ns-scrollbar-track: rgba(0, 0, 0, 0.06);
    --ns-scrollbar-size: 10px;
    --ns-scrollbar-radius: 10px;
}

/* Firefox */
* {
    scrollbar-width: thin;
    scrollbar-color: var(--ns-scrollbar-thumb) var(--ns-scrollbar-track);
}

/* Chrome / Edge / Safari */
*::-webkit-scrollbar {
    width: var(--ns-scrollbar-size);
    height: var(--ns-scrollbar-size);
}

*::-webkit-scrollbar-track {
    background: var(--ns-scrollbar-track);
    border-radius: var(--ns-scrollbar-radius);
}

*::-webkit-scrollbar-thumb {
    background-color: var(--ns-scrollbar-thumb);
    border-radius: var(--ns-scrollbar-radius);
    border: 2px solid transparent;
    background-clip: content-box;
}

*::-webkit-scrollbar-thumb:hover {
    background-color: var(--ns-scrollbar-thumb-hover);
}

body {
    font-family: 'Arial', sans-serif;

}

/* .nav-link.active {
  background-color: #f8f9fa;
  color: #007bff;
}

.nav-link {
  color: #a0a5aa;
}

.nav-link:hover {
  color: #68788a;
  text-decoration: none;
} */



/* Full height for main container */
html,
body,
#root {
    height: 100%;
    margin: 0;
    padding: 0;
}

/* .sidebar {
  width: 250px;
  height: 100vh;
} */

.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    background-color: #f8f9fa;
    padding: 20px;
    width: 18%;
    overflow-y: auto;
}


/* Main content area background */
.main-content-container {
    background-color: #f5f6fa;
    /* Light gray background */
    min-height: 100vh;
    display: flex;
    /* justify-content: center; */
    /* align-items: center; */
}

/* Center the form container */
.form-container {
    width: 100%;
    height: 100vh;
    /* Full viewport height */
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Optional: Form styling */
.card {
    border-radius: 8px;
    background-color: #fff;
    /* Ensure white background */
}

/* General form spacing */
.form-control {
    /* margin-bottom: 20px; */
}


/* For the entire page */
/* ::-webkit-scrollbar {
    width: 4px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background: #888;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
} */

.mobile-image {
    width: 450px;
    height: 450px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: top center;
    margin: 0px auto;
    /* line-height: 1px; */
    position: sticky;
    /* max-width: 100%; */
    background-size: 100%;
}


/* .mobile-image {
  width: 450px;
  height: 660px;
  background-image: url('../mobile.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0px auto;
  line-height: 1px;
  position: sticky;
} */

.notification-card {
    display: flex;
    width: 85%;
    margin: 0 auto;
    background-color: white;
    border-radius: 15px;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translate(-50%, 0);
    text-align: left;
}

.notification-card .profile {
    display: inline-block;
    margin-right: 10px;
}

.notification-card .profile img {
    width: 23px;
    height: 23px;
    border-radius: 50%;
}

.notification-card .content {
    display: inline-block;
}

.notification-card .content p {
    margin: 0;
    font-size: 14px;
    color: #000;
}

.notification-card .content span {
    font-size: 12px;
    color: #777;
}

#notification-button {
    background-color: white;
    border-radius: 10%;
}

#notification-button:hover {
    background-color: #e7e7e7;
    border-radius: 4px;
}







/* Step Page */


.steps_page {
    padding: 0px 1.5rem;
    margin-top: 1.5rem;
    display: grid;
    grid-template-rows: auto;
    row-gap: 1.5rem;
}

.steps_inner {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.steps_heading {
    margin-bottom: 1.5rem;
    text-align: center;
}

.steps_heading h1 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}

.steps_form_outer {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    gap: 1.5rem;
    width: 100%;
}

@media (min-width: 48em) {
    .steps_form_outer {
        width: auto;
    }
}

@media (min-width: 62em) {
    .steps_form_outer {
        flex-direction: row;
    }
}

.steps_left {
    padding: 1.5rem;
    border-radius: 0.5rem;
    position: relative;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
    margin-bottom: 1.5rem;
    width: 100%;
}

@media (min-width: 48em) {
    .steps_left {
        width: 40rem;
    }
}

.inner_heading h2 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}

.steps_sub_heading {
    margin-top: 0.25rem;
    margin-bottom: 1rem;
}

.name_field {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 0.5rem;
    width: 100%;
    margin-bottom: 1rem;
}

@media (min-width: 48em) {
    .name_field {
        flex-direction: row;
        width: 100%;
    }
}

.name_field>* {
    flex: 1 1;
}

.name_field label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
}

.name_field label::after {
    content: "*";
    font-size: 125%;
    color: rgb(229, 75, 77);
    margin-left: 3px;
}


.name_field1 {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 0.5rem;
    width: 100%;
    margin-bottom: 1rem;
}

@media (min-width: 48em) {
    .name_field1 {
        flex-direction: row;
        width: 100%;
    }
}

.name_field1>* {
    flex: 1 1;
}

.name_field1 label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
}

.name_field1 label::after {
    content: "*";
    font-size: 125%;
    color: rgb(229, 75, 77);
    margin-left: 3px;
}



.input_field {
    width: 100%;
    position: relative;
    display: flex;
}

.input_field input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
}

.validation_error {
    margin-top: 0.25rem;
}

.validation_error span {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 1rem;
    color: rgb(229, 75, 77);
}

.validation_error img {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
    min-width: 1rem;
    left: 0px;
    margin-right: 0.5rem;
    position: relative;
    top: 0.25rem;
    color: rgb(229, 75, 77);
}

.category_field {
    margin-bottom: 1rem;
}

.category_field label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}

.category_field label::after {
    content: "*";
    font-size: 125%;
    color: rgb(229, 75, 77);
    margin-left: 3px;
}

.select_field {
    max-width: 262px;
}

.select_field select {
    width: 100%;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(203, 209, 215);
    color: rgb(5, 27, 44) !important;
}

.select_section_label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}

.select_apply_section {
    margin-bottom: 1rem;
}

.select_section_label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}

.select_section_label label {
    margin-bottom: 5px;
}

.select_boxes {
    display: flex;
    flex-direction: column;
}


.select_box {
    min-height: 2rem;
    position: relative;
}

.select_box label {
    padding-left: 0.4rem;
}



.phone_section {
    margin-bottom: 1rem;
}

.phone_section label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}

/* .phone_section label::after {
  content: "*";
  font-size: 125%;
  color: rgb(229, 75, 77);
  margin-left: 3px;
} */

.phone_input {
    max-width: 262px;
}

.phone_input input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
}

button.form_btn {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(67, 70, 206);
    line-height: 1.125rem;
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
}




* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

img {
    max-width: 100%;
}

a {
    text-decoration: none !important;
}



.signup_page {
    position: fixed;
    overflow-x: auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    inset: 0;
    box-sizing: border-box;
    background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);
}

.signup_page_inner {
    box-sizing: border-box;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding-top: max(clamp(1rem, 3vh, 2.5rem), env(safe-area-inset-top));
    padding-right: max(0.75rem, env(safe-area-inset-right));
    padding-bottom: max(clamp(1rem, 3vh, 2.5rem), env(safe-area-inset-bottom));
    padding-left: max(0.75rem, env(safe-area-inset-left));
}

.page_logo {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    gap: 0px;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.page_logo a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    column-gap: 0.25rem;
    color: rgb(67, 70, 206);
    overflow-wrap: anywhere;
}

.signup_page .page_logo img {
    width: auto;
    max-width: 150px;
    height: auto;
    display: block;
    flex: 0 0 auto;
    min-width: 0;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45)) drop-shadow(0 0 1px rgba(255, 255, 255, 0.25));
}

@media (min-width:30em) {
    .form_outer {
        max-width: 28rem;
    }
}

.form_outer {
    width: calc(100% - 3rem);
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border-radius: 1rem;
    padding: calc(2rem);
    justify-self: center;
    display: grid;
    gap: calc(1rem) !important;
}

.form_heading {
    display: flex;
    flex-flow: column wrap;
    gap: 0.5rem;
    justify-content: start;
    align-items: stretch;
    margin: 0px;
    color: rgb(66, 77, 87);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0px;
}

.form_heading h1 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}

.signup_google {
    display: grid;
    grid-template-columns: auto min-content min-content;
    gap: 0.5rem;
}

.signup_google button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    padding: 0.35rem;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(192, 193, 245);
    color: rgb(67, 70, 206) !important;
    height: 40px;
    width: 40px;
}

.signup_google .signup_google_button {
    width: 100%;
    padding: 0.5rem 0.75rem;
}

.signup_google_button img {
    max-width: 20px;
    margin-right: 5px;
}

.separator {
    display: grid;
    grid-template-columns: auto max-content auto;
    width: 100%;
    align-items: center;
    gap: 1rem;
    margin: 0px;
}

.separator hr {
    display: block;
    margin: 0px;
    border-width: 1px 0px 0px;
    border-color: rgb(203, 209, 215);
    border-style: solid;
    width: auto;
    height: 0px;
    align-self: unset;
}

.login_form form {
    display: grid;
    row-gap: 1.5rem;
}

.login_form .input_boxes {
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    justify-content: start;
    align-items: stretch;
}

.email_input {
    width: 100%;
    position: relative;
    display: flex;
}

.email_input input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
    width: 100%;
    flex: 1 1;
    transition: border-color 100ms ease-in-out, background-color 100ms ease-in-out;
}

.password_input img {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
    cursor: pointer;
    pointer-events: auto;
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    right: 0.75rem;
}

.password_box span {
    margin: 0px;
    color: rgba(255, 0, 0, 0.82);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    /* font-size: 0.75rem; */
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.015rem;
}

.recaptcha {
    position: relative;
}

.recaptcha .checkbox {
    width: 1rem;
    height: 1rem;
    left: 0.25rem;
    top: 0.25rem;
    appearance: none;
    opacity: 0.0001;
    position: absolute;
    margin: 0px !important;
    z-index: 1;
    cursor: pointer;
}

.recaptcha_lable {
    display: flex;
    padding-left: 1.5rem;
    position: relative;
}

.recaptcha_lable label {
    font-weight: normal;
    color: rgb(5, 27, 44);
    margin-bottom: 0px;
    font-size: 1rem;
}

.recaptcha_lable label:before {
    width: 1rem;
    height: 1rem;
    border-radius: 0.125rem;
    top: 0.25rem;
    left: 0px;
    position: absolute;
    border: 1px solid rgb(203, 209, 215);
    display: inline-block;
    content: " ";
    transition: border-color 0.2s ease-in-out;
    background-color: rgb(255, 255, 255);
}

.recaptcha_lable label:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0.25rem;
    display: inline-block;
    transform: rotate(45deg);
    height: 11px;
    width: 6px;
    margin-left: 0.3em;
    border-bottom: 2px solid #78b13f;
    border-right: 2px solid #78b13f;
    opacity: 0;
    visibility: hidden;
    transition: all .3s;
}

.checkbox:checked~.recaptcha_lable label:after {
    opacity: 1;
    visibility: visible;
}

.signup_button {
    display: flex;
    flex-flow: wrap;
    gap: 0px;
    justify-content: start;
    align-items: start;
}

.signup_button button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: rgb(67, 70, 206);
    line-height: 1.125rem;
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
    width: 100%;
}

.already_acc {
    display: flex;
    flex-flow: wrap;
    gap: 0px;
    justify-content: center;
    align-items: start;
    margin-top: 10px
}

.already_acc span {
    margin: 0px;
    color: rgb(66, 77, 87);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    letter-spacing: 0px;
}

.already_acc span a {
    display: inline-flex;
    align-items: center;
    column-gap: 0.25rem;
    color: rgb(67, 70, 206);
    overflow-wrap: anywhere;
}

/* Plan Page */
.plan_page {
    background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);
    color: white;
    height: 100vh;
    padding: 2.5rem 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
}

.plan_page h1 {
    margin: 0px;
    color: inherit;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}

.plan_page a {
    display: inline-flex;
    align-items: center;
    column-gap: 0.25rem;
    color: #fff;
    overflow-wrap: anywhere;
}

.plan_boxes {
    position: relative;
    display: grid;
    gap: 1.5rem;
    padding: 1.5rem;
    grid-template-columns: 1fr;
    align-items: flex-start;
}

@media (min-width: 767px) {
    .plan_boxes {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1220px) {
    .plan_boxes {
        grid-template-columns: repeat(4, 1fr);
    }
}

.plan_box {
    padding: 1.5rem;
    border-radius: 0.5rem;
    position: relative;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
    border-radius: 1rem;
    padding: 1.5rem;
    width: 100%;
}

.plan_inner {
    display: flex;
    flex-flow: column wrap;
    gap: 1.5rem;
    justify-content: start;
    align-items: stretch;
}

.plan_content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
}

.plan_content h2 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 2rem;
    letter-spacing: 0px;
}

.plan_content p {
    margin: 0px;
    color: rgb(66, 77, 87);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0px;
}

.plan_price {
    display: flex;
    flex-flow: wrap;
    gap: 0.25rem;
    justify-content: center;
    align-items: end;
}

.plan_price h3 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.75rem;
    letter-spacing: 0.00875rem;
}

.plan_content p.plan_desc {
    margin: 0px;
    color: rgb(66, 77, 87);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.125rem;
    letter-spacing: 0.015rem;
}

p.plan_desc span {
    margin: 0px;
    color: rgb(66, 77, 87);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.015rem;
}

.plan_page a.plan_button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(67, 70, 206);
    line-height: 1.125rem;
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
}

.descriptions {
    display: flex;
    flex-flow: column wrap;
    gap: 0.5rem;
    justify-content: start;
    align-items: stretch;
}

.descriptions p {
    margin: 0px;
    color: rgb(66, 77, 87);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0px;
}

.descriptions ul {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0px;
    margin: 0px;
}

.descriptions ul li {
    list-style-type: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0px;
    color: rgb(66, 77, 87);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    letter-spacing: 0px;
}

.descriptions ul li svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: rgb(59, 182, 116);
    opacity: 1;
}

/* Step Page */
/* .steps_page {
    padding: 0px 1.5rem;
    margin-top: 1.5rem;
    display: grid;
    grid-template-rows: auto;
    row-gap: 1.5rem;
}
.steps_inner {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    flex-direction: column;
}
.steps_heading {
    margin-bottom: 1.5rem;
    text-align: center;
}
.steps_heading h1 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}
.steps_form_outer {
    display: flex;
    flex-direction: column-reverse;
    -webkit-box-pack: justify;
    justify-content: space-between;
    gap: 1.5rem;
    width: 100%;
}

@media (min-width: 48em) {
    .steps_form_outer {
        width: auto;
    }
}
@media (min-width: 62em) {
    .steps_form_outer {
        flex-direction: row;
    }
}
.steps_left {
    padding: 1.5rem;
    border-radius: 0.5rem;
    position: relative;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
	margin-bottom: 1.5rem;
	width: 100%;
}
@media (min-width: 48em) {
    .steps_left {
        width: 40rem;
    }
}
.inner_heading h2 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}
.steps_sub_heading {
    margin-top: 0.25rem;
    margin-bottom: 1rem;
}
.input_field {
    width: 100%;
    position: relative;
    display: flex;
}
.input_field input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
}
.validation_error {
    margin-top: 0.25rem;
}
.validation_error span {
    position: relative;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 1rem;
    color: rgb(229, 75, 77);
}
.validation_error img {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
    min-width: 1rem;
	left: 0px;
    margin-right: 0.5rem;
    position: relative;
    top: 0.25rem;
	color: rgb(229, 75, 77);
}
.category_field {
    margin-bottom: 1rem;
}
.category_field label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}
.select_field {
    max-width: 262px;
}
.select_field select {
    width: 100%;
    cursor: pointer;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(203, 209, 215);
    color: rgb(5, 27, 44) !important;
}
.select_section_label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}
.select_section_label label::after {
  content: "*";
  font-size: 125%;
  color: rgb(229, 75, 77);
  margin-left: 3px;
}


.select_apply_section {
    margin-bottom: 1rem;
}
.select_section_label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}
.select_section_label label{margin-bottom: 5px;}
.select_boxes {
    display: flex;
    flex-direction: column;
}


.select_box {
    min-height: 2rem;
    position: relative;
}
.select_box label {
  padding-left: 0.4rem;
} */

/* .select_box input {
    width: 1rem;
    height: 1rem;
    left: 0.25rem;
    top: 0.25rem;
    appearance: none;
    opacity: 0.0001;
    position: absolute;
    margin: 0px !important;
	z-index: 1;
	cursor: pointer;
}
.select_box label {
    display: flex;
    padding-left: 1.5rem;
    position: relative;
    margin-bottom: 0px;
    font-size: 1rem;

}
.select_box label::before {
    width: 1rem;
    height: 1rem;
    border-radius: 0.125rem;
    top: 0.25rem;
    left: 0px;
    position: absolute;
    border: 1px solid rgb(203, 209, 215);
    display: inline-block;
    content: " ";
    transition: border-color 0.2s ease-in-out;
    background-color: rgb(255, 255, 255);
}
.select_box label:after{
	content: '';
	position: absolute;
	left: 0;
	top: 0.25rem;
	display: inline-block;
	transform: rotate(45deg);
	height: 11px;
	width: 6px;
	margin-left: 0.3em;
	border-bottom: 2px solid #78b13f;
	border-right: 2px solid #78b13f;
	opacity: 0;
	visibility: hidden;
	transition: all .3s;
}
.select_box input:checked ~ .select_box label:after{
	opacity: 1;
	visibility: visible;
} */
.phone_section {
    margin-bottom: 1rem;
}

.phone_section label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}

.phone_input {
    max-width: 262px;
}

.phone_input input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
}

button.form_btn {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(67, 70, 206);
    line-height: 1.125rem;
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
}

.steps_right {
    width: max-content;
}

.step_right_heading {
    margin-bottom: 0.5rem;
}

.step_progress {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 16px;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(162, 173, 185);
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
    height: 0.75rem;
    border-radius: 1rem;
}

.progress_bar {
    width: 0%;
    display: flex;
    background-color: rgb(59, 182, 116);
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
}

.step_listing {
    display: flex;
    flex-direction: column;
    margin-top: 1.5rem;
}

.step_list {
    display: flex;
    align-items: flex-start;
}

.step_count {
    display: flex;
    flex-direction: column;
    margin-right: 0.5rem;
    align-items: center;
    justify-content: center;
    color: rgb(255, 255, 255);
    background-color: rgb(116, 128, 139);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    line-height: 0;
    padding: 0px 0.25rem;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    font-size: 12px;
}

.step_seperator {
    background-color: rgb(185, 194, 202);
    width: 1px;
    height: 0.875rem;
    margin-top: 0.375rem;
    margin-bottom: 0.25rem;
    margin-left: 0.4375rem;
}

.step_list label {
    font-weight: normal;
    color: rgb(5, 27, 44);
    font-size: 1rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    line-height: 1;
    padding-bottom: 0.25rem;
    max-width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
}

.step_list.active label {
    font-weight: bold;
}

/* Step_1 */
.step_1 .name_field {
    display: block;
    max-width: 400px;
}

.step_1 .name_field1 {
    display: block;
    max-width: 400px;
}

.step_1 .select_field {
    max-width: 400px;
}

.step_1 .progress_bar {
    width: 33%;
}

.step_2 .progress_bar {
    width: 66%;
}

.step_1 .step_list.filled .step_count {
    background: rgb(59, 182, 116);
}

.step_2 .step_list.filled .step_count {
    background: rgb(59, 182, 116);
}
















/*  dashboard  */

/* Main workspace: minmax(0,1fr) prevents wide tables/buttons from stretching past the viewport */
@media (min-width: 48em) {
    .dashboard_page {
        display: grid;
        grid-template-columns: 265px minmax(0, 1fr);
        transition: all .4s;
        overflow: visible;
    }

    .dashboard_page.collapsed_menu {
        grid-template-columns: 64px minmax(0, 1fr);
    }
}

@media (max-width: 47.99em) {
    .dashboard_page {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 100vw;
        min-height: 100vh;
        overflow-x: hidden;
        box-sizing: border-box;
    }
}

.dashboard-main-shell {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    padding: clamp(0.75rem, 2.2vw, 1.25rem);
    overflow-x: hidden;
}

/* Pending-bill notice — full width at the top of every dashboard page */
.pending-bill-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: nowrap;
    position: fixed;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2000;
    width: min(760px, calc(100vw - 32px));
    box-sizing: border-box;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
    padding: 12px 44px 12px 16px;
    border: 1px solid #fde68a;
    border-radius: 10px;
    background: #fffbeb;
    color: #92400e;
    font-size: 14px;
    font-weight: 500;
}

.pending-bill-banner__text {
    flex: 1 1 auto;
    min-width: 0;
}

.pending-bill-banner__link {
    flex: 0 0 auto;
    white-space: nowrap;
}

.pending-bill-banner__close {
    position: absolute;
    top: 6px;
    right: 10px;
    border: 0;
    background: transparent;
    color: inherit;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    opacity: 0.7;
}

.pending-bill-banner--overdue {
    border-color: #fecaca;
    background: #fef2f2;
    color: #b91c1c;
}

.pending-bill-banner__link {
    flex-shrink: 0;
    padding: 6px 14px;
    border-radius: 8px;
    background: #d97706;
    color: #fff;
    text-decoration: none;
    font-weight: 600;
}

.pending-bill-banner--overdue .pending-bill-banner__link {
    background: #dc2626;
}

.pending-bill-banner__link:hover {
    color: #fff;
    opacity: 0.9;
}

/* Below open mobile drawer (1100+) so nav links and dropdown receive clicks */
.dashboard-sidebar-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1020;
    margin: 0;
    padding: 0;
    border: none;
    background: rgba(0, 0, 0, 0.45);
    cursor: pointer;
}

/* Keep the top bar (hamburger + logo) above the dimmer */
@media (max-width: 47.99em) {
    .dashboard-sidebar-backdrop {
        top: 3.5rem;
    }

    .dashboard_left {
        position: relative;
        z-index: 1100;
    }
}

.dashboard-mobile-menu-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.25rem;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #3f4254;
    cursor: pointer;
}

.dashboard-mobile-menu-btn:hover {
    background: rgba(15, 18, 33, 0.06);
    color: #0f1221;
}

@media (min-width: 48em) {
    .dashboard-mobile-menu-btn {
        display: none;
    }
}

.dashboard_left {
    position: relative;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 16px;
    /* On desktop this is the whole left column (logo + nav + footer), so the panel tint
       and the full-height divider belong here — not on .dashboard_nav, which is only
       part of the column. On mobile it collapses to a 3.5rem top bar. */
    background-color: #f8f9fb;
    border-bottom: 1px solid #e7e9ef;
    height: 3.5rem;
    text-rendering: geometricprecision;
}

@media (min-width: 48em) {
    .dashboard_left {
        position: sticky;
        height: 100vh;
        top: 0px;
        left: 0px;
        bottom: 0px;
        width: 100%;
        z-index: 9;
        overflow: visible;
        /* Full-height divider against the white page — replaces the mobile top-bar rule. */
        border-bottom: none;
        border-right: 1px solid #e7e9ef;
    }
}

.dashboard_menus_outer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1.5rem;
    padding: 0px 0px 0px 0.5rem;
    height: 100%;
}

@media (min-width: 48em) {
    .dashboard_menus_outer {
        justify-content: flex-start;
        flex-direction: column;
        padding: 0px;
    }
}

@media (min-width: 48em) {
    .dashboard_menus {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        padding: 1.5rem 1.5rem 0px;
        position: relative;
        z-index: 1100;
    }
}

.site_logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.dashboard_page.collapsed_menu .site_logo {
    flex-direction: column;
}

.site_logo a {
    box-sizing: border-box;
    position: relative;
    justify-self: left;
    line-height: 0;
}

.sidebar_edge_toggle {
    display: none;
}

@media (min-width: 48em) {
    .sidebar_edge_toggle {
        display: inline-flex;
        position: absolute;
        top: auto;
        bottom: 0.9rem;
        right: 0;
        transform: translateX(50%);
        z-index: 1200;
        width: 28px;
        height: 28px;
        padding: 0;
        margin: 0;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: -0.5px;
        line-height: 1;
        color: #3f4254;
        background: #fff;
        border: 1px solid #e7e9ef;
        border-radius: 50%;
        box-shadow: 0 1px 4px rgba(5, 27, 44, 0.12);
        cursor: pointer;
    }

    .sidebar_edge_toggle svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .sidebar_edge_toggle:hover {
        color: #4346ce;
        border-color: #c5c8f0;
        background: #fff;
    }

    .dashboard_page.collapsed_menu .sidebar_edge_toggle {
        bottom: 2.5rem;
    }

}

.dashboard_search {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    line-height: 0;
    color: rgb(192, 193, 245);
    padding: 0.5rem;
    border-radius: 0.25rem;
}

.dashboard_page.collapsed_menu .dashboard_search {
    display: none;
}

.dashboard_search svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    filter: none;
    color: inherit;
    opacity: 1;
}

.dashboard_nav {
    display: flex;
    height: calc(-3.5rem + 100vh);
    width: calc(265px - 2rem);
    /* Light panel — brand indigo is reserved for the active item, so it stands out.
       Tinted (not pure white) so it separates from the white page; the column border
       lives on .dashboard_left, which spans the full height. */
    background: transparent;
    box-shadow: none;
    flex-direction: column;
    align-items: flex-start;
    transition: margin-left 0.3s;
    z-index: 1030;
    position: fixed;
    top: 0.5rem;
    left: 0px;
    margin-left: -100%;
    padding: 0.5rem 0.5rem 1rem;
    overflow-y: auto;
}

@media (max-width: 47.99em) {
    .dashboard_nav.dashboard_nav--open {
        margin-left: 0;
        width: 100%;
        max-width: 100vw;
        z-index: 1101;
        /* The desktop panel is transparent (tint lives on .dashboard_left), but the
           mobile drawer floats over the page and needs its own opaque background. */
        background: #f8f9fb;
        box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);
    }
}

@media (min-width: 48em) {
    .dashboard_nav {
        width: auto;
        flex-direction: column;
        /* height:100% ki jagah flex:1 1 0 use kiya - "100%" ko flex-basis ki tarah apply
           karne ke baad browser ko shrink-calculation me content size ka reference mil
           jata tha, jiski wajah se shrink poora reliable nahi tha. flex-basis:0 (flex: 1 1 0)
           + min-height:0 standard/robust pattern h jisme ye div sirf jitni jagah bachi h
           (header - footer ke beech) utni hi leta h, aur apne "overflow-y: auto" se khud
           scroll karta h - footer (.sidebar_footer) ab kabhi overlap/chhup nahi hota chahe
           koi bhi submenu (Customer Support etc.) khula ho. */
        flex: 1 1;
        min-height: 0;
        max-height: 100%;
        margin-left: 0px;
        box-shadow: none;
        justify-content: flex-start;
        /* static tha pehle - jiski wajah se base rule ka z-index: 1030 inert ho jata tha
           (z-index sirf positioned elements pe kaam karta h), aur collapsed sidebar ka
           flyout submenu DOM-order ki wajah se main content ke piche chup jata tha.
           relative se layout same rehta h (koi top/left offset nahi), bas z-index active ho jata h. */
        position: relative;
        padding: 0px 0.5rem 60px 1.5rem;
        scrollbar-gutter: stable;
        scrollbar-width: thin;
        scrollbar-color: rgba(15, 18, 33, 0.2) transparent;
    }
}

@media (min-width: 48em) {
    .dashboard_page.collapsed_menu .dashboard_nav {
        padding: 0px 0.75rem;
        align-items: center;
        overflow: visible; /* flyout submenus (.sidebar_drop_menu--flyout) ko escape hone dena h */
        scrollbar-gutter: unset;
    }
}

/* Collapsed sidebar me normal expand/collapse chevron (up/down arrow) icons nahi dikhne
   chahiye - sirf icon + flyout submenu (hover pe) dikhna chahiye, chota sidebar me arrow
   ka koi matlab nahi (klik ki jagah hover se khulega). Ye chevrons hi "sc-jSMfEi gdvaUL"
   class ke sath render hote h (main icon ye class use nahi karta). */
.dashboard_page.collapsed_menu .app_drop_down > svg.sc-jSMfEi {
    display: none;
}

.dashboard_nav a,
.dashboard_nav .app_drop_down {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    justify-content: left;
    border-radius: 8px;
    gap: 0.625rem;
    padding: 0.5rem 0.75rem;
    margin-bottom: 2px;
    font-size: 0.875rem;
    font-weight: 500;
    color: #3f4254;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.dashboard_nav a svg,
.dashboard_nav .app_drop_down svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
}

/* These sidebar icons are white-filled .svg files loaded via <img>, so \`color\`/\`fill\`
   can't reach inside them — darken them so they're visible on the light panel.
   (Does not touch the logo: that lives in .site_logo, outside .dashboard_nav.) */
.dashboard_nav a img,
.dashboard_nav .app_drop_down img {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: brightness(0) opacity(0.72);
    color: inherit;
    opacity: 1;
}

.dashboard_nav a label,
.dashboard_nav .app_drop_down label {
    max-width: inherit;
    color: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}

.dashboard_nav label:hover {
    max-width: inherit;
    color: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}

.dashboard_nav a:hover,
.dashboard_nav .app_drop_down:hover {
    color: #0f1221;
    background-color: rgba(15, 18, 33, 0.045);
}

/* Active = soft tinted pill + indigo text (not a solid block) so it reads clean on white. */
.dashboard_nav a.active,
.dashboard_nav .app_drop_down.active {
    color: #4346ce;
    background-color: #eef0fd;
    font-weight: 600;
}

.dashboard_nav a.active:hover,
.dashboard_nav .app_drop_down.active:hover {
    color: #4346ce;
    background-color: #e6e9fc;
}

.sidebar_nav {
    display: block;
    width: 100%;
    border-top: 1px solid rgba(15, 18, 33, 0.08);
    margin: 20px 0px 0px 0px;
    padding-top: 8px;
}

/* Thin, unobtrusive scrollbar for the nav panel */
.dashboard_nav::-webkit-scrollbar {
    width: 6px;
}

.dashboard_nav::-webkit-scrollbar-track {
    background: transparent;
}

.dashboard_nav::-webkit-scrollbar-thumb {
    background: rgba(15, 18, 33, 0.16);
    border-radius: 3px;
}

.dashboard_nav::-webkit-scrollbar-thumb:hover {
    background: rgba(15, 18, 33, 0.28);
}

.sidebar_nav_collapsed {
    display: block;
    width: 100%;
    border-top: 1px solid rgb(48, 50, 147);
    background-color: #78b13f;
}

/* .sidebar_nav a img{} */
.sidebar_footer {
    height: auto;
    min-height: 3.5rem;
    display: flex;
    flex-shrink: 0; /* nav wale area me jitna hi scroll ho, footer apni jagah neeche fixed rahe, kabhi chota na ho */
    grid-column-end: -1;
    justify-content: flex-end;
    background: #f8f9fb;
    z-index: 1100;
}

@media (min-width: 48em) {
    .sidebar_footer {
        height: auto;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 0.5rem;
        padding: 12px 1.5rem;
    }
}

.sidebar_footer button svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: #3f4254;
}

.sidebar_footer button {
    cursor: pointer;
    border: 0px none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgba(255, 255, 255, 0);
    line-height: 1.125rem;
    gap: 0.5rem;
    color: rgb(67, 70, 206) !important;
    text-decoration: none !important;
}

.sidebar_footer button.expend_collapsed {
    display: none;
}

@media (min-width: 48em) {

    .sidebar_footer button.expend_collapsed,
    .sidebar_footer button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2.25rem;
        height: 2.25rem;
        padding: 0.5rem;
        color: #3f4254;
        background-color: transparent;
        border: none;
        border-radius: 0.25rem;
    }

    .sidebar_footer button.logout_btn:hover,
    .sidebar_footer button.expend_collapsed:hover {
        color: #4346ce;
        background-color: rgba(15, 18, 33, 0.05);
    }

    /* Don't leave a filled background after a mouse click — only show a focus ring
       for keyboard users (focus-visible), matching the now-light sidebar. */
    .sidebar_footer button.expend_collapsed:focus {
        outline: none;
        background-color: transparent;
    }

    .sidebar_footer button.expend_collapsed:focus-visible {
        outline: 2px solid rgba(67, 70, 206, 0.45);
        outline-offset: 1px;
    }
}

.dashboard_right {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
}

.dashboard_inner {
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.org-header-card {
    display: flex;
    flex-direction: column;
    gap: 1.1rem;
    padding: 1.15rem 1.35rem;
    background: #fff;
    /* Match the apps table card (ticket-list style): same border, radius and shadow */
    border: 1px solid #e9eaee;
    border-radius: 12px;
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
}

.org-header-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
}

.org-header-info {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    min-width: 0;
}

.org-header-label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8a90a2;
}

.org-header-name {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 700;
    color: rgb(5, 27, 44);
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.org-header-side {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    flex-shrink: 0;
}

.org-header-plan {
    padding: 0.25rem 0.7rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #4346ce;
    background: #eef0ff;
    border-radius: 999px;
    white-space: nowrap;
}

.org-header-edit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #6b7280;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.org-header-edit:hover {
    background: #eef0ff;
    color: #4346ce;
}

.org-header-stats {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 1.75rem;
}

.org-stat {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    min-width: 0;
}

.org-stat-value {
    font-size: 1.3rem;
    font-weight: 700;
    color: rgb(5, 27, 44);
    line-height: 1.1;
}

.org-stat-label {
    font-size: 0.74rem;
    color: #8a90a2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 62em) {
    .org-header-stats {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1.1rem;
    }
}

@media (max-width: 30em) {
    .org-header-stats {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

.dashboard_right_top {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
}

@media (min-width: 48em) {
    .dashboard_right_top {
        flex-direction: row;
        justify-content: space-between;
    }
}

.dashboard_heading h1 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}

.add_app {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 0.5rem;
    flex-grow: 0;
}

@media (min-width: 30em) {
    .add_app {
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
}

@media (min-width: 48em) {
    .add_app {
        width: auto;
        flex-wrap: wrap-reverse;
        justify-content: flex-end;
        align-items: center;
    }
}

@media (min-width: 30em) {
    .add_app a {
        width: auto;
    }
}

.add_app a {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: 100%;
    background-color: rgb(67, 70, 206);
    line-height: 1.125rem;
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
}

.add_app a svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
}

.add_app a img {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
}

/* Add-app bar buttons: shared size; pair with btn_theme_* for colors */
.add_app_btn,
.add_app_btn_secondary {
    width: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.add_app_btn svg,
.add_app_btn_secondary svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: inherit;
    opacity: 1;
}

.dashboard_app_table {
    /* padding: 0.5rem; */
    border-radius: 0.5rem;
    position: relative;
    /* margin-block: 10px; */
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    /* max-width: calc(-3rem + 81vw); */
}

.dashboard_app_table--list-records {
    gap: 0.5rem;
}

/* Subscription Records — filter card (separate from table card), Alembic-style accordion */
.list-page-filter-card {
    padding: 0;
    border-radius: 0.5rem;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.list-page-filter-accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 16px;
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
}

.list-page-filter-accordion-header:hover {
    background-color: rgba(0, 0, 0, 0.02);
}

.list-page-filter-accordion-title {
    font-size: 0.9375rem;
    font-weight: 500;
    color: #6c757d;
}

.list-page-filter-accordion-chevron {
    flex-shrink: 0;
    transition: transform 0.2s ease;
    color: #6c757d;
}

.list-page-filter-accordion-chevron--open {
    transform: rotate(180deg);
}

.list-page-filter-accordion-body {
    padding: 16px 16px;
}

.list-page-filter-accordion-body .list-page-filter-bar {
    margin-bottom: 0;
}

.search_app {
    display: flex;
    justify-content: space-between;
}

.search_app_dropdown {
    width: 200px;
}

/* Subscription Records — filter row: fields group + actions on one row when space allows (avoids huge wrap gap) */
.list-page-filter-bar {
    margin-bottom: 8px;
}

.list-page-filter-fields {
    margin: 0;
    padding: 0;
}

.list-page-filter-field {
    margin: 0;
    padding: 0;
}

.list-page-filter-field .form-control {
    margin-bottom: 0;
}

.list-page-filter-field .ns-daterange__trigger.form-control {
    display: flex;
    align-items: center;
    gap: 5px;
    padding-left: 14px;
}

.list-page-filter-field .ns-daterange__trigger-value {
    padding-left: 2px;
}

.list-page-tag-filter-group {
    flex-wrap: nowrap;
    align-items: stretch;
}

.list-page-tag-filter-key {
    flex: 1 1;
    min-width: 0;
}

.list-page-tag-filter-key .ns-select {
    width: 100%;
}

.list-page-tag-filter-key .ns-select__control {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.list-page-tag-filter-key .ns-select__control--is-focused {
    position: relative;
    z-index: 2;
}

.list-page-tag-filter-value {
    flex: 1 1;
    min-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
}

.list-page-tag-filter-value:focus {
    position: relative;
    z-index: 2;
}

.list-page-filter-actions {
    margin-left: auto;
}

.list-page-filter-actions .add_app {
    flex-wrap: nowrap;
    align-items: center;
}

.dashboard_table {
    overflow: visible;
    width: 100%;
}

.table_inner {
    border: 1px solid rgb(229, 232, 235);
    border-radius: 0.25rem;
    overflow-x: auto;
    overflow-y: visible;
    width: 100%;
    position: relative;
    /* required for sticky column layering */
}

/* Keep table header visible while vertical-scrolling rows inside table area. */
.table_inner.table_y_scroll table.table_outer thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background: rgb(246, 247, 248);
}

/* Compact table spacing when table-sm is applied */
table.table_outer.table-sm th,
table.table_outer.table-sm td {
    padding: 0.4rem;
}

table.table_outer {
    font-size: 14px;
    width: 100%;
    /* max-width: 800px; */
    border-collapse: separate;
    /* sticky columns work reliably */
    border-spacing: 0;
    box-shadow: none !important;
    table-layout: auto;
}

table.table_outer tr {
    height: 3.125rem;
}

table.table_outer th {
    padding: 0.75rem 0.5rem;
    line-height: 1.1875rem;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    background: rgb(246, 247, 248);
    border-bottom: 1px solid rgb(229, 232, 235);
    font-weight: bold;
    font-size: 13px;
}

table.table_outer tr>th:last-of-type {
    border-top-right-radius: 0.25rem;
}

table.table_outer tbody {
    border-collapse: collapse;
}

table.table_outer tbody tr {
    border-bottom: 1px solid rgb(229, 232, 235);
    position: relative;
}

table.table_outer tbody tr.support-ticket-row--clickable {
    cursor: pointer;
}

table.table_outer tbody tr.support-ticket-row--clickable:hover {
    background: rgb(246, 247, 248);
}

table.table_outer tbody tr:last-of-type {
    border-bottom: 0
}

table.table_outer td {
    padding: 0.5rem 0.5rem;
    vertical-align: middle;
    text-align: left;
    transition: 0.1s ease-in-out;
    text-overflow: ellipsis;
    font-size: 13px;
}

table.table_outer td:last-child {
    overflow: visible;
}

table.table_outer td a {
    display: inline-flex;
    align-items: center;
    column-gap: 0.25rem;
    color: #000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
}

table.table_outer td.plan span {
    font-size: 16px;
    height: 1.5625rem;
    padding: 0px 0.5rem;
    border-radius: 0.25rem;
    white-space: nowrap;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: rgb(40, 51, 62);
    background-color: rgb(229, 232, 235);
}

table.table_outer td svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    filter: none;
    color: inherit;
    opacity: 1;
    /* margin-right: 0.5rem; */
}

table.table_outer td button svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
}

table.table_outer td button {
    cursor: pointer;
    border: 0px none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgba(255, 255, 255, 0);
    line-height: 1.125rem;
    color: rgb(67, 70, 206);
}

/* ---------------------------------------------------------
   Pagination (Alembic-style, Bootstrap-compatible)
   Applies wherever we use Bootstrap \`.pagination\` markup.
   --------------------------------------------------------- */
.pagination {
    gap: 0.25rem;
}

.pagination .page-link {
    min-width: 2rem;
    height: 2rem;
    padding: 0 0.6rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 0.8125rem;
    /* ~13px */
    border-radius: 0.5rem;
    border: 1px solid rgb(229, 232, 235);
    background: rgb(255, 255, 255);
    color: rgb(67, 70, 206);
    box-shadow: rgba(5, 27, 44, 0.08) 0px 1px 2px;
    transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease, box-shadow 120ms ease;
}

.pagination .page-link:hover {
    background: rgb(236, 236, 252);
    border-color: rgb(192, 193, 245);
    color: rgb(58, 61, 179);
}

.pagination .page-link:focus {
    box-shadow: 0 0 0 0.2rem rgba(67, 70, 206, 0.18);
}

.pagination .page-item.disabled .page-link,
.pagination .page-link:disabled {
    color: rgb(162, 173, 185);
    background: rgb(246, 247, 248);
    border-color: rgb(229, 232, 235);
    box-shadow: none;
}

.pagination .page-item.active .page-link {
    background: rgb(67, 70, 206);
    border-color: rgb(58, 61, 179);
    color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
}

.pagination.pagination-sm .page-link {
    min-width: 1.75rem;
    height: 1.75rem;
    border-radius: 0.45rem;
    box-shadow: none;
    font-size: 0.75rem;
    /* 12px */
}

/* Pagination bar alignment (Showing... + pager stay one line) */
.pagination_align {
    flex-wrap: nowrap;
    gap: 0.75rem;
}

.pagination_align>* {
    min-width: 0;
}

.pagination_align .pagination {
    flex-wrap: nowrap;
}

.pagination_align .text-muted,
.pagination_showing {
    white-space: nowrap;
    font-size: 12px;
}

.pagination_align .text-muted b,
.pagination_showing b {
    font-size: inherit;
    font-weight: 600;
}

/* Subscription table specific column widths */
table.table_outer td.col-action {
    width: 40px;
    max-width: 40px;
    background: #fff;
}

/* Text buttons in action column (e.g. API Keys "Disable") — not kebab-only width */
table.table_outer th.col-action.col-action-wide,
table.table_outer td.col-action.col-action-wide {
    width: auto;
    min-width: 7.5rem;
    max-width: none;
}

.table_inner:not(.at-scroll-end) table.table_outer td.col-action.col-action-wide {
    min-width: 7.5rem;
    width: auto;
    max-width: none;
}

/* Sticky Action column (OneSignal-like) */
.table_inner:not(.at-scroll-end) table.table_outer th.col-action,
.table_inner:not(.at-scroll-end) table.table_outer td.col-action {
    position: sticky;
    right: 0;
}

/* Make sticky column look like a single layered strip */
.table_inner:not(.at-scroll-end) table.table_outer th.col-action,
.table_inner:not(.at-scroll-end) table.table_outer td.col-action {
    border-left: 1px solid rgb(229, 232, 235);
    box-shadow: -6px 0 10px rgba(16, 24, 40, 0.08);
    background-clip: padding-box;
}

.table_inner:not(.at-scroll-end) table.table_outer th.col-action {
    z-index: 4;
    /* above body cells */
    background: rgb(246, 247, 248);
    /* match header background */
}

.table_inner:not(.at-scroll-end) table.table_outer td.col-action {
    z-index: 3;
    min-width: 40px;
    padding-right: 6px;
}

/* When sticky is disabled at far-right, make it look normal (no hint it was sticky) */
.table_inner.at-scroll-end table.table_outer th.col-action {
    /* position: unset; */
}

.table_inner.at-scroll-end table.table_outer td.col-action {
    position: static;
    right: auto;
    border-left: 0;
    box-shadow: none;
    background: inherit;
}

/* Kebab cell is always centred in its column (same as Subscription Records) */
table.table_outer th.col-action:not(.col-action-wide),
table.table_outer td.col-action:not(.col-action-wide) {
    text-align: center !important;
}

/* Ensure action (kebab) button is always visible */
table.table_outer td.col-action .dropdown-trigger-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: rgb(67, 70, 206);
}

table.table_outer td.col-action .dropdown-trigger-btn svg {
    display: block;
}

table.table_outer td.col-subscription-id,
table.table_outer td.col-notify-sphere-id {
    width: 140px;
    /* max-width: 140px; */
}

table.table_outer td.col-device-name {
    width: 120px;
    /* max-width: 120px; */
}

table.table_outer td.col-android-version {
    width: 100px;
    /* max-width: 100px; */
}

table.table_outer td.col-token {
    width: 180px;
    /* max-width: 180px; */
}

table.table_outer td.col-latitude,
table.table_outer td.col-longitude {
    width: 90px;
    /* max-width: 90px; */
}

table.table_outer td.col-status {
    width: 70px;
    /* max-width: 70px; */
}

table.table_outer td span {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.dashboardsvg {
    min-width: 16px;
    width: 25px !important;
    height: 20px !important;
    filter: none;
    color: inherit;
    opacity: 1;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 24px;
}

.dropdown-menu1 {
    position: fixed;
    background-color: white;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    width: 180px;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    right: 10px
}

.dropdown-menu1 button {
    display: block;
    width: 100% !important;
    padding: 10px;
    text-align: left;
    background: none;
    border: none;
    justify-content: flex-start !important;
    cursor: pointer;
    color: #000 !important;
    white-space: nowrap;
}

.dropdown-menu1 .delete-class {
    color: red !important;
    border-top: 1px solid lightgray;
}


.dropdown-menu1 button:hover {
    background-color: #f0f0f0;
}

.dropdown-menu2 {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 10000;
    width: 200px;
}

.dropdown-menu2 button {
    display: block;
    width: 100% !important;
    padding: 10px;
    text-align: left;
    background: none;
    border: none;
    justify-content: flex-start !important;
    cursor: pointer;
    color: #000 !important;
}

.dropdown-menu2 .delete-class {
    color: red !important;
    border-top: 1px solid lightgray;
}


.dropdown-menu2 button:hover {
    background-color: #f0f0f0;
}

.dropdown-menu-user {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1;
    width: 250px;
}

.dropdown-menu-user button {
    display: block;
    width: 100% !important;
    padding: 10px;
    text-align: left;
    background: none;
    border: none;
    justify-content: flex-start !important;
    cursor: pointer;
    color: #000 !important;
}

.dropdown-menu-user .delete-class {
    color: red !important;
    border-top: 1px solid lightgray;
}


.dropdown-menu-user button:hover {
    background-color: #f0f0f0;
}

.dropdown-menu-subscription {
    position: absolute;
    background-color: white;
    border: 1px solid rgb(229, 232, 235);
    border-radius: 0.375rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 10000;
    width: 225px;
    padding: 0.2rem 0.2rem;
    display: flex;
    flex-direction: column;
}

.dropdown-menu-subscription button {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100% !important;
    box-sizing: border-box; /* width:100% + left/right padding ko ek sath fit kare, warna button
                               container se thoda bahar nikal jata h aur hover-highlight sirf
                               right side pe flush/clipped dikhta h (left side theek rehta h) */
    padding: 0.75rem 0.5rem;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    color: #051b2c !important;
    font-size: 14px;
    font-weight: 400;
    transition: background-color 0.15s ease;
    white-space: nowrap;
}

/* Match icon size/weight across Users + Subscriptions row menus (react-icons render as SVG). */
.dropdown-menu-subscription button>svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    min-width: 20px;
}

.dropdown-menu-subscription button:hover:not(:disabled) {
    background-color: #693cac1e;
}

.dropdown-menu-subscription button:disabled {
    pointer-events: auto;
}

.dropdown-menu-subscription .delete-class {
    color: rgb(229, 75, 77) !important;
    border-top: 1px solid rgb(229, 232, 235);
    margin-top: 0.25rem;
    padding-top: 0.75rem;
}

.dropdown-menu-subscription .delete-class:hover {
    background-color: #693cac1e;
}





.dropdown-menu3 {
    position: absolute;
    background-color: white;
    /* border: 1px solid #ccc; */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1;
    width: 80px;
}

.dropdown-menu3 button {
    display: block;
    height: 37px;
    width: 100% !important;
    padding: 10px;
    text-align: left;
    background: none;
    border: none;
    justify-content: flex-start !important;
    cursor: pointer;
    color: #000 !important;
}

.dropdown-menu3 .delete-class {
    color: #e54b4d !important;
    /* border-top: 1px solid lightgray; */
}


.dropdown-menu3 button:hover {
    background-color: #f0f0f0;
}



.tabButton {
    width: 36px;
    padding: 0.4rem 0.25rem !important;
}

.tabButton:hover {
    background-color: rgb(236, 250, 255);
}









/* Increase the width and height of the Selectize dropdown */
.selectize-dropdown {
    font-size: 30px;
    /* Adjust font size */
    max-height: 300px;
    /* Adjust dropdown height */
    width: 400px;
    /* Adjust dropdown width */
    overflow-y: auto;
    /* Enable scrolling if dropdown exceeds max-height */
}

.selectize-input {
    font-size: 30px;
    /* Adjust input size */
    height: 40px;
    /* Adjust height of the input */
}

.selectize-input input {
    height: 100%;
    /* Ensure input takes up the full height */
    padding: 40px;
    /* Add padding to increase size */
}

/* Change the background and text color of the highlighted option */
.selectize-dropdown .active {
    background-color: #4c6faf;
    /* Change this to your desired highlight color */
    color: white;
    /* Change text color */
}

/* Change the background color of hovered options (when the mouse is over an option) */
.selectize-dropdown .option:hover {
    background-color: #667bb438;
    /* Change this to your desired hover color */
    color: black;
    /*  Change text color */
}















.dashboard_dropdown {
    position: relative;
    z-index: 1200;
}

.dropdown_menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    float: left;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 16px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, .15);
    border-radius: 4px;
    box-shadow: 0 6px 12px #0000002d;
    background-clip: padding-box;
    font-size: 0.875rem;
    margin: 0.4rem 0px 0px;
    padding: 0;
    border: 1px solid rgba(15, 18, 33, 0.10);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px -2px rgba(5, 27, 44, 0.08), 0 12px 32px -6px rgba(5, 27, 44, 0.22);
}

.dashboard_dropdown.show .dropdown_menu {
    display: block;
}

.dashboard_dropdown .dropdown_menu .nav-tabs {
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    width: 18rem;
    border-bottom: 1px solid rgba(15, 18, 33, 0.09);
    display: flex;
}

/* App/Org tabs — desktop had no active indicator at all; give them a proper underline. */
.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link {
    padding: 0.75rem 0;
    font-size: 0.85rem;
    font-weight: 500;
    color: #6b7280;
    transition: color 0.15s ease;
}

.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link:hover {
    color: rgb(5, 27, 44);
}

.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link.active {
    color: rgb(67, 70, 206);
    font-weight: 600;
}

.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link.active::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    border-radius: 2px 2px 0 0;
    background: rgb(67, 70, 206);
}

.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    background-color: transparent;
    border-radius: 0px;
    border: none;
    padding: 0px;
    color: rgb(5, 27, 44);
    max-width: 50%;
}

.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    background-color: transparent;
    border-radius: 0px;
    border: none;
    padding: 1rem 0px;
    color: rgb(5, 27, 44);
}

@media (min-width: 48em) {
    .dashboard_dropdown {
        display: flex;
        position: relative;
    }
}

/* App/Org dropdown: desktop = top bar; mobile = duplicate inside slide-out \`dashboard_nav\` */
@media (max-width: 47.99em) {
    .dashboard-app-dropdown--desktop {
        display: none !important;
    }
}

@media (min-width: 48em) {
    .dashboard-app-dropdown--mobile {
        display: none !important;
    }
}

@media (max-width: 47.99em) {
    .dashboard-app-dropdown--mobile {
        width: 100%;
        max-width: 100%;
        padding: 0 0.5rem 0.75rem;
        margin: 0 0 0.75rem;
        border-bottom: 1px solid rgba(255, 255, 255, 0.09);
        flex-shrink: 0;
        align-self: stretch;
    }

    .dashboard-app-dropdown--mobile .dropdown_menu {
        left: 0;
        right: auto;
        width: min(100%, 20rem);
        max-width: calc(100vw - 2rem);
        background-color: #fff;
        color: rgb(5, 27, 44);
    }

    .dashboard-app-dropdown--mobile .dropdown_menu .nav-tabs {
        width: 100%;
        max-width: 100%;
    }

    .dashboard-app-dropdown--mobile .dropdown_menu .nav-tabs button.nav-link {
        color: rgb(5, 27, 44) !important;
    }

    .dashboard-app-dropdown--mobile .dropdown_menu .nav-tabs button.nav-link.active {
        color: rgb(67, 70, 206) !important;
        font-weight: 600;
    }
}

.dropdown_outer {
    width: 100%;
}

.dashboard_dropdown button {
    width: 100%;
    background-color: #f6f7fb;
    border: 1px solid #e4e6ef;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #1f2433;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.dashboard_dropdown button:hover {
    background-color: #eef0f6;
    border-color: #d7dae8;
    /* Bootstrap's .btn-primary:hover forces white text — keep it dark/readable. */
    color: #1f2433;
}

.dashboard_dropdown.show button {
    background-color: #eef0fd;
    border-color: #b9bdf2;
    color: #1f2433;
}

.dashboard_dropdown span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 0.5rem;
}

.dashboard_dropdown svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
    margin-left: auto;
}

.dashboard_dropdown li.nav-item button.active::after {
    content: "";
    position: absolute;
    background-color: rgb(129, 131, 236);
    width: 0.25rem;
    left: 0px;
    height: 100%;
}

@media (min-width: 48em) {
    .dashboard_dropdown li.nav-item button.active::after {
        left: auto;
        bottom: 0px;
        height: 0.25rem;
        width: 100%;
    }
}

.sidebar_footer button.logout_btn {
    display: inline-flex;
    width: auto;
    flex-shrink: 0;
    color: #3f4254 !important;
    font-size: 13px;
}

.sidebar_user {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex: 1 1;
}
.sidebar_user_avatar {
    width: 36px;
    height: 36px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.sidebar_user_meta {
    min-width: 0;
}
.sidebar_user_name {
    font-size: 13px;
    font-weight: 600;
    color: #212529;
    line-height: 1.25;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.sidebar_user_email {
    font-size: 11px;
    color: #6c757d;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (min-width: 48em) {
    .dashboard_page.collapsed_menu .sidebar_footer {
        padding: 0 0.5rem 1rem;
        justify-content: center;
        flex-direction: column;
        gap: 0.35rem;
    }
    .dashboard_page.collapsed_menu .sidebar_user {
        justify-content: center;
        flex: 0 1;
    }
}






/* New App */


.sub_heading {
    margin-top: 1rem;
}

.app_plateform {
    padding: 1.5rem;
    border-radius: 0.5rem;
    position: relative;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
}

@media (min-width: 48em) {
    .app_plateform_field {
        width: 29.25rem;
    }
}

.app_input {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    margin-top: 5px;
}

.app_input input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
}

.app_plateform_field .search_app_dropdown {
    width: 100%;
}

.next_button button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(67, 70, 206);
    line-height: 1.125rem;
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
}

.select_app {
    margin-top: 5px;
}

.select_app ul {
    padding-left: 0;
    list-style: none;
    --controlWidth: calc(8.75rem + 0.5rem);
    display: grid;
    gap: 1.5rem;
}

@media (min-width: 48em) {
    .select_app ul {
        grid-template-columns: repeat(auto-fill, var(--controlWidth));
    }
}

.select_app ul li {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 0;
    cursor: pointer;
}

.select_inner {
    --button-radius: 4px;
    transition: 0.1s ease-in;
    width: 100%;
    height: 8.75rem;
    cursor: pointer;
    padding: 0.5rem;
    color: rgb(66, 77, 87);
    background-color: rgb(255, 255, 255);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(203, 209, 215);
    border-radius: var(--button-radius);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.select_app ul li input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 0;
    cursor: pointer;
}

.select_app ul li input:checked+.select_inner {
    border-color: rgb(67, 70, 206);
    background-color: rgb(236, 236, 252);
}








/* configuration Ap */

.app_setting_steps_outer {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

.app_setting_steps_inner {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.app_setting_steps_form_outer {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    gap: 1.5rem;
    width: 100%;
    max-width: 100%;
}

.app_setting_step_1 .progress_bar {
    width: 25%;
}

.app_setting_step_2 .progress_bar {
    width: 50%;
}

.app_setting_step_3 .progress_bar {
    width: 75%;
}

.app_setting_step_1 .step_list.filled .step_count {
    background: rgb(59, 182, 116);
}

.app_setting_step_2 .step_list.filled .step_count {
    background: rgb(59, 182, 116);
}

.app_setting_step_3 .step_list.filled .step_count {
    background: rgb(59, 182, 116);
}

@media (min-width: 62em) {
    .app_setting_steps_form_outer {
        flex-direction: row;
    }
}

.app_setting_steps_left {
    padding: 1.5rem;
    border-radius: 0.5rem;
    position: relative;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
    margin-bottom: 1.5rem;
    width: 100%;
    flex: 1 1;
    min-width: 0;
}

@media (min-width: 48em) {
    .app_setting_steps_left {
        max-width: 63rem;
    }
}

.app_setting_steps_form_outer .steps_right {
    flex-shrink: 0;
    width: auto;
    min-width: 180px;
}

/* Dashboard right panel - prevent overflow */
.dashboard_right {
    width: 100%;
    max-width: 100%;
    /* overflow-x: hidden; */
}

.dashboard_right .dashboard_inner {
    width: 100%;
    max-width: 100%;
}

.configuration_page {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

/* .inner_heading h2 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 2.25rem;
    letter-spacing: -0.00875rem;
}
.steps_sub_heading {
    margin-top: 0.25rem;
    margin-bottom: 1rem;
}
.name_field {
    display: flex;
    flex-direction: column;
    -webkit-box-pack: start;
    justify-content: start;
    gap: 0.5rem;
    width: 100%;
	margin-bottom: 1rem;
}
@media (min-width: 48em) {
    .name_field {
        flex-direction: row;
        width: 100%;
    }
}
.name_field > * {
    flex: 1 1 0%;
}
.name_field label{
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
}
.name_field label::after {
    content: "*";
    font-size: 125%;
    color: rgb(229, 75, 77);
    margin-left: 3px;
}
.input_field {
    width: 100%;
    position: relative;
    display: flex;
}
.input_field input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
}
.validation_error {
    margin-top: 0.25rem;
}
.validation_error span {
    position: relative;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 1rem;
    color: rgb(229, 75, 77);
}
.validation_error img {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
    min-width: 1rem;
	left: 0px;
    margin-right: 0.5rem;
    position: relative;
    top: 0.25rem;
	color: rgb(229, 75, 77);
}
.category_field {
    margin-bottom: 1rem;
}
.category_field label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}
.select_field {
    max-width: 262px;
}
.select_field select {
    width: 100%;
    cursor: pointer;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(203, 209, 215);
    color: rgb(5, 27, 44) !important;
}
.select_section_label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}
.select_apply_section {
    margin-bottom: 1rem;
}
.select_section_label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}
.select_section_label label{margin-bottom: 5px;}
.select_boxes {
    display: flex;
    flex-direction: column;
}
.select_box {
    min-height: 2.25rem;
    position: relative;
}
.select_box input {
    width: 1rem;
    height: 1rem;
    left: 0.25rem;
    top: 0.25rem;
    appearance: none;
    opacity: 0.0001;
    position: absolute;
    margin: 0px !important;
	z-index: 1;
	cursor: pointer;
}
.select_box label {
    display: flex;
    padding-left: 1.5rem;
    position: relative;
    margin-bottom: 0px;
    font-size: 1rem;

}
.select_box label::before {
    width: 1rem;
    height: 1rem;
    border-radius: 0.125rem;
    top: 0.25rem;
    left: 0px;
    position: absolute;
    border: 1px solid rgb(203, 209, 215);
    display: inline-block;
    content: " ";
    transition: border-color 0.2s ease-in-out;
    background-color: rgb(255, 255, 255);
}
.select_box label:after{
	content: '';
	position: absolute;
	left: 0;
	top: 0.25rem;
	display: inline-block;
	transform: rotate(45deg);
	height: 11px;
	width: 6px;
	margin-left: 0.3em;
	border-bottom: 2px solid #78b13f;
	border-right: 2px solid #78b13f;
	opacity: 0;
	visibility: hidden;
	transition: all .3s;
}
.select_box input:checked ~ .select_box label:after{
	opacity: 1;
	visibility: visible;
}
.phone_section {
    margin-bottom: 1rem;
}
.phone_section label {
    font-weight: normal;
    color: rgb(66, 77, 87);
    font-size: 1rem;
    margin-bottom: 5px;
}
.phone_input {
    max-width: 262px;
}
.phone_input input {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    outline: none 0px;
    width: 100%;
    color: rgb(5, 27, 44);
    border-radius: 0.25rem;
    border: 1px solid rgb(203, 209, 215);
    background: rgb(255, 255, 255);
}
button.form_btn {
    cursor: pointer;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(67, 70, 206);
    line-height: 1.125rem;
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
}
.steps_right {
    width: max-content;
}
.step_right_heading {
    margin-bottom: 0.5rem;
}
.step_progress {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 16px;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(162, 173, 185);
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
    height: 0.75rem;
    border-radius: 1rem;
}
.progress_bar {
    width: 0%;
    display: flex;
    background-color: rgb(59, 182, 116);
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
}
.step_listing {
    display: flex;
    flex-direction: column;
    margin-top: 1.5rem;
}
.step_list {
    display: flex;
    align-items: flex-start;
}
.step_count {
    display: flex;
    flex-direction: column;
    margin-right: 0.5rem;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: rgb(255, 255, 255);
    background-color: rgb(116, 128, 139);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    line-height: 0;
    padding: 0px 0.25rem;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    font-size: 12px;
}
.step_seperator {
    background-color: rgb(185, 194, 202);
    width: 1px;
    height: 0.875rem;
    margin-top: 0.375rem;
    margin-bottom: 0.25rem;
    margin-left: 0.4375rem;
}
.step_list label {
    font-weight: normal;
    color: rgb(5, 27, 44);
    font-size: 1rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    line-height: 1;
    padding-bottom: 0.25rem;
    max-width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
}
.step_list.active label {
    font-weight: bold;
} */

/* Step_1 */
/* .step_1 .name_field {
	display: block;
	max-width: 400px;
}
.step_1 .select_field {
    max-width: 400px;
}
.step_1 .progress_bar {
    width: 33%;
}
.step_2 .progress_bar {
    width: 66%;
}
.step_1 .step_list.filled .step_count {
    background: rgb(59, 182, 116);
}
.step_2 .step_list.filled .step_count {
    background: rgb(59, 182, 116);
}
*/

.upload_file label {
    width: 100%;
}

.configuration_page .steps_form {
    width: 66%;
}

.configuration_page .select_field {
    max-width: 100%
}

.file_type {
    width: 100%;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    -webkit-box-pack: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(203, 209, 215);
    color: rgb(5, 27, 44) !important;
}

.configuration_page .select_apply_section {
    margin-top: 40px
}

.configuration_page .go_back {
    background: transparent;
    color: #000 !important;
    border: 0;
}





.retrieve_pera {
    display: flex;
    align-items: center;
}

.retrieve_pera a {
    display: inline-flex;
    align-items: center;
    column-gap: 0.25rem;
    color: rgb(67, 70, 206);
    overflow-wrap: anywhere;
}

.need_help {
    background: rgb(246, 247, 248);
    border: 1px solid rgb(229, 232, 235);
    border-radius: 0.5rem;
    padding: 1rem;
    gap: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 20px;
}

.need_help button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: 100%;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(192, 193, 245);
    color: rgb(67, 70, 206) !important;
}

@media (min-width: 30em) {
    .need_help button {
        width: auto;
    }
}

.need_help button svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
}

.need_help button span {
    margin-left: 0.5rem;
}




/* Select SDK */
.sdk_outer {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: 1fr;
}

.sdk_outer h2 {
    color: rgb(5, 27, 44);
    font-size: 1.375rem;
    font-weight: 500;
    margin-top: 0px;
    margin-bottom: 0.5rem;
}

.sdk_outer code {
    padding: 2px 4px;
    font-size: 90%;
    color: inherit;
    background-color: #b3b3b31a;
    word-break: break-all;
    white-space: normal;
    border-radius: 2px;
}

.sdk_outer button {
    cursor: pointer;
    border: 0px none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(255, 255, 255);
    line-height: 2rem;
    color: rgb(116, 128, 139) !important;
}

.sdk_outer svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
}

.check_subscribe button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(192, 193, 245);
    color: rgb(67, 70, 206) !important;
}

.check_subscribe button span {
    margin-left: 0.5rem;
}

.sidebar_dropdown_link {
    color: rgb(5, 27, 44);
}

.sidebar_dropdown_link:hover {
    color: rgb(67, 70, 206);
}

/* App/Org picker: links sit in a white .dropdown_menu but inherit .dashboard_nav a (lavender) — force readable text */
.dashboard_nav .dashboard_dropdown .dropdown_menu a.sidebar_dropdown_link,
.dashboard_nav .dashboard_dropdown .dropdown_menu a {
    color: rgb(5, 27, 44) !important;
}

.dashboard_nav .dashboard_dropdown .dropdown_menu a.sidebar_dropdown_link:hover,
.dashboard_nav .dashboard_dropdown .dropdown_menu a:hover {
    color: rgb(67, 70, 206) !important;
    background-color: rgba(67, 70, 206, 0.07);
    border-radius: 6px;
}

.dashboard_nav .dashboard_dropdown .dropdown_menu .tab-content ul li {
    padding: 0.15rem 0;
}

.dashboard_nav .dashboard_dropdown .dropdown_menu svg {
    color: rgb(67, 70, 206);
    opacity: 1;
}


.sidebar_footer button.expend_collapsed {
    transition: all .4s;
}


.dashboard_nav .nav_dropdown {
    position: relative; /* collapsed state ke flyout submenu ke liye anchor */
    color: #3f4254;
    width: 100%;
    display: flex;
    flex-direction: column;
}

/* Collapsed sidebar me submenu inline expand hone ki jagah icon ke right side flyout ki tarah khulta h */
.dashboard_nav .sidebar_drop_menu.sidebar_drop_menu--flyout {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 0;
    width: 200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    padding: 6px 0;
    z-index: 1040;
}
.dashboard_nav .sidebar_drop_menu.sidebar_drop_menu--flyout ul {
    margin: 0;
    border-left: none;
    padding-left: 0;
}
.dashboard_nav .sidebar_drop_menu.sidebar_drop_menu--flyout ul li a {
    padding-left: 0.9rem;
}

/* Sub-menu: same indent and dot marker for every parent (Messages, Audience, Setting, Delivery, Support) */
.dashboard_nav .sidebar_drop_menu {
    width: 100%;
}

.dashboard_nav .sidebar_drop_menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.dashboard_nav .sidebar_drop_menu ul li {
    list-style: none;
}

/* Sub-items sit under a subtle guide line instead of bullet dots (dots read as dated). */
.dashboard_nav .sidebar_drop_menu ul {
    margin: 2px 0 6px 1.4rem;
    border-left: 1px solid rgba(15, 18, 33, 0.10);
    padding-left: 0.35rem;
}

.dashboard_nav .sidebar_drop_menu ul li a {
    padding-left: 0.75rem;
    font-size: 0.82rem;
    font-weight: 400;
    color: #6b7280;
}

.dashboard_nav .sidebar_drop_menu ul li a::before {
    display: none;
}

.dashboard_nav .sidebar_drop_menu ul li a.active {
    color: #4346ce;
    background-color: #eef0fd;
    font-weight: 600;
}

.dashboard_nav .app_drop_down label {
    flex: 1 1 auto;
    margin-right: 0;
}

.dashboard_nav .app_drop_down > svg:last-child {
    margin-left: auto;
    flex-shrink: 0;
}










/* platform  */


.plateform_section {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.plateform_section h2 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 2rem;
    letter-spacing: 0px;
}

.plateform_cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding-block: 10px;
}

@media (min-width: 48em) {
    .plateform_cards {
        grid-template-columns: 1fr 1fr;
    }
}

.plateform_card {
    border-radius: 0.5rem;
    position: relative;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
    border: none;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    background: #fff;
}

.card_top {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    column-gap: 1.5rem;
    padding-bottom: 1.5rem;
}

.card_top_left {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    row-gap: 0.75rem;
}

.card_top_inner {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
}

@media (min-width: 30em) {
    .card_top_inner {
        align-items: center;
        flex-direction: row;
        column-gap: 0.75rem;
    }
}

.card_top_inner h3 {
    margin: 0px;
    color: rgb(5, 27, 44);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.75rem;
    letter-spacing: 0.00875rem;
}

.active_inactive {
    display: flex;
    flex-flow: row;
    gap: 0.75rem;
}

.active_inactive span {
    height: 1.5625rem;
    padding: 0px 0.5rem;
    border-radius: 0.25rem;
    white-space: nowrap;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: rgb(38, 119, 76);
    background-color: rgb(231, 246, 238);
    margin: 0px;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.125rem;
    letter-spacing: 0.00875rem;
}

.card_top_right {
    display: flex;
    flex-direction: column;
    justify-content: start;
}

.card_top_right svg {
    min-width: 48px;
    width: 48px;
    height: 48px;
    filter: none;
    color: inherit;
    opacity: 1;
}

.card_footer {
    display: flex;
    flex-flow: column wrap;
    row-gap: 1rem;
}

@media (min-width: 30em) {
    .card_footer {
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
    }
}

.card_setting {
    display: flex;
    flex-flow: column wrap;
    row-gap: 0.75rem;
    align-content: flex-start;
}

@media (min-width: 30em) {
    .card_setting {
        flex-direction: row;
        column-gap: 0.5rem;
    }
}

.card_setting a {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    width: auto;
    background-color: rgb(255, 255, 255);
    line-height: 1.125rem;
    border: 1px solid rgb(192, 193, 245);
    color: rgb(67, 70, 206) !important;
    transition: all .3s;
}

.inactive_plateform .card_setting a {
    background-color: rgb(67, 70, 206);
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
    transition: all .3s;
}

.card_setting a svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
    filter: none;
    color: inherit;
    opacity: 1;
}

.card_setting a span {
    margin-left: 0.5rem;
}

.card_setting a:hover,
.card_setting a:focus {
    background-color: rgb(236, 236, 252);
    border-color: rgb(67, 70, 206);
    color: rgb(67, 70, 206) !important;
}

.inactive_plateform .card_setting a:hover,
.inactive_plateform .card_setting a:focus {
    background-color: rgb(58, 61, 179);
    border-color: rgb(58, 61, 179);
    color: rgb(255, 255, 255) !important;
}


.log-img,
.ns-app-logo--collapsed {
    max-width: 36px !important;
    width: 36px !important;
    height: auto;
    object-fit: contain;
}

.ns-app-logo {
    height: 38px;
    width: auto;
    max-width: 160px;
    display: block;
    object-fit: contain;
}

.loader-div {
    background-color: rgb(220 220 220) !important;
    border: 1px solid lightgray !important;
    width: 214px !important;
}

.loader-img {
    width: fit-content !important;
    height: inherit !important;
}









/* CustomModal.css */
.custom-modal-size .modal-dialog {
    max-width: 580px;
    /* Set the width */
}

.custom-modal-size .modal-content {
    height: 666px;
    /* Set the total height of the modal */
    display: flex;
    flex-direction: column;
}

.custom-modal-size .modal-body {
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    scrollbar-width: thin;
    padding: 1.25rem 0.75rem 1.25rem 1.25rem;
}

.custom-modal-size .modal-footer {
    height: 80px;
    border-top: 1px solid #dee2e6;
}

/* Create Ticket modal: fixed header/footer, scrollable body */
.create-ticket-modal .modal-dialog {
    max-height: calc(100vh - 2rem);
    margin: 1rem auto;
    display: flex;
    flex-direction: column;
}

.create-ticket-modal .modal-content {
    max-height: calc(100vh - 2rem);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.create-ticket-modal .modal-header {
    flex-shrink: 0;
}

.create-ticket-modal-form {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.create-ticket-modal .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.create-ticket-modal .modal-footer {
    flex-shrink: 0;
}

/* History modal: scroll only on inner body, not whole modal */
.history-modal-no-scroll .modal-content {
    overflow: visible;
}

.history-modal-no-scroll .modal-body {
    overflow: hidden;
    padding: 1rem;
    /* max-height: 55vh; */
    display: flex;
    flex-direction: column;
}

.history-modal-body-inner {
    overflow: auto;
    flex: 1 1;
    min-height: 0;
}

/* SkeletonLoader.css */
.skeleton-table {
    width: 100%;
    border-collapse: collapse;
}

.skeleton-table th,
.skeleton-table td {
    padding: 10px;
    /* border: 1px solid #e0e0e0; */
}

.skeleton-cell {
    width: 100%;
    height: 20px;
    background-color: #e0e0e0;
    border-radius: 4px;
    animation: shimmer 1.5s infinite linear;
}

@keyframes shimmer {
    0% {
        background-position: -100px 0;
    }

    100% {
        background-position: 100px 0;
    }
}



/* Button Loader */
.btn-loader {
    width: 18px;
    height: 18px;
    border: 2px solid #ffffff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    animation: btn-spin 1s linear infinite;
}

@keyframes btn-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

button.form_btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* SSL Domain Check */
.modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal_content {
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    max-width: 480px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
}

.modal_content.modal_large {
    max-width: 800px;
}

.modal_content h3 {
    margin-top: 0;
}

.form_group {
    margin-bottom: 16px;
}

.form_group label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
}

.form_group .form_control {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
}

.modal_actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 20px;
}

.add_app_link_btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
}

.add_app_link_btn:hover {
    background: #1d4ed8;
}

.btn_sm {
    padding: 4px 10px;
    font-size: 12px;
    margin-right: 6px;
    border-radius: 4px;
    border: 1px solid #d1d5db;
    background: #f9fafb;
    cursor: pointer;
}

.btn_sm:hover {
    background: #e5e7eb;
}

.btn_danger {
    color: #dc2626;
    border-color: #fca5a5;
    background: #fef2f2;
}

.btn_danger:hover {
    background: #fee2e2;
}

.btn_primary {
    background: #2563eb;
    color: #fff;
    border: none;
}

.btn_primary:hover {
    background: #1d4ed8;
}

.btn_primary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* ---- Common theme buttons (reuse in add_app, modals, anywhere) ---- */
.btn_theme_primary {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    line-height: 1.125rem;
    background-color: rgb(67, 70, 206);
    border: 1px solid rgb(58, 61, 179);
    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;
    color: rgb(255, 255, 255) !important;
}

.btn_theme_primary:hover {
    background-color: rgb(58, 61, 179);
}

.btn_theme_primary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.btn_theme_secondary {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(209, 213, 219);
    color: rgb(55, 65, 81);
    line-height: 1.125rem;
}

.btn_theme_secondary:hover {
    background-color: rgb(249, 250, 251);
}

.btn_theme_secondary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.btn_theme_orange {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: #f59e0b;
    border: 1px solid #d97706;
    color: rgb(255, 255, 255) !important;
    line-height: 1.125rem;
}

.btn_theme_orange:hover {
    background-color: #d97706;
}

.btn_theme_orange:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Same height / radius / padding for every list-page action (primary + adjacent) */
.add_app_btn,
.add_app_btn_secondary,
.add_app a.add_app_btn,
.add_app a.add_app_btn_secondary {
    box-sizing: border-box;
    width: auto;
    height: 2.25rem;
    padding: 0 0.75rem;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1;
    border-radius: 0.25rem;
    white-space: nowrap;
    text-decoration: none;
}

.add_app_btn span,
.add_app_btn_secondary span {
    display: inline-flex;
    align-items: center;
    line-height: 1;
}

.btn_theme_danger {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    background-color: #dc2626;
    border: 1px solid #b91c1c;
    color: #fff;
}

.btn_theme_danger:hover {
    background-color: #b91c1c;
}

.btn_theme_danger:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* =========================================================
   Light semantic badges — Bootstrap 5 palette (soft bg + emphasis text)
   Use with: className="badge rounded-pill bg-light-success" etc.
   (Subscription status + reusable across the app)
   ========================================================= */
.badge.bg-light-primary {
    background-color: #cfe2ff !important;
    color: #084298 !important;
}

.badge.bg-light-secondary {
    background-color: #e2e3e5 !important;
    color: #41464b !important;
}

.badge.bg-light-success {
    background-color: #d1e7dd !important;
    color: #0f5132 !important;
}

.badge.bg-light-danger {
    background-color: #f8d7da !important;
    color: #842029 !important;
}

.badge.bg-light-warning {
    background-color: #fff3cd !important;
    color: #664d03 !important;
}

.badge.bg-light-info {
    background-color: #cff4fc !important;
    color: #055160 !important;
}

/* "Ended" automations etc. - had no rule before, so the badge rendered white-on-white (invisible). */
.badge.bg-light-dark {
    background-color: #d3d3d4 !important;
    color: #212529 !important;
}

/* Slightly clearer pill for status labels (optional; works with Bootstrap .badge) */
.badge.rounded-pill.bg-light-primary,
.badge.rounded-pill.bg-light-secondary,
.badge.rounded-pill.bg-light-success,
.badge.rounded-pill.bg-light-danger,
.badge.rounded-pill.bg-light-warning,
.badge.rounded-pill.bg-light-info,
.badge.rounded-pill.bg-light-dark {
    padding: 0.275rem 0.75rem;
    font-size: 0.7125rem;
    font-weight: 500;
    line-height: 1.25;
}

/* WhatsApp · Template Records — toolbar: keep row aligned with Refresh / Add Template */
.wa-template-records-toolbar.add_app {
    flex-direction: row !important;
    flex-wrap: nowrap;
    align-items: center !important;
    justify-content: flex-end !important;
    width: auto;
    max-width: min(100%, 52rem);
}
@media (max-width: 47.99em) {
    .wa-template-records-toolbar.add_app {
        flex-wrap: wrap;
        max-width: 100%;
    }
}
.wa-template-records-toolbar.add_app .wa-template-toolbar-delete.add_app_btn_secondary {
    border-color: #dc2626;
    color: #dc2626;
    background: #fff;
}
.wa-template-records-toolbar.add_app .wa-template-toolbar-delete.add_app_btn_secondary:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #b91c1c;
    color: #b91c1c;
}
.wa-template-records-toolbar.add_app .wa-template-toolbar-delete.add_app_btn_secondary:disabled {
    opacity: 0.55;
    border-color: #e5e7eb;
    color: #9ca3af;
    background: #f9fafb;
}

.form-options-list .form-group {
    margin-bottom: 0;
}

.form-options-list .form-control {
    margin-bottom: 0;
}

/* App dashboard */
.app-dashboard {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.app-dashboard__filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem 1rem;
}

.app-dashboard__date-range {
    flex: 0 1 auto;
    width: auto;
    min-width: 220px;
    max-width: 300px;
}

.app-dashboard__date-range .ns-daterange {
    width: auto;
    max-width: 300px;
}

.app-dashboard__range-label {
    font-size: 0.875rem;
    color: #64748b;
}

.app-dashboard__intro {
    margin: 0;
    color: #6b7280;
    font-size: 0.95rem;
}

.app-dashboard__section-title {
    margin: 0 0 0.75rem;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #6b7280;
}

.app-dashboard__kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1rem;
}

.app-dashboard__kpi {
    background: #fff;
    border-radius: 12px;
    padding: 1.15rem 1.25rem;
    box-shadow: rgba(5, 27, 44, 0.08) 0 1px 8px -1px, rgba(5, 27, 44, 0.06) 0 3px 4px -1px;
    display: flex;
    align-items: flex-start;
    gap: 0.85rem;
    text-decoration: none;
    color: inherit;
    transition: transform 0.15s, box-shadow 0.15s;
}

.app-dashboard__kpi--link:hover {
    transform: translateY(-2px);
    box-shadow: rgba(5, 27, 44, 0.12) 0 4px 16px -2px;
}

.app-dashboard__kpi-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.app-dashboard__kpi-value {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.2;
    color: #051b2c;
}

.app-dashboard__kpi-label {
    font-size: 0.8125rem;
    color: #6b7280;
    margin-top: 0.15rem;
}

.app-dashboard__kpi-sub {
    font-size: 0.75rem;
    color: #10b981;
    margin-top: 0.25rem;
}

.app-dashboard__charts {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
}

@media (min-width: 960px) {
    .app-dashboard__charts {
        grid-template-columns: repeat(2, 1fr);
    }
}

.app-dashboard__chart-card {
    background: #fff;
    border-radius: 12px;
    padding: 1.25rem;
    box-shadow: rgba(5, 27, 44, 0.08) 0 1px 8px -1px;
    min-height: 300px;
}

.app-dashboard__chart-card h3 {
    margin: 0 0 1rem;
    font-size: 1rem;
    font-weight: 600;
    color: #051b2c;
}

.app-dashboard__chart-empty {
    margin: 2.5rem 0 1rem;
    text-align: center;
    color: #9ca3af;
    font-size: 0.875rem;
}

.app-dashboard__chart-skeleton {
    height: 240px;
    width: 100%;
    border-radius: 8px;
    margin-top: 0.5rem;
}

.app-dashboard__empty {
    background: #fff;
    border-radius: 12px;
    padding: 2rem;
    text-align: center;
    color: #6b7280;
    box-shadow: rgba(5, 27, 44, 0.06) 0 1px 8px -1px;
}

.app-dashboard__skeleton {
    width: 72px;
    height: 28px;
}

/* Shared list styling (tickets, customers, staff, …). Scoped under
   .ns-support-list so global tables (Users, Subscriptions, etc.) are untouched. */

.ns-support-list .ns-tabs {
  display: inline-flex;
  background: #f1f3f5;
  border-radius: 8px;
  padding: 3px;
  gap: 2px;
  margin: 0 0 16px;
}
.ns-support-list .ns-tab {
  border: none;
  background: transparent;
  font-size: 13px;
  padding: 6px 15px;
  border-radius: 6px;
  color: #6c757d;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.ns-support-list .ns-tab:hover {
  color: #212529;
}
.ns-support-list .ns-tab--active {
  background: #fff;
  color: #212529;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.ns-support-list .dashboard_app_table {
  border: 1px solid #e9eaee;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.ns-support-list table.table_outer thead th {
  background: #f8f9fb;
  color: #8a8f98;
  font-weight: 500;
  font-size: 12px;
  text-transform: none;
  padding: 11px 16px;
  border-bottom: 1px solid #eceef1;
}

.ns-support-list table.table_outer tbody td {
  padding: 12px 16px;
  border-top: 1px solid #f1f3f5;
  vertical-align: middle;
  font-size: 13px;
  color: #212529;
}
.ns-support-list table.table_outer tbody tr:first-child td {
  border-top: none;
}
.ns-support-list .support-ticket-row--clickable {
  cursor: pointer;
  transition: background 0.12s;
}
.ns-support-list .support-ticket-row--clickable:hover td {
  background: #f8f9fb;
}

.ns-support-list .ns-requester {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.ns-support-list .ns-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.ns-support-list .ns-requester-name {
  color: #212529;
  font-size: 13px;
}
.ns-support-list .ns-requester-email {
  color: #9aa0a6;
  font-size: 11px;
}

.ns-support-list .ns-pill {
  display: inline-block;
  font-size: 12px;
  padding: 2px 9px;
  border-radius: 6px;
  background: #f1f3f5;
  color: #495057;
  text-transform: capitalize;
}

.ns-modal .modal-content {
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.16);
}
.ns-modal .modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eceef1;
  align-items: center;
}
.ns-modal .modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}
.ns-modal .modal-body {
  padding: 20px;
}
.ns-modal .modal-body .form-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  margin-bottom: 5px;
}
.ns-modal .modal-body .form-control {
  height: 38px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 13px;
  padding: 0 12px;
  box-shadow: none;
}
.ns-modal .modal-body textarea.form-control {
  height: auto;
  padding: 8px 12px;
}
.ns-modal .modal-body .form-control:focus {
  border-color: rgb(67, 70, 206);
  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.12);
}
.ns-modal .modal-footer {
  padding: 14px 20px;
  border-top: 1px solid #eceef1;
  gap: 8px;
}
.ns-modal .modal-footer .add_app_btn.btn_theme_primary {
  display: inline-flex;
  align-items: center;
  background: rgb(67, 70, 206);
  color: #fff;
  border: none;
  height: 38px;
  padding: 0 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
}
.ns-modal .modal-footer .add_app_btn.btn_theme_primary:hover {
  background: rgb(56, 59, 180);
}
.ns-modal .modal-footer .add_app_btn.btn_theme_primary span {
  color: #fff;
}
.ns-modal .modal-footer .btn_theme_secondary {
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  background: #fff;
  color: #495057;
  font-size: 13px;
  font-weight: 500;
}
.ns-modal .modal-footer .btn_theme_secondary:hover {
  background: #f8f9fa;
}
/* ===== Collaborate / Partner Integrations ===== */
.pi-page {
  padding: 20px 24px;
  min-height: 100vh;
}

.pi-page-title {
  font-size: 28px;
  font-weight: 600;
  margin: 4px 0 16px;
  color: #1a1a1a;
}

.pi-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

.pi-tab {
  appearance: none;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  margin-bottom: -1px;
}

.pi-tab:hover {
  color: #111827;
}

.pi-tab.active {
  color: #111827;
  border-bottom-color: #111827;
}

.pi-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.pi-search {
  flex: 1 1 220px;
  max-width: 320px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

.pi-search:focus {
  outline: none;
  border-color: #4c5fd5;
  box-shadow: 0 0 0 2px rgba(76, 95, 213, 0.15);
}

.pi-filter-select {
  height: 36px;
  min-width: 140px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  background: #fff;
  color: #374151;
}

.pi-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
}

@media (min-width: 48em) {
  .pi-cards {
    grid-template-columns: 1fr 1fr;
  }
}

@media (min-width: 75em) {
  .pi-cards {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.pi-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  min-height: 200px;
  box-shadow: rgba(5, 27, 44, 0.06) 0px 1px 6px -1px;
}

.pi-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.pi-logo {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  object-fit: contain;
  object-position: center;
  background: #fff;
  border: 1px solid #d1d5db;
  box-sizing: border-box;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.pi-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 4px 10px;
}

.pi-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #9ca3af;
}

.pi-status--active .pi-status-dot {
  background: #16a34a;
}

.pi-status--active {
  background: #ecfdf5;
  color: #166534;
}

.pi-card-name {
  margin: 0 0 4px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #111827;
}

.pi-card-category {
  margin: 0 0 8px;
  font-size: 13px;
  color: #6b7280;
}

.pi-card-stat {
  margin: 0;
  font-size: 13px;
  color: #4b5563;
  flex: 1 1;
}

.pi-card-actions {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.pi-card-actions a,
.pi-card-actions button {
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #4c5fd5;
  cursor: pointer;
  text-decoration: none;
}

.pi-card-actions a:hover,
.pi-card-actions button:hover {
  text-decoration: underline;
}

.pi-empty {
  padding: 48px 24px;
  text-align: center;
  color: #6b7280;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  background: #fafafa;
}

.pi-detail-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #4c5fd5;
  text-decoration: none;
  margin-bottom: 0;
}

.pi-detail-back:hover {
  text-decoration: underline;
}

.pi-detail-shell {
  margin-top: 0;
  height: calc(100vh - 4.5rem);
  min-height: 0;
}

.pi-detail-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.pi-detail-top {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 20px 14px;
}

.pi-detail-tabs {
  flex-shrink: 0;
  display: flex;
  gap: 0;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding: 0 20px;
  margin-top: 10px;
}

.pi-detail-tabs .pi-tab {
  margin-bottom: -1px;
}

.pi-detail-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px;
}

.pi-detail-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 0;
}

.pi-detail-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.pi-schema-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pi-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.pi-field input,
.pi-field select {
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #111827;
  background: #fff;
  box-sizing: border-box;
}

.pi-field input:disabled,
.pi-field select:disabled {
  background: #f9fafb;
  color: #6b7280;
}

.pi-remove-btn {
  appearance: none;
  border: 1px solid #fecaca;
  background: #fef2f2;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  color: #dc2626;
  cursor: pointer;
}

.pi-remove-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pi-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 4px 20px 18px;
  margin-bottom: 0;
}

.pi-section > .pi-block:first-child {
  border-top: none;
  padding-top: 14px;
}

.pi-block {
  padding: 18px 0;
  border-top: 1px solid #f3f4f6;
}

.pi-block h2 {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.pi-block p,
.pi-section > p {
  margin: 0 0 8px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
}

.pi-section h2 {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.pi-section p {
  margin: 0 0 8px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
}

.pi-kv {
  display: grid;
  gap: 10px;
}

.pi-kv-row {
  display: grid;
  grid-template-columns: 180px 1fr auto;
  gap: 10px;
  align-items: start;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;
}

.pi-kv-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.pi-kv-label {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
}

.pi-kv-value {
  font-size: 13px;
  color: #111827;
  word-break: break-all;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.pi-kv-value.plain {
  font-family: inherit;
}

.pi-copy-btn {
  appearance: none;
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
}

.pi-copy-btn:hover {
  background: #f9fafb;
}

.pi-params {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pi-param-chip {
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  background: #f3f4f6;
  color: #374151;
  border-radius: 6px;
  padding: 4px 8px;
}

.pi-token-toggle {
  appearance: none;
  border: none;
  background: none;
  color: #4c5fd5;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
}

@media (max-width: 640px) {
  .pi-kv-row {
    grid-template-columns: 1fr;
  }

  .pi-page {
    padding: 16px;
  }
}

.pi-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

.pi-toggle-row.compact {
  margin: 0;
}

/* Same checkbox look across activate / postbacks / schema toggles */
.pi-detail-layout input[type="checkbox"],
.pi-toggle-row input[type="checkbox"],
.pi-map-row input[type="checkbox"] {
  appearance: none;
  width: 18px;
  height: 18px;
  margin: 0;
  border: 2px solid #c7cad1;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  flex-shrink: 0;
  display: inline-grid;
  place-content: center;
  vertical-align: middle;
}

.pi-detail-layout input[type="checkbox"]::before,
.pi-toggle-row input[type="checkbox"]::before,
.pi-map-row input[type="checkbox"]::before {
  content: "";
  width: 10px;
  height: 10px;
  transform: scale(0);
  transition: transform 0.12s ease-in-out;
  box-shadow: inset 1em 1em #fff;
  transform-origin: center;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
}

.pi-detail-layout input[type="checkbox"]:checked,
.pi-toggle-row input[type="checkbox"]:checked,
.pi-map-row input[type="checkbox"]:checked {
  background: #4c5fd5;
  border-color: #4c5fd5;
}

.pi-detail-layout input[type="checkbox"]:checked::before,
.pi-toggle-row input[type="checkbox"]:checked::before,
.pi-map-row input[type="checkbox"]:checked::before {
  transform: scale(1);
}

.pi-detail-layout input[type="checkbox"]:disabled,
.pi-toggle-row input[type="checkbox"]:disabled,
.pi-map-row input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pi-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.pi-section-head h2 {
  margin: 0;
}

.pi-window-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 8px 0 12px;
}

.pi-radio {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
}

.pi-window-value {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  font-size: 13px;
  color: #4b5563;
}

.pi-window-slider {
  flex: 1 1;
  max-width: 420px;
  min-width: 0;
}

.pi-window-value input[type="range"] {
  width: 100%;
  max-width: none;
  margin: 0;
}

.pi-window-ticks {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 11px;
  color: #9ca3af;
  padding: 0 2px;
}

.pi-window-readout {
  flex-shrink: 0;
  padding-top: 2px;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
}

.pi-map-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pi-map-table--default .pi-map-head,
.pi-map-table--default .pi-map-row {
  display: grid;
  grid-template-columns: 160px 220px;
  gap: 12px;
  align-items: center;
  justify-content: start;
}

.pi-map-table--default .pi-map-row input[disabled] {
  background: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}

.pi-map-table--3 .pi-map-head,
.pi-map-table--3 .pi-map-row {
  display: grid;
  grid-template-columns: 160px minmax(160px, 220px) auto;
  gap: 12px;
  align-items: center;
}

.pi-map-table--5 .pi-map-head,
.pi-map-table--5 .pi-map-row {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(140px, 1.2fr) minmax(140px, 180px) minmax(140px, 1fr) auto;
  gap: 8px;
  align-items: center;
}

.pi-map-head {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  padding-bottom: 4px;
  border-bottom: 1px solid #f3f4f6;
}

.pi-map-row select,
.pi-map-row input[type="text"],
.pi-map-row input:not([type="checkbox"]):not([type="radio"]):not([type="range"]) {
  width: 100%;
  height: 34px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 8px;
  font-size: 13px;
}

.pi-map-empty {
  font-size: 13px;
  color: #6b7280;
  margin: 8px 0;
}

.pi-check-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  cursor: pointer;
  margin: 4px 0 0;
}

.pi-check-label--title {
  font-size: 16px;
  margin-bottom: 8px;
}

.pi-check-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

.pi-map-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.pi-bulk-wrap {
  position: relative;
}

.pi-bulk-btn {
  appearance: none;
  background: #fff;
  border: 1px solid #4c5fd5;
  color: #4c5fd5;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.pi-bulk-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pi-bulk-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 20;
  width: 280px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  padding: 12px;
}

.pi-bulk-group {
  margin-bottom: 12px;
}

.pi-bulk-group-title {
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  margin-bottom: 6px;
  text-transform: lowercase;
}

.pi-bulk-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #374151;
  margin: 6px 0;
  cursor: pointer;
}

.pi-bulk-confirm {
  width: 100%;
  justify-content: center;
}

.pi-map-table--events .pi-map-head,
.pi-map-table--events .pi-map-row {
  display: grid;
  grid-template-columns: 36px minmax(120px, 1fr) minmax(150px, 1.2fr) minmax(140px, 180px) minmax(140px, 1fr) auto;
  gap: 8px;
  align-items: center;
}

.pi-map-event {
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;
}

.pi-map-event:last-child {
  border-bottom: none;
}

.pi-map-partner-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.pi-map-partner-cell .pi-map-creatable {
  flex: 1 1;
  min-width: 0;
}

.pi-map-creatable--cond {
  flex: 1 1;
  min-width: 140px;
}

.pi-map-partner-cell input {
  flex: 1 1;
  min-width: 0;
}

.pi-map-chevron {
  color: #9ca3af;
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
}

.pi-map-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.pi-icon-btn {
  appearance: none;
  border: none;
  background: transparent;
  color: #6b7280;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.pi-icon-btn:hover {
  background: #f3f4f6;
}

.pi-icon-btn--danger {
  color: #dc2626;
}

.pi-icon-btn--danger:hover {
  background: #fef2f2;
}

.pi-icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pi-conditions {
  margin: 8px 0 4px 36px;
  padding-left: 12px;
  border-left: 2px dashed #d1d5db;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pi-condition-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.pi-condition-row input {
  height: 34px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 8px;
  font-size: 13px;
  min-width: 110px;
  flex: 1 1;
}

.pi-condition-when {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.pi-add-condition {
  appearance: none;
  border: none;
  background: none;
  color: #4c5fd5;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  align-self: flex-start;
}

.pi-add-event {
  appearance: none;
  display: inline-flex;
  align-items: center;
  border: 1px solid #4c5fd5;
  background: #fff;
  color: #4c5fd5;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 8px;
  margin-top: 12px;
}

.pi-add-event:hover {
  background: #eef2ff;
}

.pi-footer-bar {
  flex-shrink: 0;
  position: relative;
  bottom: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px;
  margin-top: 0;
  background: #fff;
  border-top: 1px solid #e5e7eb;
}

.pi-footer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.pi-unsaved {
  font-size: 13px;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 6px;
  padding: 6px 10px;
}

.pi-btn-primary,
.pi-btn-ghost {
  appearance: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.pi-btn-primary {
  background: #4c5fd5;
  color: #fff;
  border: none;
}

.pi-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pi-btn-ghost {
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
}

.pi-btn-ghost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .pi-map-table--default .pi-map-head,
  .pi-map-table--default .pi-map-row,
  .pi-map-table--3 .pi-map-head,
  .pi-map-table--3 .pi-map-row,
  .pi-map-table--5 .pi-map-head,
  .pi-map-table--5 .pi-map-row,
  .pi-map-table--events .pi-map-head,
  .pi-map-table--events .pi-map-row {
    grid-template-columns: 1fr;
  }

  .pi-conditions {
    margin-left: 0;
  }
}

/* Message report (push + WhatsApp campaign detail) */
.message-report-container {
    padding: 20px;
    background-color: #f8f9fa;
    min-height: 100vh;
    width: 100%;
    max-width: none;
}

.wa-campaign-report.message-report-container {
    width: 100%;
    max-width: none;
}

.report-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.report-breadcrumb {
    font-size: 14px;
    color: #6c757d;
}

.breadcrumb-link {
    color: #6c5ce7;
    cursor: pointer;
}

.breadcrumb-link:hover {
    text-decoration: underline;
}

.breadcrumb-separator {
    margin: 0 8px;
    color: #6c757d;
}

.breadcrumb-current {
    color: #212529;
}

.message-title-section {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
}

.message-title {
    font-size: 20px;
    font-weight: 600;
    color: #212529;
    margin: 0;
    max-width: 80%;
}

.message-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 25px;
}

.message-meta-started {
    white-space: nowrap;
    margin-right: 6px;
}

/* Stats Cards */
.stats-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 30px;
}

.stat-card {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-label {
    font-size: 12px;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #212529;
}

.stat-sublabel {
    font-size: 12px;
    color: #6c757d;
}

/* Chart Section */
.chart-section {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.chart-header h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
}

.chart-filters {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
}

.chart-note {
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 20px;
}

.chart-container {
    height: 200px;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chart-placeholder {
    width: 100%;
    height: 100%;
    padding: 20px;
}

.chart-line {
    width: 100%;
    height: 100%;
}

.chart-legend {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #495057;
}

.legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.legend-dot.clicks {
    background-color: #6c5ce7;
}

.legend-dot.confirmed {
    background-color: #00b894;
}

.legend-dot.sessions {
    background-color: #e17055;
}

.legend-item.add-outcome {
    color: #6c5ce7;
    cursor: pointer;
}

/* Outcomes Table */
.outcomes-section {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.outcomes-table {
    margin-bottom: 10px;
}

.outcomes-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    font-size: 13px;
}

.show-all-link {
    color: #6c5ce7;
    font-size: 13px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.show-all-link:hover {
    text-decoration: underline;
}

/* Statistics Row */
.statistics-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 30px;
}

.delivery-stats,
.platform-stats {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.delivery-stats h4,
.platform-stats h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
}

.platform-label {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 10px;
}

.progress-bar-container {
    height: 8px;
    background-color: #e9ecef;
    border-radius: 4px;
    margin-bottom: 15px;
    overflow: hidden;
}

.progress-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #6c5ce7, #a29bfe);
    border-radius: 4px;
}

.progress-bar-fill.android {
    background: #4CAF50;
}

.stats-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.stats-list li {
    display: flex;
    align-items: center;
    padding: 8px 0;
    font-size: 13px;
    border-bottom: 1px solid #f1f3f5;
}

.stats-list li:last-child {
    border-bottom: none;
}

.stats-list .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 10px;
}

.stats-list .value {
    margin-left: auto;
    font-weight: 500;
}

.dot.audience {
    background-color: #6c5ce7;
}

.dot.sent {
    background-color: #a29bfe;
}

.dot.delivered {
    background-color: #00b894;
}

.dot.confirmed {
    background-color: #00cec9;
}

.dot.unsubscribed {
    background-color: #e17055;
}

.dot.error {
    background-color: #d63031;
}

.dot.remaining {
    background-color: #fdcb6e;
}

.dot.canceled {
    background-color: #636e72;
}

.dot.android {
    background-color: #4CAF50;
}

/* Audience Activity */
.audience-activity {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.activity-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.activity-header h4 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
}

.activity-filters {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 15px;
}

.filter-chip {
    padding: 6px 12px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 20px;
    font-size: 12px;
    color: #495057;
    cursor: pointer;
}

.filter-chip:hover {
    background-color: #e9ecef;
}

.filter-chip--active {
    background-color: #e8f0fe;
    border: 2px solid #6c5ce7;
    color: #3d2fb8;
    font-weight: 600;
    box-shadow: 0 0 0 1px rgba(108, 92, 231, 0.25);
}

.filter-chip:focus-visible {
    outline: 2px solid #6c5ce7;
    outline-offset: 2px;
}

.activity-table-wrap {
    position: relative;
}

.activity-table-wrap--loading {
    opacity: 0.65;
    pointer-events: none;
}

.activity-pagination {
    border-top: 1px solid #f1f3f5;
    margin-top: 4px;
}

.activity-table {
    margin-bottom: 15px;
}

.activity-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    font-size: 12px;
}

.activity-table td {
    font-size: 13px;
}

.truncate {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.failure-reason-cell {
    max-width: 320px;
}

.device-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    background-color: #e8f5e9;
    border-radius: 4px;
    font-size: 12px;
}

.subscription-badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
}

.subscription-badge.subscribed {
    background-color: #d4edda;
    color: #155724;
}

.subscription-badge.pending {
    background-color: #fff3cd;
    color: #856404;
}

.subscription-badge.failed {
    background-color: #f8d7da;
    color: #721c24;
}

.activity-note {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #6c757d;
    margin: 0;
}

/* Message Settings */
.message-settings-section {
    background: white;
    border-radius: 8px;
    padding: 25px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.message-settings-section>h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 25px;
    color: #212529;
}

.settings-content {
    display: flex;
    gap: 40px;
}

.settings-details {
    border-right: 1px solid #e9ecef;
    padding-right: 40px;
    flex: 1 1;
}

.settings-group-header {
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    margin-top: 20px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.settings-group-header:first-child {
    margin-top: 0;
}

.settings-group-header.android-header {
    color: #212529;
}

.settings-row {
    display: grid;
    grid-template-columns: 200px 1fr;
    padding: 10px 0;
    border-bottom: 1px solid #f1f3f5;
    font-size: 13px;
}

.settings-row:last-of-type {
    border-bottom: none;
}

.settings-label {
    color: #495057;
}

.settings-value {
    color: #212529;
}

.message-row {
    border-bottom: none;
    padding-bottom: 5px;
}

.message-content-row {
    padding-top: 0;
}

.language-label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.language-indicator {
    width: 2px;
    height: 100%;
    min-height: 40px;
    background-color: #dee2e6;
    display: inline-block;
}

.message-text {
    color: #495057;
    line-height: 1.5;
}

/* Phone Preview - Same style as PushNotification */
.phone-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
}

.mobile-image-report {
    width: 320px;
    height: 640px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    border-radius: 30px;
    padding: 50px 20px 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    position: relative;
    background-color: #f8f9fa;
    border: 8px solid #e0e0e0;
}

.notification-card-report {
    display: flex;
    background: white;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    gap: 12px;
}

.profile-report {
    flex-shrink: 0;
}

.profile-report img {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.notification-content-report {
    flex: 1 1;
    min-width: 0;
}

.app-name-report {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
}

.notification-title-report {
    font-size: 14px;
    margin-bottom: 2px;
    color: #212529;
}

.notification-body-report {
    font-size: 14px;
    color: #333;
    margin-bottom: 0;
    line-height: 1.4;
    word-wrap: break-word;
}

.preview-label {
    margin-top: 20px;
    font-size: 13px;
    color: #6c757d;
    text-align: center;
}

/* Status Badge */
.status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.status-badge.delivered {
    background-color: #d4edda;
    color: #155724;
}

.status-badge.failed {
    background-color: #f8d7da;
    color: #721c24;
}

.status-badge.pending {
    background-color: #fff3cd;
    color: #856404;
}

.status-badge.processing {
    background-color: #d1ecf1;
    color: #0c5460;
}

.status-badge.cancelled {
    background-color: #e2e3e5;
    color: #383d41;
}

/* Responsive */
@media (max-width: 992px) {
    .stats-cards {
        grid-template-columns: repeat(2, 1fr);
    }

    .statistics-row {
        grid-template-columns: 1fr;
    }

    .settings-content {
        grid-template-columns: 1fr;
    }

    .settings-details {
        border-right: none;
        padding-right: 0;
        border-bottom: 1px solid #e9ecef;
        padding-bottom: 30px;
        margin-bottom: 30px;
    }

    .phone-preview {
        order: 1;
    }

    .settings-row {
        grid-template-columns: 1fr;
        gap: 5px;
    }
}

@media (max-width: 576px) {
    .stats-cards {
        grid-template-columns: 1fr;
    }

    .phone-frame-modern {
        width: 220px;
        height: 400px;
    }
}

/* WhatsApp platform (inbox, contacts, campaigns, phones, …) */
.wa-platform {
  padding: 1rem 1.25rem 2rem;
  width: 100%;
  max-width: none;
  margin: 0;
}

.wa-platform__header {
  margin-bottom: 1.25rem;
}

.wa-platform__title-row {
  display: flex;
  align-items: center;
  gap: 0.75rem 1rem;
  flex-wrap: wrap;
}

.wa-platform__header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.wa-platform__title {
  font-size: 1.35rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.wa-platform__phone-tools {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-left: auto;
}

.wa-platform__active-phone {
  font-size: 0.92rem;
  font-weight: 600;
  color: #111b21;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.wa-msg-link {
  display: inline-flex;
  align-items: center;
}

.wa-msg-link__copy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0.2rem;
  color: #6c757d;
  line-height: 1;
  cursor: pointer;
  border-radius: 4px;
}

.wa-msg-link__copy:hover {
  color: #198754;
  background: rgba(25, 135, 84, 0.08);
}

.wa-platform__subtitle {
  margin: 0.25rem 0 0;
  color: #6c757d;
  font-size: 0.9rem;
}

.wa-md strong {
  font-weight: 700;
}

.wa-md em {
  font-style: italic;
}

.wa-md s {
  text-decoration: line-through;
}

.wa-md code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.92em;
}

/* WhatsApp template CTA row — keep fields + remove on one line, equal heights */
.ns-wa-tpl-btn-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 0.5rem;
  overflow-x: auto;
}
.ns-wa-tpl-btn-row .form-control,
.ns-wa-tpl-btn-row .form-select {
  height: 38px;
  min-height: 38px;
  font-size: 0.875rem;
}
.ns-wa-tpl-btn-field {
  min-width: 0;
}
.ns-wa-tpl-btn-field--type {
  flex: 0 1 11rem;
}
.ns-wa-tpl-btn-field--text {
  flex: 0 1 10rem;
}
.ns-wa-tpl-btn-field--urltype {
  flex: 0 0 8.5rem;
}
.ns-wa-tpl-btn-field--grow {
  flex: 1 1 12rem;
}
.ns-wa-tpl-btn-remove {
  width: 38px;
  height: 38px;
  padding: 0;
  flex: 0 0 38px;
  line-height: 1;
}
.ns-wa-tpl-btn-remove svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.wa-tpl-body-wrap {
  position: relative;
}
.wa-tpl-body-wrap .form-control {
  padding-right: 4.5rem;
}
.ns-wa-tpl-btn-row .ns-wa-tpl-btn-type__control {
  min-height: 38px !important;
  height: 38px !important;
}
.wa-tpl-body-count {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 12px;
  color: #6c757d;
  pointer-events: none;
}
.wa-tpl-body-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 6px;
}
.wa-tpl-body-toolbar button {
  border: none;
  background: transparent;
  color: #54656f;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1;
}
.wa-tpl-body-toolbar button:hover {
  background: #f0f2f5;
}
.wa-tpl-body-toolbar .wa-tpl-body-toolbar-addvar {
  color: rgb(67, 70, 206);
  font-weight: 500;
  font-size: 13px;
}

.wa-muted {
  color: #6c757d;
  font-size: 0.875rem;
}

.wa-card {
  border: none;
  border-radius: 12px;
  overflow: hidden;
}

.wa-usage-type {
  min-width: 160px;
}

/* Inbox uses the full window — no max-width cap, full viewport height */
.wa-platform--full {
  max-width: none;
  padding-bottom: 1rem;
}

.wa-platform--full .wa-platform__header {
  margin-bottom: 0.75rem;
}

.wa-inbox {
  display: grid;
  grid-template-columns: minmax(280px, 360px) 1fr;
  gap: 1rem;
  height: calc(100vh - 150px);
  min-height: 480px;
}

@media (max-width: 991px) {
  .wa-inbox {
    grid-template-columns: 1fr;
    height: auto;
  }
}

.wa-inbox__list,
.wa-inbox__thread {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.wa-inbox__list-head {
  padding: 0.85rem 1rem;
  font-weight: 600;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #f7f8fa;
}

.wa-inbox__list-body {
  flex: 1 1;
  overflow-y: auto;
}

.wa-inbox__list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2.5rem 1.25rem;
}

.wa-inbox__row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  text-align: left;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: #fff;
  padding: 0.7rem 0.9rem;
  cursor: pointer;
  transition: background 0.15s ease;
}

.wa-inbox__row:hover {
  background: #f5f6f6;
}

.wa-inbox__row.active {
  background: #ecedfb;
}

.wa-avatar {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4346ce, #6b6ee8);
  color: #fff;
  font-weight: 600;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wa-avatar--lg {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
}

.wa-inbox__row-main {
  flex: 1 1;
  min-width: 0;
}

.wa-inbox__row-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
}

.wa-inbox__phone {
  font-size: 0.92rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wa-inbox__time {
  font-size: 0.72rem;
  color: #8696a0;
  flex: 0 0 auto;
}

.wa-inbox__row-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.15rem;
}

.wa-badge {
  background: #4346ce;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  flex: 0 0 auto;
}

.wa-inbox__preview {
  font-size: 0.82rem;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wa-inbox__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  text-align: center;
  padding: 2rem;
  gap: 0.35rem;
  background: #f8f9fa;
}

.wa-inbox__empty-icon {
  width: 44px;
  height: 44px;
  opacity: 0.45;
  color: #6c757d;
  flex-shrink: 0;
}

.wa-inbox__list-empty .wa-inbox__empty-icon {
  width: 36px;
  height: 36px;
}

.wa-inbox__empty-title {
  font-weight: 600;
  font-size: 1.05rem;
}

.wa-tick {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  color: #8696a0;
  margin-left: 2px;
}

.wa-tick--read {
  color: #53bdeb;
}

.wa-tick--fail {
  color: #d92d20;
}

.wa-inbox__thread-head {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.6rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #f7f8fa;
}

.wa-inbox__thread-title {
  flex: 1 1;
  min-width: 0;
  line-height: 1.25;
}

.wa-session-pill {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  white-space: nowrap;
}

.wa-session-pill--open {
  background: #d9f3e5;
  color: #0f7a4d;
}

.wa-session-pill--closed {
  background: #feecec;
  color: #b42318;
}

.wa-inbox__messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.25rem 1.5rem;
  background: #efeae2;
  background-image: radial-gradient(rgba(0, 0, 0, 0.025) 1px, transparent 1px);
  background-size: 22px 22px;
}

.wa-bubble {
  max-width: 68%;
  padding: 0.45rem 0.7rem 0.3rem;
  border-radius: 10px;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
  width: fit-content;
}

/* WhatsApp-like: media bubbles use a fixed wider width so images aren't cramped/cropped */
.wa-bubble--media {
  width: min(330px, 88%);
  max-width: min(330px, 88%);
  padding: 0.2rem 0.2rem 0.3rem;
}

.wa-bubble--media .wa-bubble__tpl-label,
.wa-bubble--media .wa-bubble__text,
.wa-bubble--media .wa-bubble__footer {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.wa-bubble--in {
  background: #fff;
  margin-right: auto;
  border-top-left-radius: 2px;
}

.wa-bubble--out {
  background: #e6e7fa;
  margin-left: auto;
  border-top-right-radius: 2px;
}

.wa-bubble__text {
  white-space: pre-wrap;
  word-break: break-word;
}

.wa-bubble__tpl-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.2rem;
}

.wa-inbox__composer-closed {
  width: 100%;
  padding: 0.25rem 0;
}

.wa-inbox__composer-stack {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.wa-inbox__composer-block-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: #374151;
}

.wa-inbox__composer-block--tpl {
  padding-top: 0.65rem;
  border-top: 1px solid #e5e7eb;
}

.wa-inbox__tpl-preview {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
}

.wa-inbox__tpl-preview-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6c757d;
  margin-bottom: 0.35rem;
}

.wa-inbox__tpl-preview-body {
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-break: break-word;
  color: #1f2937;
  line-height: 1.4;
}

.wa-bubble__media {
  margin: 0 0 0.35rem;
  overflow: hidden;
  border-radius: 6px;
  background: #e9edef;
}

.wa-bubble__media--image {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.wa-bubble__media--image img,
.wa-bubble__media--video video {
  display: block;
  width: 100%;
  height: auto;
  max-height: 420px;
  object-fit: contain;
  object-position: center;
  background: #e9edef;
}

.wa-bubble__media--video video {
  background: #000;
  max-height: 420px;
}

.wa-bubble__media--pending,
.wa-bubble__media--doc {
  padding: 0.45rem 0.55rem;
  font-size: 0.8rem;
  color: #667781;
  background: rgba(0, 0, 0, 0.04);
}

.wa-bubble__media--location {
  margin: 0 0 0.35rem;
}

.wa-bubble__location-card {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  padding: 0.5rem 0.55rem;
  text-decoration: none;
  color: inherit;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 6px 6px 0 0;
}

.wa-bubble__location-pin {
  font-size: 1.1rem;
  line-height: 1.2;
}

.wa-bubble__location-title {
  font-size: 0.82rem;
  font-weight: 600;
  color: #111b21;
}

.wa-bubble__location-sub,
.wa-bubble__location-coords {
  font-size: 0.72rem;
  color: #667781;
  margin-top: 0.1rem;
}

.wa-bubble__media a {
  text-decoration: none;
}

.wa-bubble__footer {
  font-size: 0.66rem;
  color: #8696a0;
  text-align: right;
  margin-top: 0.15rem;
}

.wa-inbox__composer {
  padding: 0.5rem 0.75rem 0.4rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: #f7f8fa;
}

.wa-inbox__composer-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.wa-inbox__composer-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
}

.wa-inbox__tpl-select {
  width: auto;
  max-width: 220px;
  min-width: 140px;
  flex: 0 1 auto;
}

.wa-inbox__tpl-vars {
  flex: 1 1 120px;
  max-width: 200px;
  min-width: 100px;
}

.wa-inbox__tpl-header-file {
  flex: 0 1 150px;
  min-width: 110px;
  max-width: 180px;
}

.wa-inbox__tpl-header-url {
  flex: 1 1 140px;
  min-width: 120px;
  max-width: 220px;
}

.wa-inbox__tpl-header-coord {
  flex: 0 1 90px;
  min-width: 70px;
  max-width: 110px;
}

.wa-inbox__composer-main {
  display: flex;
  gap: 0.45rem;
  align-items: flex-end;
}

.wa-composer-input {
  resize: vertical;
  border-radius: 12px;
  padding: 0.4rem 0.75rem;
  min-height: 40px;
  max-height: 280px;
  flex: 1 1;
  line-height: 1.35;
  font-size: 0.875rem;
}

.wa-composer-input--preview {
  background: #fff;
  color: #374151;
  cursor: default;
}

.wa-inbox__session-bar {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.7rem;
  line-height: 1.3;
  padding: 0.15rem 0 0;
}

.wa-inbox__session-bar--open {
  color: #027a48;
}

.wa-inbox__session-bar--closed {
  color: #b42318;
}

.wa-inbox__session-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex: 0 0 auto;
  background: currentColor;
}

.wa-send-btn {
  border-radius: 20px;
  min-width: 42px;
  height: 36px;
  flex: 0 0 auto;
  background: #4346ce !important;
  border-color: #4346ce !important;
  color: #fff !important;
  padding: 0 0.75rem;
}

.wa-send-btn:hover:not(:disabled) {
  background: #3538b8 !important;
  border-color: #3538b8 !important;
}

.wa-kpi {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.wa-kpi__val {
  font-size: 1.5rem;
  font-weight: 700;
  color: #4346ce;
}

.wa-profile-img {
  max-width: 120px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* SweetAlert above page drawers/portals (e.g. z-index 1065); Safari scrollbar overlap */
.swal2-container {
  z-index: 20000 !important;
}



.automation-builder {
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
    background: #f8fafc;
    overflow: hidden;
}

/* =========================
   HEADER
========================= */

.automation-live-errors {
    background: #fef2f2;
    border-bottom: 1px solid #fecaca;
    color: #991b1b;
    font-size: 13px;
    line-height: 1.45;
    padding: 8px 20px;
}
.automation-live-errors div + div {
    margin-top: 4px;
}

.automation-header {
    min-height: 70px;
    padding: 12px 20px;
    background: #ffffff;
    border-bottom: 1px solid #e5e7eb;

    display: flex;
    align-items: center;
    justify-content: space-between;

    flex-shrink: 0;
}

.automation-back-btn {
    width: 38px;
    height: 38px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    vertical-align: middle;
}

.automation-header h4 {
    margin: 0 0 4px;
    font-size: 18px;
    font-weight: 600;
    color: #111827;
}

.automation-header span {
    font-size: 13px;
    color: #6b7280;
}

.automation-header button {
    margin-left: 0;
}

/* =========================
   MAIN WORKSPACE
========================= */

.automation-workspace {
    position: relative;
    flex: 1 1;
    min-height: 0;

    display: flex;

    overflow: hidden;
}


/* =========================
   INSERT MENU
========================= */

.automation-insert-menu {
    position: absolute;
    pointer-events: all;

    background: #fff;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
    padding: 8px;
    z-index: 1000;
    width: 220px;
    max-height: 60vh;
    overflow-y: auto;
}

.automation-insert-menu .menu-group-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: #9ca3af;
    padding: 8px 10px 4px;
}
.automation-insert-menu button {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    text-align: left;
    padding: 8px 10px;
    border: none;
    background: none;
    border-radius: 6px;
    font-size: 13px;
}
.automation-insert-menu button:hover { background: #f3f4f6; }
.automation-insert-menu .menu-icon {
    width: 22px; height: 22px; border-radius: 6px;
    display: flex; align-items: center; justify-content: center;
    color: #fff; flex-shrink: 0; font-size: 13px;
}
.automation-edge-plus-btn {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1.5px solid #c7c9d9;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    line-height: 0;
    color: #4c5fd5;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.automation-edge-plus-btn:hover {
    background: #eef0ff;
    border-color: #4c5fd5;
    box-shadow: 0 0 0 6px rgba(76, 95, 213, 0.12);
}
.automation-edge-plus-btn svg {
    width: 12px;
    height: 12px;
    display: block;
}


.automation-header > div:last-child {
    display: flex;
    align-items: center;
    gap: 10px;
}

.automation-more-options .dropdown-toggle::after {
    transition: transform 0.15s ease;
}
.automation-more-options.show .dropdown-toggle::after {
    transform: rotate(180deg);
}

.automation-more-options .dropdown-menu-subscription {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 6px;
    overflow: hidden; /* hover-highlight ko rounded border ke andar clip karne ke liye */
}

/* =========================
   SET LIVE CHECKLIST MODAL
========================= */

.automation-setlive-modal .modal-body {
    max-height: 60vh;
    overflow-y: auto;
}

.automation-setlive-checking {
    padding: 24px 0;
    text-align: center;
    color: #6b7280;
    font-size: 14px;
}

.automation-setlive-checklist {
    list-style: none;
    margin: 0;
    padding: 0;
}

.automation-setlive-checklist li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 9px 0;
    border-bottom: 1px solid #f1f2f6;
    font-size: 13.5px;
    color: #374151;
}

.automation-setlive-checklist li:last-child {
    border-bottom: none;
}

.automation-setlive-checklist-icon {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
}

.automation-setlive-checklist li {
    transition: opacity 0.2s ease;
}

.automation-setlive-checklist li.is-pending {
    opacity: 0.55;
}

.automation-setlive-checklist li.is-ok .automation-setlive-checklist-icon {
    background: rgba(34, 197, 94, 0.12);
    color: #16a34a;
}

.automation-setlive-checklist li.is-fail .automation-setlive-checklist-icon {
    background: rgba(239, 68, 68, 0.12);
    color: #dc2626;
}

.automation-setlive-checklist li.is-pending .automation-setlive-checklist-icon {
    background: rgba(107, 114, 128, 0.1);
}

.automation-setlive-spinner {
    width: 13px;
    height: 13px;
    border: 2px solid rgba(107, 114, 128, 0.35);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    animation: btn-spin 0.8s linear infinite;
}

.automation-setlive-checklist-label {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.automation-setlive-checklist li.is-fail .automation-setlive-checklist-label {
    color: #991b1b;
    font-weight: 500;
}

.automation-setlive-checklist-detail {
    font-size: 12.5px;
    font-weight: 400;
    color: #991b1b;
    opacity: 0.85;
}

.automation-setlive-summary {
    margin-top: 14px;
    padding: 10px 12px;
    border-radius: 0.375rem;
    font-size: 13.5px;
    font-weight: 500;
}

.automation-setlive-summary.is-ok {
    background: rgba(34, 197, 94, 0.08);
    color: #15803d;
    border: 1px solid rgba(34, 197, 94, 0.25);
}

.automation-setlive-summary.is-fail {
    background: rgba(239, 68, 68, 0.08);
    color: #b91c1c;
    border: 1px solid rgba(239, 68, 68, 0.25);
}



/* =========================
   CONFIG DRAWER
========================= */

.automation-config-drawer {
    /* Base width node-config drawers (Wait / Send Email / Send push / Add User) ke liye -
       Automation Settings drawer isi variable ke upar +340px jyada rakhta h (neeche
       inline style me calc() se), taaki agar yeh base kabhi badlein to settings wala
       drawer khud-ba-khud usse bada hi rahe, dono jagah alag-alag number update na karna pade. */
    --automation-drawer-width: 640px;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: var(--automation-drawer-width);
    background: #fff;
    box-shadow: -2px 0 12px rgba(0,0,0,0.15);
    display: flex;
    flex-direction: column;
    z-index: 1050;
}

.automation-config-drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
}

.automation-config-drawer-header h5 {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
}

.automation-config-drawer-header .drawer-actions {
    display: flex;
    gap: 8px;
}

/* Config drawer (node config + Automation Settings) ke andar ka text thoda chota/compact -
   ek 460px chaudi drawer me bootstrap ka default (16px) form text bahut bada/cramped lagta
   h isliye yahan scoped override h (sirf drawer ke andar, baaki app me kahi aur asar nahi
   padega). Section-title pehle inline style={{fontSize:14}} se chota kiya jata tha har
   jagah alag se - ab ek hi jagah class se ho raha h. */
.automation-config-drawer-body .automation-settings-section-title {
    font-size: 14px;
    margin-bottom: 10px;
}
.automation-config-drawer-body .automation-settings-help-text {
    font-size: 12px;
}
.automation-config-drawer-body .form-control,
.automation-config-drawer-body .form-select,
.automation-config-drawer-body select,
.automation-config-drawer-body input,
.automation-config-drawer-body textarea {
    font-size: 13px;
}
.automation-config-drawer-body .btn {
    font-size: 13px;
}
.automation-config-drawer-body .automation-settings-radio-title {
    font-size: 13px;
}
.automation-config-drawer-body .automation-settings-radio-desc {
    font-size: 12px;
}
/* Metric / Template / Wait-unit jaise custom select-dropdowns (native <select> ki jagah
   bane h) bhi drawer ke baaki text se bade (14px, zyada padding) the - yahan bhi 13px/
   compact padding pe la rahe h taaki poori drawer ek hi consistent size me dikhe. */
.automation-config-drawer-body .automation-settings-select-trigger {
    padding: 7px 10px;
    font-size: 13px;
}
.automation-config-drawer-body .automation-settings-select-dropdown-menu.dropdown-menu-subscription button {
    padding: 0.45rem 0.6rem;
    font-size: 13px;
}
.automation-config-drawer-body .automation-settings-select-group-title {
    padding: 6px 12px 2px;
}

/* Baaki app me jaisa automation-header ke Cancel/Save buttons ka purple theme h (upar
   AUTOMATION HEADER section me), yahan bhi wahi match karte h - taaki drawer ke buttons
   bootstrap ke default blue/gray jaise na dikhe. */
.automation-config-drawer-header button.btn-primary {
    background: #4c5fd5;
    border-color: #4c5fd5;
}
.automation-config-drawer-header button.btn-primary:hover:not(:disabled) {
    background: #3d4fc2;
    border-color: #3d4fc2;
}
.automation-config-drawer-header button.btn-secondary,
.automation-config-drawer-header button.btn-outline-secondary {
    background: #fff;
    border-color: #d1d5db;
    color: #374151;
}
.automation-config-drawer-header button.btn-secondary:hover,
.automation-config-drawer-header button.btn-outline-secondary:hover {
    background: #693cac1e;
}

.automation-config-drawer-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 16px 20px;
}

.automation-config-drawer-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 1049;
}

.automation-node-info-banner {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    background: #eef2ff;
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 14px;
    font-size: 13px;
    color: #374151;
}

.automation-node-info-banner-text {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.automation-node-info-banner-icon {
    flex-shrink: 0;
    margin-top: 2px;
    color: #4c5fd5;
}

.automation-node-info-banner-text a {
    color: #5b4ddb;
    font-weight: 500;
}

.automation-node-info-banner-close {
    cursor: pointer;
    flex-shrink: 0;
    color: #6b7280;
}

.automation-node-tip-box {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 12px;
    color: #6b7280;
}

.automation-node-tip-icon {
    flex-shrink: 0;
    margin-top: 1px;
    color: #9ca3af;
}

.automation-node-adv-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 13px;
    color: #374151;
}

.automation-settings-option-cards {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
}

.automation-settings-option-card {
    flex: 1 1;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    padding: 20px;
    cursor: pointer;
    text-align: center;
    background: #f9fafb;
}

.automation-settings-option-card.active {
    border-color: #5b4ddb;
    background: #f5f3ff;
}

.automation-settings-option-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e5e7eb;
    color: #6b7280;
    margin-bottom: 8px;
}

.automation-settings-option-card.active .automation-settings-option-icon {
    background: #e3defc;
    color: #5b4ddb;
}

.automation-settings-option-card h6 {
    margin: 8px 0 4px;
    font-weight: 600;
}

.automation-settings-option-card p {
    margin: 0;
    font-size: 13px;
    color: #6b7280;
}

/* Entry/Exit/Re-entry/Schedule - sabhi Automation Settings tabs ke andar yahi shared design
   language use ho (section title, field labels, dividers, segment add-links) */
.automation-settings-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 16px;
}

.automation-settings-field-label {
    display: block;
    font-size: 13px;
    color: #374151;
    margin-bottom: 8px;
}

.automation-settings-segment-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: none;
    padding: 0;
    color: #5b4ddb;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.automation-settings-segment-link:hover {
    color: #4a3dc9;
    text-decoration: underline;
}

.automation-settings-divider {
    border: none;
    border-top: 1px solid #e5e7eb;
    margin: 20px 0;
}

.automation-settings-help-text {
    margin: 4px 0 0;
    font-size: 12px;
    color: #6b7280;
}

/* "+ Add Template" link next to Push/WhatsApp dropdown labels - reuses the same link look as
   the existing automation-settings-segment-link, just sized to sit inline with a field label. */
.automation-settings-add-template-link {
    font-size: 12px;
    font-weight: 500;
    color: #5b4ddb;
    text-decoration: none;
}
.automation-settings-add-template-link:hover {
    color: #4a3dc9;
    text-decoration: underline;
}

/* WhatsApp template preview now uses the shared WhatsAppMessagePreview component (same chat-bubble
   look as WhatsApp > Templates) instead of its own bubble styles here. */
.automation-settings-push-preview-label {
    font-size: 12px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 6px;
}

/* Push template preview (point 5) - phone-notification-style card. */
.automation-settings-push-preview-phone {
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 12px;
    max-width: 320px;
}
.automation-settings-push-preview-title {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 2px;
}
.automation-settings-push-preview-message {
    font-size: 12px;
    color: #4b5563;
}

.automation-branch-radio-row {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 10px;
}

.automation-branch-radio {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    cursor: pointer;
    margin: 0;
}

.automation-branch-radio input[type="radio"] {
    accent-color: #4c5fd5;
    width: 16px;
    height: 16px;
    margin: 0;
}

.automation-branch-radio-body {
    margin-top: 10px;
    margin-left: 24px;
}

.automation-branch-error {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #dc2626;
    font-size: 13px;
    margin-top: 8px;
}

.automation-branch-tip {
    display: flex;
    gap: 8px;
    background: #f9fafb;
    border-radius: 6px;
    padding: 10px 12px;
    margin-top: 10px;
    font-size: 12px;
    color: #4b5563;
}

.automation-branch-segment-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #693cac1e;
    color: #4c5fd5;
    border-radius: 14px;
    padding: 4px 10px;
    font-size: 13px;
    margin: 0 6px 6px 0;
}

.automation-branch-segment-chip svg {
    cursor: pointer;
}

.automation-branch-include-segment-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    color: #4c5fd5;
    font-size: 13px;
    font-weight: 500;
    padding: 4px 0;
    cursor: pointer;
}

.automation-settings-channels-box {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 14px 18px;
}

.automation-settings-channel-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
}

.automation-settings-channel-row + .automation-settings-channel-row {
    border-top: 1px solid #f1f2f6;
}

.automation-settings-channel-label {
    width: 90px;
    font-size: 13px;
    font-weight: 600;
    color: #111827;
}

.automation-settings-channel-bar {
    flex: 1 1;
    height: 4px;
    border-radius: 2px;
    background: #e5e7eb;
    max-width: 160px;
    position: relative;
    overflow: hidden;
}

.automation-settings-channel-bar-fill {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    border-radius: 2px;
    background: #22c55e;
}

.automation-settings-channel-value {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    min-width: 16px;
    text-align: right;
}

/* Generic helper: hide anything labeled/marked "beta" for now (point 3 - feature paused,
   will be revisited later). Apply this class directly on the box/row that should be hidden. */
.beta_hide {
    display: none !important;
}

/* Goals tab: "Beta" pill next to "Set an Automation Goal" */
.automation-settings-beta-badge {
    font-size: 11px;
    font-weight: 600;
    color: #5b4ddb;
    background: #ede9fe;
    padding: 2px 8px;
    border-radius: 999px;
    line-height: 1.4;
}

/* Goals tab: custom "Metric" dropdown (native <select> ki jagah OneSignal jesa panel) */
.automation-settings-select-wrap {
    position: relative;
}

.automation-settings-select-trigger {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border: 1px solid #5b4ddb;
    border-radius: 6px;
    background: #fff;
    color: #111827;
    font-size: 14px;
    cursor: pointer;
}

.automation-settings-select-placeholder {
    color: #9ca3af;
}

/* Metric/Template/Wait-unit dropdown ke liye \`.dropdown-menu-subscription\` hi underlying
   component/markup h (App ke standard "More options"/card 3-dot/list row-actions wala), lekin
   ek "select" field ki tarah dikhna chahiye, ek action-menu ki tarah nahi - isliye apna khud ka
   tighter/form-jesa skin is class se milta h: poori trigger-width (native <select> jaisa),
   compact row-height, aur selected value pe checkmark (icon-heavy action-row jesa nahi). */
.automation-settings-select-dropdown-menu.dropdown-menu-subscription {
    width: 100%;
    min-width: 100%;
    max-height: 260px;
    overflow-y: auto;
    padding: 4px;
}
.automation-settings-select-dropdown-menu.dropdown-menu-subscription button {
    padding: 8px 10px;
    font-size: 13px;
    border-radius: 4px;
    justify-content: space-between;
}

.automation-settings-select-empty {
    padding: 10px 14px;
    font-size: 13px;
    color: #9ca3af;
}

/* Selected option ko checkmark + halka purple text se highlight karte h (select jaisa), aur
   locked (jese "Sessions Attribution") option ko disabled jaisa dikhate h. */
.automation-settings-select-dropdown-menu.dropdown-menu-subscription button.active {
    background: #693cac1e;
    color: #4c5fd5;
    font-weight: 500;
}
.automation-settings-select-dropdown-menu.dropdown-menu-subscription button:disabled {
    color: #9ca3af;
    cursor: not-allowed;
}
.automation-settings-select-dropdown-menu .automation-settings-select-check {
    flex-shrink: 0;
    margin-left: auto;
    color: #4c5fd5;
}
.automation-settings-select-dropdown-menu .automation-settings-select-lock {
    flex-shrink: 0;
    margin-left: auto;
}

.automation-settings-select-group-title {
    padding: 8px 14px 4px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #9ca3af;
}

.automation-settings-select-locked-action {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    border: none;
    border-top: 1px solid #e5e7eb;
    background: none;
    padding: 10px 14px;
    font-size: 13px;
    font-weight: 500;
    color: #5b4ddb;
    cursor: not-allowed;
}

/* Exit rules tab (and reused for Entry/Re-entry style "which option" choices): full-width
   radio cards stacked vertically, with the active one's nested content (checkboxes/segment
   picker/tags) rendered INSIDE the card, matching the OneSignal reference screenshots */
.automation-settings-radio-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 12px;
    cursor: pointer;
    background: #fff;
}

.automation-settings-radio-card.active {
    border-color: #5b4ddb;
}

.automation-settings-radio {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1.5px solid #d1d5db;
    flex-shrink: 0;
    margin-top: 2px;
}

.automation-settings-radio.checked {
    border-color: #5b4ddb;
    border-width: 5px;
}

.automation-settings-radio-title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
}

.automation-settings-radio-desc {
    font-size: 13px;
    color: #6b7280;
    margin-top: 2px;
}

.automation-settings-radio-card-body {
    margin-top: 14px;
    cursor: default;
}

.automation-settings-radio-card-body .form-check {
    margin-bottom: 10px;
}

/* Segment/tag chips (Exit rules "Enters a segment" + "Tag users when they exit early") */
.automation-settings-chip-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.automation-settings-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #eef0fd;
    color: #3f3fae;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 13px;
}

.automation-settings-chip-remove {
    cursor: pointer;
    flex-shrink: 0;
}

.automation-settings-chip-remove:hover {
    color: #1f1f6b;
}

/* "Previous" / "Next" pagination footer across all Automation Settings tabs - dono buttons
   LEFT side pe rakhe h (space-between se right wala "Next" button page ke bottom-right
   corner me chup jata tha, jaha chat-widget ka floating icon rehta h). */
.automation-settings-pagination {
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #e5e7eb;
    flex-shrink: 0;
}

/* Select Segment modal */
.automation-settings-modal-search {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #5b4ddb;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 12px;
    color: #9ca3af;
}

.automation-settings-modal-search input {
    border: none;
    outline: none;
    flex: 1 1;
    font-size: 14px;
    color: #111827;
}

.automation-settings-segment-list {
    max-height: 280px;
    overflow-y: auto;
}

.automation-settings-segment-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 4px;
    border-bottom: 1px solid #f1f2f6;
}

.automation-settings-segment-row-icon {
    display: inline-flex;
    color: #5b4ddb;
    flex-shrink: 0;
}

.automation-settings-segment-row-name {
    flex: 1 1;
    font-size: 14px;
    font-weight: 600;
    color: #111827;
}

.automation-settings-segment-row-add {
    border: none;
    background: none;
    color: #5b4ddb;
    display: inline-flex;
    cursor: pointer;
}

.automation-settings-segment-row-add:disabled {
    color: #d1d5db;
    cursor: default;
}

.automation-settings-modal-footnote {
    text-align: center;
    font-size: 13px;
    margin-top: 10px;
}

/* =========================
   CANVAS
========================= */

.automation-canvas {
    flex: 1 1;
    min-width: 0;
    min-height: 0;

    position: relative;

    background: #f8fafc;
}

.automation-canvas .react-flow {
    width: 100%;
    height: 100%;
}


/* =========================
   NODE
========================= */

.automation-node {
    position: relative;
    width: 220px;
    padding: 0;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    /* overflow:hidden hata diya - isse Handle circles (card edge pe half-in/half-out) aur
       ConditionNode ke Yes/No labels (card ke bahar bottom pe) clip ho jate the */
}

/* Har node card ke top-right wala "..." (three-dot) actions menu - Edit/Duplicate/Delete
   (Entrance/Exit pe sirf Edit) */
.node-actions-menu {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
}

.node-actions-toggle {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    line-height: 0;
    border-radius: 4px;
    border: 1px solid transparent;
    background: transparent;
    color: #9ca3af;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.node-actions-toggle:hover,
.node-actions-toggle:focus {
    background: #f3f4f6;
    color: #374151;
    border-color: #e5e7eb;
}
.node-actions-toggle::after {
    display: none; /* bootstrap ka default caret arrow yahan nahi chahiye, sirf dots icon */
}
.node-actions-toggle svg {
    width: 14px;
    height: 14px;
}


.node-actions-menu .dropdown-menu-subscription {
    width: 104px;
    margin-top: 4px;
}

/* Node card (220px chaudi) ke 3-dot menu ka dropdown card ke hisab se hi chota/compact hona
   chahiye - header ke "More options" wale dropdown se bhi aur zyada chota, isliye
   width/padding/font-size/icon-size yahan alag se override kiye h. */
.node-actions-dropdown-menu.dropdown-menu-subscription {
    padding: 0.1rem;
}
.node-actions-dropdown-menu.dropdown-menu-subscription button {
    padding: 0.22rem 0.3rem;
    font-size: 11px;
    gap: 5px;
}
.node-actions-dropdown-menu.dropdown-menu-subscription button > svg {
    width: 11px;
    height: 11px;
    min-width: 11px;
}
.node-actions-dropdown-menu.dropdown-menu-subscription .delete-class {
    padding-top: 0.3rem;
}

/* Automation Settings drawer ke left side wali tabs list (Entry rules / Re-entry rules /
   Schedule / Goals) - pehle raw inline style se banti thi (16px jesa default font, light-gray
   active background) jo bootstrap-size text jesa bada dikh raha tha; ab app ke purple theme
   se match karti compact class h. */
.automation-settings-tabs-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.automation-settings-tab-item {
    padding: 8px 10px;
    font-size: 13px;
    font-weight: 400;
    color: #4b5563;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}
.automation-settings-tab-item:hover {
    background: #693cac1e;
}
.automation-settings-tab-item.active {
    font-weight: 600;
    color: #4c5fd5;
    background: #4c5fd51a;
}

/* Drag-drop reorder: jis "+" edge ke paas card drop hoga vo highlight ho jayega */
.automation-edge-plus-btn.drop-target-active {
    background: var(--primary-color, #6366f1);
    border-color: var(--primary-color, #6366f1);
    color: #fff;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.4);
}
/* Jaise hi koi card drag hota h, HAR "+" apni jagah ek card-width rectangle drop-zone
   dikhata h (jaha bhi drop ho sakta h) - jo sabse nazdeek h vo ".active" se highlight ho jata h */
.automation-edge-drop-zone {
    width: 220px; /* .automation-node ke width (220px) ke barabar */
    height: 44px;
    border-radius: 10px;
    border: 2px dashed #c7cad9;
    background: rgba(148, 163, 184, 0.06);
    pointer-events: none;
    transition: border-color 0.15s ease, background 0.15s ease;
}
.automation-edge-drop-zone.active {
    border-color: var(--primary-color, #6366f1);
    background: rgba(99, 102, 241, 0.1);
}

/* Drag-drop reorder: jahan se card uthaya gaya h, vahan uski jagah card ke exact
   width/height ka ek dashed placeholder box dikhta h (jab tak drop nahi ho jata) */
.automation-drag-ghost {
    opacity: 0.55; /* OneSignal jesa - asli card jesa hi dikhega, bas thoda halka (placeholder) */
}

.automation-node-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 28px 10px 12px; /* right side .node-delete-btn (top-right) ke liye jagah */
    border-bottom: 1px solid #f1f1f1;
    border-radius: 4px 4px 0 0; /* overflow:hidden parent se hatane ke baad bhi top corners rounded rahe */
}

.automation-node-icon {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
}

.automation-node.entrance-node .automation-node-icon { background: #16a34a; }
.automation-node.exit-node .automation-node-icon     { background: #dc2626; }
.automation-node.send-node .automation-node-icon     { background: #4c5fd5; }
.automation-node.email-node .automation-node-icon    { background: #0891b2; }
.automation-node.in-app-node .automation-node-icon   { background: #7c3aed; }
.automation-node.sms-node .automation-node-icon      { background: #0d9488; }
.automation-node.wait-node .automation-node-icon     { background: #f59e0b; }
.automation-node.condition-node .automation-node-icon{ background: #ec4899; }

/* Condition node ke "Yes"/"No" branch tags - node card ke bottom se thoda neeche, chhoti
   pill/chip jaisi dikhe (plain text ki jagah) - OneSignal jese reference design se match
   karne ke liye. */
.automation-node-branch-label {
    position: absolute;
    bottom: -22px;
    transform: translateX(-50%);
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 1px 8px;
    font-size: 11px;
    font-weight: 500;
    color: #4b5563;
    white-space: nowrap;
}
/* PlusEdge ke andar Condition branch ke turn-point par "Yes"/"No" label - automation-node-branch-label
   jesa hi dikhta h, bas ab yeh edge ke actual turn-coordinate (turnX/turnY) par render hota h
   (parent transform already translate(x,y) kar deta h), isliye apna position/bottom nahi chahiye. */
.automation-edge-branch-label {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 1px 8px;
    font-size: 11px;
    font-weight: 500;
    color: #4b5563;
    white-space: nowrap;
    pointer-events: none;
}
.automation-node.tag-node .automation-node-icon      { background: #d97706; }
.automation-node.whatsapp-node .automation-node-icon { background: #25d366; }

.automation-node-body {
    padding: 10px 12px;
}

.automation-node-badge {
    display: inline-block;
    margin-top: 6px;
    padding: 2px 8px;
    border-radius: 4px;
    background: #fef3c7;
    color: #92400e;
    font-size: 11px;
}


/* =========================
   NODE TYPES
========================= */

/* Node type ka color sirf header icon badge se dikhta h (NODE_TYPE_ICONS backgrounds) -
   card border sabhi types me same (plain gray) rakha h taki consistent dikhe; selected hone pe
   React Flow ki apni default highlight (blue outline) lagti h, vo bhi sabhi types pe equally. */


/* =========================
   NODE CONFIG PANEL
========================= */

.node-config-panel {
    width: 280px;
    min-width: 280px;

    padding: 18px;

    background: #ffffff;

    border-left: 1px solid #e5e7eb;

    overflow-y: auto;
}

.node-config-panel h5 {
    margin: 0;

    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
}

.node-config-panel .d-flex {
    margin-bottom: 20px;
}

.node-config-panel .d-flex button {
    border: 0;
    background: transparent;

    font-size: 20px;

    cursor: pointer;
}

.node-config-panel label {
    display: block;

    margin: 14px 0 6px;

    font-size: 13px;
    font-weight: 500;

    color: #374151;
}

.node-config-panel input,
.node-config-panel select {
    width: 100%;

    padding: 8px 10px;

    border: 1px solid #d1d5db;
    border-radius: 6px;

    font-size: 13px;

    outline: none;
}

.node-config-panel input:focus,
.node-config-panel select:focus {
    border-color: #3b82f6;
}


/* =========================
   REACT FLOW CONTROLS
========================= */

.automation-canvas .react-flow__controls {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.automation-canvas .react-flow__minimap {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    overflow: hidden;
}


/* =========================
   CONNECTION
========================= */

.automation-canvas .react-flow__edge-path {
    stroke-width: 2;
}

.automation-canvas .react-flow__handle {
    width: 8px;
    height: 8px;
}


/* =========================
   MOBILE / SMALL SCREEN
========================= */

@media (max-width: 900px) {

    .automation-sidebar {
        width: 150px;
        min-width: 150px;
        padding: 10px;
    }

    .node-config-panel {
        width: 240px;
        min-width: 240px;
    }

}




/* Live per-node enrollment count badge (Automation Builder) - top-left corner of a message/wait/
   condition card, opposite the "..." actions menu. Clickable: opens the user list behind it. */
/* Body row that holds the card's own text on the left + the live user-count badge on the
   right (bottom of the card, next to whatever text already shows there) - flex, not absolute
   positioning, so the badge sits inline with the text instead of floating over the card. */
.automation-node-body-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}
.automation-node-body-row > *:first-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.automation-node-user-count-badge {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 1px 6px;
    border-radius: 999px;
    border: 1px solid #bfdbfe;
    background: #eff6ff;
    color: #1d4ed8;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
}
.automation-node-user-count-badge:hover {
    background: #dbeafe;
    border-color: #93c5fd;
}
.automation-node-user-count-wrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
}
.automation-node-user-error-badge {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 1px 6px;
    border-radius: 999px;
    border: 1px solid #fecaca;
    background: #fef2f2;
    color: #b91c1c;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
}
.automation-node-user-error-badge:hover {
    background: #fee2e2;
    border-color: #fca5a5;
}

/* Invisible merge point that closes an automation Condition block (JoinNode in AutomationBuilder.js) */
.automation-join-node {
    width: 2px;
    height: 2px;
    background: transparent;
    pointer-events: none;
}
.automation-join-node .react-flow__handle {
    opacity: 0;
    width: 2px;
    height: 2px;
    min-width: 0;
    min-height: 0;
    border: 0;
    top: 0;
    bottom: auto;
}
.automation-join-node .react-flow__handle-bottom {
    top: auto;
    bottom: 0;
}

/* ---- Automation: failed pre-launch check highlight ---- */
.react-flow__node.automation-node-has-error .automation-node {
  border: 2px solid #dc2626 !important;
  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.15), 0 4px 12px rgba(220, 38, 38, 0.18);
  animation: automation-error-pulse 1.4s ease-in-out 3;
}
@keyframes automation-error-pulse {
  0%, 100% { box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.15), 0 4px 12px rgba(220, 38, 38, 0.18); }
  50% { box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.25), 0 4px 12px rgba(220, 38, 38, 0.25); }
}
.automation-setlive-checklist li.is-clickable { cursor: pointer; }
.automation-setlive-checklist li.is-clickable:hover { background: rgba(220, 38, 38, 0.06); }
.automation-setlive-checklist-goto {
  display: block;
  margin-top: 2px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #dc2626;
}

/* ---- Automation: view-only (live / ended / archived) ---- */
.automation-readonly-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 8px;
  padding: 10px 14px;
  border: 1px solid #fcd9a6;
  background: #fff8ec;
  color: #7a4a05;
  border-radius: 8px;
  font-size: 0.85rem;
}
.automation-readonly-note {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 0.8rem;
}
.automation-readonly-fieldset {
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
}

/* ============================================================
   Engage → Funnel (components/engage/FunnelAnalysis.js)
   KPI tiles reuse .campaign-summary-*, chips reuse .badge.bg-light-*,
   buttons reuse .btn_theme_*, help icons reuse HelpTooltip.
   Theme: primary #4346ce, ink #1a2332, muted #6b7785, border #e8ecf1.
   ============================================================ */


.funnel-card {
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    padding: 18px 20px;
    margin-bottom: 16px;
}

.funnel-card-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 14px;
}

.funnel-card-head h2 {
    font-size: 16px;
    font-weight: 600;
    color: #1a2332;
    margin: 0;
}

.funnel-card-head p {
    margin: 2px 0 0;
    font-size: 13px;
    color: #6b7785;
}

/* ---- step builder ---- */

.funnel-steps {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 8px;
}

.funnel-step {
    flex: 1 1 200px;
    max-width: 280px;
    min-width: 190px;
    border: 1px solid #e8ecf1;
    border-radius: 10px;
    padding: 10px;
    background: #fff;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.funnel-step:hover,
.funnel-step:focus-within {
    border-color: #4346ce;
    box-shadow: 0 0 0 3px #eef0fc;
}

.funnel-step--empty {
    background: #fbfcfe;
}

.funnel-step-top {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.funnel-step-num {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #4346ce;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 22px;
    min-width: 22px;
    padding: 0 !important;
    line-height: 1;
    box-sizing: border-box;
}

.funnel-step-label {
    font-size: 12px;
    font-weight: 500;
    color: #6b7785;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.funnel-step-actions {
    margin-left: auto;
    display: flex;
    gap: 2px;
}

.funnel-step-actions button {
    border: none;
    background: none;
    color: #6b7785;
    width: 26px;
    height: 26px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.funnel-step-actions button:hover:not(:disabled) {
    background: #f4f6fa;
    color: #1a2332;
}

.funnel-step-actions button:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.funnel-step-arrow {
    display: flex;
    align-items: center;
    color: #b4bccb;
    font-size: 20px;
}

.funnel-step-add {
    flex: 0 0 auto;
    min-width: 130px;
    border: 1.5px dashed #c9cfdc;
    border-radius: 10px;
    background: none;
    color: #4346ce;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 14px;
}

.funnel-step-add:hover {
    border-color: #4346ce;
    background: #eef0fc;
}

.funnel-error {
    margin-top: 8px;
    font-size: 13px;
    color: #b42318;
}

.funnel-settings {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    align-items: end;
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid #e8ecf1;
}

.funnel-setting label,
.funnel-more label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    color: #6b7785;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 6px;
}

.funnel-setting--actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
}

.funnel-setting--actions .btn_theme_secondary,
.funnel-setting--actions .btn_theme_primary {
    gap: 6px;
    min-height: 38px;
}

.funnel-more-toggle {
    margin-top: 14px;
    border: none;
    background: none;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #4346ce;
    font-weight: 500;
    font-size: 14px;
}

.funnel-more-toggle svg:last-child {
    transition: transform 0.2s;
}

.funnel-more-toggle svg.open {
    transform: rotate(180deg);
}

.funnel-more {
    padding-top: 12px;
}

/* segmented control (step order + users modal tabs) */
.funnel-seg {
    display: inline-flex;
    flex-wrap: wrap;
    background: #f4f6fa;
    border: 1px solid #e8ecf1;
    border-radius: 8px;
    padding: 3px;
    gap: 2px;
    margin-bottom: 14px;
}

.funnel-seg--inline {
    display: flex;
    margin-bottom: 0;
}

.funnel-seg--inline button {
    flex: 1 1;
}

.funnel-seg button {
    border: none;
    background: none;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 14px;
    color: #6b7785;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 30px;
}

.funnel-seg button.active {
    background: #fff;
    color: #4346ce;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
}

/* ---- results ---- */

.funnel-results.is-loading {
    opacity: 0.55;
    pointer-events: none;
    transition: opacity 0.2s;
}

.funnel-applied {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.funnel-applied-path {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    color: #1a2332;
    margin-right: 6px;
}

.funnel-applied-path svg {
    color: #b4bccb;
}

.funnel-page .campaign-summary-row {
    margin-bottom: 16px;
}

.funnel-page .campaign-summary-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.funnel-meter {
    display: flex;
    align-items: center;
    gap: 10px;
}

.funnel-meter span {
    min-width: 48px;
    text-align: right;
    font-size: 13px;
    color: #1a2332;
}

.funnel-meter-bar {
    flex: 1 1;
    height: 6px;
    border-radius: 6px;
    background: #f4f6fa;
    overflow: hidden;
}

.funnel-meter-bar i {
    display: block;
    height: 100%;
    background: #4346ce;
    border-radius: 6px;
}

.funnel-insight {
    background: #eef0fc;
    border: 1px solid #dcdffa;
    border-radius: 10px;
    padding: 12px 16px;
    color: #1a2332;
    font-size: 14px;
    line-height: 1.55;
    margin-bottom: 16px;
}

/* ---- chart ---- */

.funnel-chart {
    position: relative;
    padding-left: 44px;
}

.funnel-chart-plot {
    position: relative;
    height: 300px;
    margin-top: 36px;
}

.funnel-chart-yaxis span {
    position: absolute;
    left: -44px;
    width: 36px;
    text-align: right;
    font-size: 11px;
    color: #98a2b3;
    transform: translateY(50%);
}

.funnel-chart-grid i {
    position: absolute;
    left: 0;
    right: 0;
    height: 0;
    border-top: 1px solid #eef1f5;
}

.funnel-chart-grid i:first-child,
.funnel-chart-grid i:last-child {
    border-top-color: #e3e7ee;
}

.funnel-chart-cols {
    position: absolute;
    inset: 0;
    display: grid;
    gap: 2px;
}

.funnel-col {
    position: relative;
    display: flex;
    justify-content: center;
}

.funnel-col-track {
    position: absolute;
    top: 0;
    bottom: 0;
    width: min(64%, 120px);
}

.funnel-col-bar,
.funnel-col-drop {
    position: absolute;
    left: 0;
    right: 0;
    border: none;
    padding: 0;
    cursor: pointer;
}

.funnel-col-bar {
    bottom: 0;
    background: #4346ce;
    border-radius: 4px 4px 0 0;
    transition: background 0.15s;
}

.funnel-col-bar.is-hover,
.funnel-col-bar:focus-visible {
    background: #3a3db3;
    outline: none;
}

.funnel-col-drop {
    background: repeating-linear-gradient(135deg, #d9dde8 0 2px, #f4f6fa 2px 7px);
    border-radius: 4px 4px 0 0;
    /* 2px surface gap between the drop-off area and the reached bar */
    box-shadow: inset 0 -2px 0 #fff;
}

.funnel-col-drop.is-hover,
.funnel-col-drop:focus-visible {
    background: repeating-linear-gradient(135deg, #bfc5d4 0 2px, #eceff5 2px 7px);
    outline: none;
}

.funnel-col-value {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    line-height: 1.15;
    pointer-events: none;
}

.funnel-col-value strong {
    display: block;
    font-size: 15px;
    color: #1a2332;
}

.funnel-col-value span {
    font-size: 12px;
    color: #6b7785;
}

.funnel-col-conv {
    position: absolute;
    left: 0;
    bottom: 8px;
    transform: translateX(-50%);
    z-index: 2;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 999px;
    padding: 2px 8px 2px 6px;
    font-size: 12px;
    font-weight: 600;
    color: #1a2332;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
    white-space: nowrap;
}

.funnel-col-conv svg {
    color: #4346ce;
}

.funnel-chart-labels {
    display: grid;
    gap: 2px;
    margin-top: 10px;
}

.funnel-chart-label {
    text-align: center;
    min-width: 0;
    padding: 0 4px;
}

.funnel-chart-label small {
    display: block;
    font-size: 11px;
    color: #98a2b3;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.funnel-chart-label strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #1a2332;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.funnel-legend {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #e8ecf1;
    font-size: 13px;
    color: #475467;
}

.funnel-legend span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.funnel-legend-swatch {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 3px;
}

.funnel-legend-swatch--reached {
    background: #4346ce;
}

.funnel-legend-swatch--drop {
    background: repeating-linear-gradient(135deg, #d9dde8 0 2px, #f4f6fa 2px 5px);
    border: 1px solid #d0d5e0;
}


.funnel-tip {
    position: absolute;
    z-index: 5;
    width: 240px;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.14);
    padding: 10px 12px;
    pointer-events: none;
    font-size: 13px;
}

.funnel-tip-title {
    font-weight: 600;
    color: #1a2332;
    margin-bottom: 6px;
}

.funnel-tip-row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    color: #6b7785;
    line-height: 1.7;
}

.funnel-tip-row strong {
    color: #1a2332;
}


/* ---- step breakdown table + users modal table ---- */

.funnel-users-table {
    margin: 0;
    font-size: 14px;
}

.funnel-users-table th {
    font-size: 12px;
    font-weight: 500;
    color: #6b7785;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    border-bottom: 1px solid #e8ecf1;
    background: #fafbfc;
    white-space: nowrap;
}

.funnel-users-table td {
    vertical-align: middle;
    border-bottom: 1px solid #f0f2f5;
    color: #1a2332;
}

.funnel-table-step {
    display: flex;
    align-items: center;
    gap: 10px;
}

.funnel-table-actions {
    white-space: nowrap;
}

.funnel-link {
    border: none;
    background: none;
    padding: 0;
    margin-left: 14px;
    color: #4346ce;
    font-weight: 500;
    font-size: 13px;
}

.funnel-link:hover:not(:disabled) {
    text-decoration: underline;
}

.funnel-link--muted {
    color: #475467;
}

.funnel-link:disabled {
    color: #c0c6d1;
    cursor: not-allowed;
}

.funnel-users-sub {
    display: block;
    font-size: 13px;
    font-weight: 400;
    color: #6b7785;
    margin-top: 2px;
}

.funnel-user {
    display: flex;
    align-items: center;
    gap: 10px;
}

.funnel-user-name {
    font-weight: 500;
    color: #1a2332;
}

.funnel-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #eef0fc;
    color: #4346ce;
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
}

.funnel-avatar--anon {
    background: #f2f4f7;
    color: #98a2b3;
}

.funnel-dots {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: help;
}

.funnel-dots i {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #e4e7ec;
}

.funnel-dots i.on {
    background: #4346ce;
}

.funnel-dots small {
    margin-left: 4px;
    color: #6b7785;
}

/* ---- empty states ---- */

.funnel-empty {
    text-align: center;
    padding: 40px 20px;
    color: #6b7785;
}

.funnel-empty h3 {
    font-size: 16px;
    font-weight: 600;
    color: #1a2332;
    margin: 12px 0 6px;
}

.funnel-empty p {
    max-width: 460px;
    margin: 0 auto;
    font-size: 14px;
}

.funnel-empty--sm {
    padding: 28px 10px;
}

.funnel-empty-art {
    width: 150px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.funnel-empty-art span {
    display: block;
    height: 14px;
    border-radius: 4px;
    background: #4346ce;
    opacity: 0.85;
}

.funnel-empty-art span:nth-child(2) {
    opacity: 0.55;
}

.funnel-empty-art span:nth-child(3) {
    opacity: 0.3;
}

/* ---- responsive ---- */

@media (max-width: 992px) {
    .funnel-settings {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .funnel-step-arrow {
        display: none;
    }
}

@media (max-width: 768px) {
    .funnel-settings {
        grid-template-columns: 1fr;
    }

    .funnel-setting--actions .btn_theme_primary,
    .funnel-setting--actions .btn_theme_secondary {
        width: 100%;
    }

    .funnel-step {
        max-width: none;
    }

    .funnel-chart-plot {
        height: 240px;
    }

    .funnel-col-value strong {
        font-size: 13px;
    }

}

.funnel-label-val {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: #6b7785;
}

.funnel-label-val b {
    font-size: 14px;
    color: #1a2332;
}

.funnel-step--dup {
    border-color: #e5484d;
    box-shadow: 0 0 0 3px rgba(229, 72, 77, 0.12);
}

.funnel-steps .funnel-step-arrow {
    flex: 0 0 auto;
}

.funnel-table-actions {
    white-space: nowrap;
    padding-right: 72px;
}

.funnel-steps--many .funnel-step-arrow {
    display: none;
}

@media (max-width: 576px) {
    .funnel-col-conv {
        display: none;
    }
}

/* ---- Engage → Funnel: saved funnels (FunnelList.js + name/description on FunnelAnalysis.js) ---- */
.funnel-meta {
    margin-bottom: 14px;
}

.funnel-meta label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    color: #6b7785;
    margin-bottom: 4px;
}

.funnel-dirty-badge {
    margin-left: 10px;
    font-size: 11px;
    font-weight: 500;
    vertical-align: middle;
}

.funnel-list-steps {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    max-width: 420px;
}

.funnel-list-steps-arrow {
    color: #b4bccb;
    flex: 0 0 auto;
}

.funnel-kpi-sub {
  margin-top: 2px;
  font-size: 13px;
  color: #6b7280;
}

/* Table cells force \`span { display:block }\` — keep the step number a centred circle */
table.table_outer .funnel-step-num {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    line-height: 1;
}

.funnel-users-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: nowrap;
}

.funnel-next-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    font-size: 13px;
    color: #475467;
}

.funnel-segment-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 12px;
}

.funnel-actions-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 14px;
}

.funnel-actions-row .funnel-more-toggle {
    margin-top: 0;
}

/* A step can hold several events: keep the step cards the same height and let the chips wrap inside */
.funnel-step .ns-funnel-step__control {
    min-height: 40px;
}

.funnel-step .ns-funnel-step__multi-value {
    max-width: 100%;
}

.funnel-applied-label {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #6b7785;
}

.funnel-path {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    min-width: 260px;
    max-width: 460px;
}

.funnel-path-chip {
    padding: 2px 8px;
    border-radius: 999px;
    background: #f2f4f7;
    color: #475467;
    font-size: 12px;
    white-space: nowrap;
}

.funnel-path-chip--step {
    background: #eef0ff;
    color: #3f3fbf;
    font-weight: 600;
}

.funnel-path-arrow,
.funnel-path-more {
    color: #98a2b3;
    font-size: 12px;
}


/* DateRangePicker: portaled panel always stays reachable - scrolls inside itself when the window is short */
.ns-daterange__popover.ns-daterange__popover--portal {
  max-height: calc(100vh - 24px);
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;;AAGA,gCAAgC;AAChC;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;;;IAGI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;8DAG8D;AAC9D;IACI,+CAA+C;IAC/C,qDAAqD;IACrD,yCAAyC;IACzC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI,qBAAqB;IACrB,oEAAoE;AACxE;;AAEA,2BAA2B;AAC3B;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;IAC3C,yCAAyC;IACzC,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;;AAEpC;;AAEA;;;;;;;;;;;;GAYG;;;;AAIH,mCAAmC;AACnC;;;IAGI,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;;;GAGG;;AAEH;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;;AAGA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;AAC7B;;;AAGA,wBAAwB;AACxB;;;;;;;;;;;;;;GAcG;;AAEH;IACI,YAAY;IACZ,aAAa;IACb,yDAAsC;IACtC,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;;AAGA;;;;;;;;;;GAUG;;AAEH;IACI,aAAa;IACb,UAAU;IACV,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;;;;;;;AAQA,cAAc;;;AAGd;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;IAEb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAE9B,8BAA8B;IAC9B,WAAW;IACX,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,0FAA0F;IAC1F,YAAY;IACZ,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IAEtB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;IACf;AACJ;;AAEA;IACI,SAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IAEtB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;IACf;AACJ;;AAEA;IACI,SAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;;;AAIA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IAEnB,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;IACV,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,oCAAoC;IACpC,qBAAqB;IACrB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;;;AAIA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;;GAKG;;AAEH;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,qBAAqB;IACrB,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;AACxC;;;;;AAKA;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;;;AAIA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,QAAQ;IACR,sBAAsB;IACtB,4GAA4G;AAChH;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oEAAoE;IACpE,uDAAuD;IACvD,0EAA0E;IAC1E,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,QAAQ;IAER,uBAAuB;IAEvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IAEpB,uBAAuB;IAEvB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,cAAc;IACd,YAAY;IACZ,iGAAiG;AACrG;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,wBAAwB;IACxB,oCAAoC;IACpC,0FAA0F;IAC1F,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IAEX,sBAAsB;IAEtB,oBAAoB;IACpB,WAAW;IACX,sBAAsB;IACtB,4JAA4J;IAC5J,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,qBAAqB;IACrB,oCAAoC;IACpC,kCAAkC;IAClC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,WAAW;IAEX,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IAET,sBAAsB;IAEtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;IAC9B,WAAW;IACX,SAAY;IACZ,8EAA8E;AAClF;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,4JAA4J;IAC5J,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,qBAAqB;IACrB,YAAY;IACZ,yCAAyC;IACzC,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,qBAAqB;IACrB,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IAER,sBAAsB;IAEtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,kCAAkC;IAClC,qBAAqB;IACrB,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IAER,uBAAuB;IAEvB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,4JAA4J;IAC5J,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IAEpB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,cAAc;AACd;IACI,4GAA4G;IAC5G,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IAEtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IAEpB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,0BAA0B;IAE1B,uBAAuB;AAC3B;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,0FAA0F;IAC1F,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IAEX,sBAAsB;IAEtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,4JAA4J;IAC5J,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IAEZ,uBAAuB;IAEvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,qBAAqB;IACrB,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IAEX,sBAAsB;IAEtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,4JAA4J;IAC5J,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;IAEb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,4JAA4J;IAC5J,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,UAAU;AACd;;AAEA,cAAc;AACd;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmLG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoDG;AACH;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,qBAAqB;IACrB,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4JAA4J;IAC5J,eAAe;IACf,oCAAoC;IACpC,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,yBAAyB;IACzB,oCAAoC;IACpC,4JAA4J;IAC5J,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,4JAA4J;IAC5J,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;;;;;;;;;;;;;;;;AAiBA,gBAAgB;;AAEhB,iGAAiG;AACjG;IACI;QACI,aAAa;QACb,2CAA2C;QAC3C,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA,wEAAwE;AACxE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,qCAAqC;IACrC,sBAAsB;IACtB,0CAA0C;IAC1C,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,8EAA8E;AAC9E;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,aAAa;IACb,SAAS;IACT,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,eAAe;AACnB;;AAEA,yDAAyD;AACzD;IACI;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,4JAA4J;IAC5J,eAAe;IACf;;wEAEoE;IACpE,yBAAyB;IACzB,gCAAgC;IAChC,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,QAAQ;QACR,SAAS;QACT,WAAW;QACX,WAAW;QACX,UAAU;QACV,iBAAiB;QACjB,mFAAmF;QACnF,mBAAmB;QACnB,+BAA+B;IACnC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IAEnB,8BAA8B;IAC9B,WAAW;IACX,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI;QAEI,2BAA2B;QAC3B,sBAAsB;QACtB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IAEnB,mBAAmB;IAEnB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,oBAAoB;QACpB,kBAAkB;QAClB,SAAS;QACT,cAAc;QACd,QAAQ;QACR,0BAA0B;QAC1B,aAAa;QACb,WAAW;QACX,YAAY;QACZ,UAAU;QACV,SAAS;QACT,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,cAAc;QACd,cAAc;QACd,gBAAgB;QAChB,yBAAyB;QACzB,kBAAkB;QAClB,2CAA2C;QAC3C,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;AAEJ;;AAEA;IAEI,mBAAmB;IACnB,aAAa;IAEb,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;IACzB;;+DAE2D;IAC3D,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,aAAa;IACb,eAAe;IACf,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb;oFAC4E;QAC5E,mBAAmB;QACnB,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,WAAW;QACX,sBAAsB;QACtB;;;;;;8DAMsD;QACtD,SAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAEhB,2BAA2B;QAC3B;;;sGAG8F;QAC9F,kBAAkB;QAClB,+BAA+B;QAC/B,wBAAwB;QACxB,qBAAqB;QACrB,kDAAkD;IACtD;AACJ;;AAEA;IACI;QACI,oBAAoB;QAEpB,mBAAmB;QACnB,iBAAiB,EAAE,uEAAuE;QAC1F,uBAAuB;IAC3B;AACJ;;AAEA;;;qEAGqE;AACrE;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IAEb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yDAAyD;AAC7D;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;;iFAEiF;AACjF;;IAEI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,yCAAyC;AAC7C;;AAEA,4FAA4F;AAC5F;;IAEI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,4CAA4C;IAC5C,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,kDAAkD;AAClD;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,cAAc,EAAE,gGAAgG;IAChH,mBAAmB;IAEnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;QAEnB,8BAA8B;QAE9B,mBAAmB;QACnB,WAAW;QACX,oBAAoB;IACxB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,wCAAwC;IACxC,qBAAqB;IACrB,WAAW;IACX,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI;;QAEI,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;QACvB,cAAc;QACd,eAAe;QACf,eAAe;QACf,cAAc;QACd,6BAA6B;QAC7B,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;;QAEI,cAAc;QACd,wCAAwC;IAC5C;;IAEA;4EACwE;IACxE;QACI,aAAa;QACb,6BAA6B;IACjC;;IAEA;QACI,0CAA0C;QAC1C,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,kFAAkF;IAClF,yBAAyB;IACzB,mBAAmB;IACnB,0FAA0F;AAC9F;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,gDAAgD;QAChD,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IAEtB,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI;QACI,mBAAmB;QAEnB,8BAA8B;IAClC;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IAEX,YAAY;AAChB;;AAEA;IACI;QACI,mBAAmB;QAEnB,2BAA2B;QAC3B,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,uBAAuB;QAEvB,yBAAyB;QACzB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,qBAAqB;IACrB,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA,uEAAuE;AACvE;;IAEI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,0FAA0F;IAC1F,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA,2FAA2F;AAC3F;IACI,UAAU;IACV,qBAAqB;IACrB,oCAAoC;IACpC,0FAA0F;IAC1F,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IAEb,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA,kHAAkH;AAClH;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,SAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA,+EAA+E;AAC/E;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,8BAA8B;AAClC;;AAEA,mDAAmD;AACnD;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,iCAAiC;IACjC,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;IAC3C,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IAEpB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IAEpB,uBAAuB;IAEvB,mBAAmB;IACnB,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,wCAAwC;IACxC,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;;;8DAG8D;AAC9D;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,UAAU;IACV,qBAAqB;IACrB,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;IACvB,6CAA6C;IAC7C,yGAAyG;AAC7G;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;IAEI,yBAAyB;IACzB,8BAA8B;IAC9B,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,yBAAyB;IACzB,0FAA0F;AAC9F;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA,gEAAgE;AAChE;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,8CAA8C;AAC9C;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA,mFAAmF;AACnF;;IAEI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA,0CAA0C;AAC1C;;IAEI,gBAAgB;IAChB,QAAQ;AACZ;;AAEA,wDAAwD;AACxD;;IAEI,yCAAyC;IACzC,8CAA8C;IAC9C,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA,sFAAsF;AACtF;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,8EAA8E;AAC9E;;IAEI,6BAA6B;AACjC;;AAEA,mDAAmD;AACnD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,yCAAyC;IACzC,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,yCAAyC;IACzC,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,yCAAyC;IACzC,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,oCAAoC;IACpC,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB,EAAE;;+FAEmE;IAC3F,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA,+FAA+F;AAC/F;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;;;;;AAMA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,yCAAyC;IACzC,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;;AAGA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;;;;;;;;;AAUA,4DAA4D;AAC5D;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,iCAAiC;AACrC;;AAEA,mEAAmE;AACnE;IACI,yBAAyB;IACzB,gDAAgD;IAChD,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,sFAAsF;AACtF;IACI,2BAA2B;IAC3B,4CAA4C;IAC5C,YAAY;IACZ,uBAAuB;AAC3B;;;;;;;;;;;;;;;;AAgBA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAElB,gCAAgC;IAChC,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,wFAAwF;AAC5F;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,+CAA+C;IAC/C,aAAa;AACjB;;AAEA,yFAAyF;AACzF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IAEb,uBAAuB;IAEvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IAEb,uBAAuB;IAEvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA,6FAA6F;AAC7F;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,yBAAyB;QACzB,mBAAmB;QACnB,kDAAkD;QAClD,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,OAAO;QACP,WAAW;QACX,uBAAuB;QACvB,6BAA6B;QAC7B,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;QAClC,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gEAAgE;AACpE;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,8EAA8E;IAC9E,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,SAAS;IACT,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,SAAO;AACX;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,uBAAuB;QACvB,SAAO;IACX;AACJ;;;;;;;AAOA,YAAY;;;AAGZ;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,0FAA0F;IAC1F,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,qBAAqB;IACrB,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IAEtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,oCAAoC;IACpC,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;IACV,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;;;;;;;;AASA,qBAAqB;;AAErB;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IAEb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAE9B,8BAA8B;IAC9B,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,0FAA0F;IAC1F,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,SAAO;IACP,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,WAAW;IACX,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8SG;;AAEH,WAAW;AACX;;;;;;;;;;;;;;;;;;;CAmBC;;AAED;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,oCAAoC;IACpC,qBAAqB;IACrB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;AACb;;;;;;AAMA;IACI,aAAa;IAEb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IAEpB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,aAAa;IAEb,8BAA8B;IAE9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,oCAAoC;IACpC,qBAAqB;IACrB,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;;;;AAKA,eAAe;AACf;IACI,aAAa;IACb,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,oCAAoC;IACpC,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,oCAAoC;IACpC,qBAAqB;IACrB,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,sHAAsH;AACtH;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,kCAAkC;IAClC,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd;;;AAGA;IACI,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB,EAAE,qDAAqD;IACzE,cAAc;IACd,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA,yGAAyG;AACzG;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,aAAa;AACjB;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB;;AAEA,2GAA2G;AAC3G;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yFAAyF;AACzF;IACI,wBAAwB;IACxB,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;;;;;;;;;AAWA,cAAc;;;AAGd;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,0FAA0F;IAC1F,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IAEnB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;QAEI,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,4JAA4J;IAC5J,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IAEpB,uBAAuB;IAEvB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IAEtB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI;QAEI,mBAAmB;QAEnB,8BAA8B;QAC9B,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;IAEpB,mBAAmB;IAEnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,oCAAoC;IACpC,qBAAqB;IACrB,oCAAoC;IACpC,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,oCAAoC;IACpC,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;;IAEI,kCAAkC;IAClC,8BAA8B;IAC9B,oCAAoC;AACxC;;;AAGA;;IAEI,0BAA0B;IAC1B,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;;;;;;;;;AAUA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA,8DAA8D;AAC9D;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,8DAA8D;AAC9D;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,SAAO;IACP,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;;;AAIA,kBAAkB;AAClB;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,wEAAwE;AACxE;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,kCAAkC;IAClC,kCAAkC;IAClC,0FAA0F;IAC1F,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,oCAAoC;IACpC,oCAAoC;IACpC,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mFAAmF;AACnF;;;;IAII,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;;;8DAI8D;AAC9D;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,qGAAqG;AACrG;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,oFAAoF;AACpF;;;;;;;IAOI,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,wFAAwF;AACxF;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,8BAA8B;IAC9B,oCAAoC;IACpC,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,sFAAsF;IACtF,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gDAAgD;IAChD,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;kFACkF;;AAElF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,6EAA6E;AAC/E;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,6EAA6E;EAC7E,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,oEAAoE;AACpE;;;EAIE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,8BAA8B;EAC9B,wBAAwB;EACxB,sEAAsE;AACxE;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,2GAA2G;EAC3G,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,gHAAgH;EAChH,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;;;;;;;IAQE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yDAAkU;IAClU,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gCAAgC;QAChC,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6EAA6E;EAC7E,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;;EAEE,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4EAA4E;EAC5E,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,0FAA0F;AAC1F;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;EAGE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,SAAO;EACP,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,wFAAwF;AACxF;EACE,yBAAyB;AAC3B;;;;AAIA;IACI,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;2BAE2B;;AAE3B;IACI,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;;IAEhC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;2BAE2B;;AAE3B;IACI,kBAAkB;IAClB,SAAO;IACP,aAAa;;IAEb,aAAa;;IAEb,gBAAgB;AACpB;;;AAGA;;2BAE2B;;AAE3B;IACI,kBAAkB;IAClB,mBAAmB;;IAEnB,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA,uCAAuC,mBAAmB,EAAE;AAC5D;IACI,WAAW,EAAE,YAAY,EAAE,kBAAkB;IAC7C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,WAAW,EAAE,cAAc,EAAE,eAAe;AAChD;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,cAAc;IACd,sCAAsC;IACtC,iFAAiF;AACrF;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,6CAA6C;AACjD;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,gBAAgB,EAAE,kEAAkE;AACxF;;AAEA;;2BAE2B;;AAE3B;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,gCAAgC;IAChC,kBAAkB;IAClB,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;;;AAIA;;2BAE2B;;AAE3B;IACI;;;iGAG6F;IAC7F,gCAAgC;IAChC,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;;;;uDAIuD;AACvD;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;;;;;IAKI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;;oFAEoF;AACpF;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;;AAEA;;mDAEmD;AACnD;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;AACA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;+EAC+E;AAC/E;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;gGACgG;AAChG;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;yEACyE;AACzE;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,qEAAqE;AACrE;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;8FAC8F;AAC9F;IACI,wBAAwB;AAC5B;;AAEA,4DAA4D;AAC5D;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,wFAAwF;AACxF;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;2FAI2F;AAC3F;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;6EAC6E;AAC7E;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;wFAEwF;AACxF;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yFAAyF;AACzF;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;yEAEyE;AACzE;IACI,aAAa;IACb,2BAA2B;IAC3B,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAO;IACP,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;2BAE2B;;AAE3B;IACI,SAAO;IACP,YAAY;IACZ,aAAa;;IAEb,kBAAkB;;IAElB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;;2BAE2B;;AAE3B;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf;kFAC8E;AAClF;;AAEA;iCACiC;AACjC;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,4EAA4E;AAChF;AACA;;IAEI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,aAAa,EAAE,wEAAwE;AAC3F;AACA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;;qEAEqE;AACrE;IACI,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,QAAQ;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA;;;oCAGoC;AACpC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mDAAmD;AACvD;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA,kFAAkF;AAClF;IACI,yCAAyC;IACzC,2CAA2C;IAC3C,WAAW;IACX,6CAA6C;AACjD;AACA;kGACkG;AAClG;IACI,YAAY,EAAE,iDAAiD;IAC/D,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,qCAAqC;IACrC,oBAAoB;IACpB,0DAA0D;AAC9D;AACA;IACI,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;mFACmF;AACnF;IACI,aAAa,EAAE,8EAA8E;AACjG;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,4BAA4B,EAAE,0DAA0D;IACxF,gCAAgC;IAChC,0BAA0B,EAAE,0EAA0E;AAC1G;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;AAClB;;AAEA,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;;AAE5E;;mBAEmB;AACnB;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AACA;;oGAEoG;AACpG;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;AACA,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;;AAE5E;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;;AAGA;;2BAE2B;;AAE3B;;gGAEgG;;;AAGhG;;2BAE2B;;AAE3B;IACI,YAAY;IACZ,gBAAgB;;IAEhB,aAAa;;IAEb,mBAAmB;;IAEnB,8BAA8B;;IAE9B,gBAAgB;AACpB;;AAEA;IACI,SAAS;;IAET,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,uBAAuB;;IAEvB,eAAe;;IAEf,eAAe;AACnB;;AAEA;IACI,cAAc;;IAEd,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;;IAEI,WAAW;;IAEX,iBAAiB;;IAEjB,yBAAyB;IACzB,kBAAkB;;IAElB,eAAe;;IAEf,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;AACzB;;;AAGA;;2BAE2B;;AAE3B;IACI,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;2BAE2B;;AAE3B;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;;AAGA;;2BAE2B;;AAE3B;;IAEI;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;AAEJ;;;;;AAKA;+FAC+F;AAC/F;;2FAE2F;AAC3F;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,0DAA0D;AAC9D;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,0DAA0D;AAC9D;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,uGAAuG;AACvG;IACI,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,SAAS;IACT,MAAM;IACN,YAAY;AAChB;AACA;IACI,SAAS;IACT,SAAS;AACb;;AAEA,4DAA4D;AAC5D;EACE,oCAAoC;EACpC,iFAAiF;EACjF,oDAAoD;AACtD;AACA;EACE,WAAW,iFAAiF,EAAE;EAC9F,MAAM,iFAAiF,EAAE;AAC3F;AACA,gDAAgD,eAAe,EAAE;AACjE,sDAAsD,mCAAmC,EAAE;AAC3F;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;;;;;iEAKiE;;;AAGjE;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA,2BAA2B;;AAE3B;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;;IAEI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,sDAAsD;AACtD;IACI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,4CAA4C;AAChD;;AAEA,sBAAsB;;AAEtB;IACI,aAAa;IACb,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,oBAAoB;;AAEpB;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,6EAA6E;IAC7E,0BAA0B;IAC1B,kEAAkE;IAClE,+BAA+B;AACnC;;AAEA;;IAEI,6EAA6E;IAC7E,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6EAA6E;IAC7E,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;;AAGA,uDAAuD;;AAEvD;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,2BAA2B;;AAE3B;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA,yBAAyB;;AAEzB;IACI;QACI,gDAAgD;IACpD;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,qGAAqG;AACrG;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,uFAAuF;AACvF;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,sGAAsG;AACtG;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,eAAe;AACnB;;;AAGA,4GAA4G;AAC5G;EACE,8BAA8B;EAC9B,gBAAgB;AAClB","sourcesContent":["/* Shared list / delivery UI (Sent Messages, Scheduled, WhatsApp lists) */\n.sent-messages-container {\n    padding: 20px;\n    background-color: #f8f9fa;\n    min-height: 100vh;\n}\n\n.sent-messages-header {\n    margin-bottom: 30px;\n}\n\n.breadcrumb-nav {\n    font-size: 14px;\n    color: #6c757d;\n    margin-bottom: 10px;\n}\n\n.breadcrumb-item {\n    color: #6c757d;\n}\n\n.breadcrumb-separator {\n    margin: 0 8px;\n}\n\n.page-title {\n    font-size: 28px;\n    font-weight: 600;\n    color: #212529;\n    margin-bottom: 20px;\n}\n\n.filters-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n    padding: 15px 20px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.filter-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.filter-group label {\n    margin: 0;\n    font-weight: 500;\n    color: #495057;\n    font-size: 14px;\n}\n\n.filter-group .dropdown-toggle {\n    min-width: 150px;\n    text-align: left;\n    border-color: #dee2e6;\n}\n\n.add-filter-btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color: #6c5ce7;\n    text-decoration: none;\n    font-weight: 500;\n    padding: 6px 12px;\n}\n\n.add-filter-btn:hover {\n    color: #5b4bc4;\n    text-decoration: none;\n}\n\n.message-name {\n    font-weight: 500;\n    color: #212529;\n    max-width: 400px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.status-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.status-badge.delivered {\n    background-color: #d4edda;\n    color: #155724;\n}\n\n.status-badge.failed {\n    background-color: #f8d7da;\n    color: #721c24;\n}\n\n.status-badge.pending {\n    background-color: #fff3cd;\n    color: #856404;\n}\n\n.status-badge.processing {\n    background-color: #d1ecf1;\n    color: #0c5460;\n}\n\n.status-badge.cancelled {\n    background-color: #e2e3e5;\n    color: #383d41;\n}\n\n.dropdown-toggle.btn-link:focus {\n    box-shadow: none !important;\n}\n\n@media (max-width: 768px) {\n    .sent-messages-container {\n        padding: 15px;\n    }\n\n    .filters-section {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .filter-group {\n        width: 100%;\n    }\n\n    .filter-group .dropdown-toggle {\n        width: 100%;\n    }\n\n    .dashboard_app_table--list-records .table_inner {\n        overflow-x: auto;\n    }\n}\n\n\n/* Users page dropdown styling */\n.dashboard_table .dropdown-toggle::after,\n.user-action-dropdown::after {\n    display: none !important;\n}\n\n.user-action-dropdown {\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.user-action-dropdown:hover,\n.user-action-dropdown:focus,\n.user-action-dropdown:active {\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.dashboard_table .dropdown-menu {\n    min-width: 200px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    padding: 8px 0;\n    z-index: 1050;\n}\n\n.dashboard_table .dropdown-item {\n    display: flex;\n    align-items: center;\n    padding: 10px 16px;\n    font-size: 14px;\n}\n\n.dashboard_table .dropdown-item:hover {\n    background-color: #f5f5f5;\n}\n\n.dashboard_table .dropdown-item.text-danger:hover {\n    background-color: #fff5f5;\n}\n\n/* =========================================================\n   Global scrollbar styling (project-wide)\n   Works on: Chrome/Edge/Safari (webkit) + Firefox\n   ========================================================= */\n:root {\n    --ns-scrollbar-thumb: rgba(152, 162, 179, 0.75);\n    --ns-scrollbar-thumb-hover: rgba(152, 162, 179, 0.95);\n    --ns-scrollbar-track: rgba(0, 0, 0, 0.06);\n    --ns-scrollbar-size: 10px;\n    --ns-scrollbar-radius: 10px;\n}\n\n/* Firefox */\n* {\n    scrollbar-width: thin;\n    scrollbar-color: var(--ns-scrollbar-thumb) var(--ns-scrollbar-track);\n}\n\n/* Chrome / Edge / Safari */\n*::-webkit-scrollbar {\n    width: var(--ns-scrollbar-size);\n    height: var(--ns-scrollbar-size);\n}\n\n*::-webkit-scrollbar-track {\n    background: var(--ns-scrollbar-track);\n    border-radius: var(--ns-scrollbar-radius);\n}\n\n*::-webkit-scrollbar-thumb {\n    background-color: var(--ns-scrollbar-thumb);\n    border-radius: var(--ns-scrollbar-radius);\n    border: 2px solid transparent;\n    background-clip: content-box;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n    background-color: var(--ns-scrollbar-thumb-hover);\n}\n\nbody {\n    font-family: 'Arial', sans-serif;\n\n}\n\n/* .nav-link.active {\n  background-color: #f8f9fa;\n  color: #007bff;\n}\n\n.nav-link {\n  color: #a0a5aa;\n}\n\n.nav-link:hover {\n  color: #68788a;\n  text-decoration: none;\n} */\n\n\n\n/* Full height for main container */\nhtml,\nbody,\n#root {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n/* .sidebar {\n  width: 250px;\n  height: 100vh;\n} */\n\n.sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    background-color: #f8f9fa;\n    padding: 20px;\n    width: 18%;\n    overflow-y: auto;\n}\n\n\n/* Main content area background */\n.main-content-container {\n    background-color: #f5f6fa;\n    /* Light gray background */\n    min-height: 100vh;\n    display: flex;\n    /* justify-content: center; */\n    /* align-items: center; */\n}\n\n/* Center the form container */\n.form-container {\n    width: 100%;\n    height: 100vh;\n    /* Full viewport height */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Optional: Form styling */\n.card {\n    border-radius: 8px;\n    background-color: #fff;\n    /* Ensure white background */\n}\n\n/* General form spacing */\n.form-control {\n    /* margin-bottom: 20px; */\n}\n\n\n/* For the entire page */\n/* ::-webkit-scrollbar {\n    width: 4px;\n}\n\n::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #555;\n} */\n\n.mobile-image {\n    width: 450px;\n    height: 450px;\n    background-image: url('../mobile.svg');\n    background-repeat: no-repeat;\n    background-position: top center;\n    margin: 0px auto;\n    /* line-height: 1px; */\n    position: sticky;\n    /* max-width: 100%; */\n    background-size: 100%;\n}\n\n\n/* .mobile-image {\n  width: 450px;\n  height: 660px;\n  background-image: url('../mobile.svg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin: 0px auto;\n  line-height: 1px;\n  position: sticky;\n} */\n\n.notification-card {\n    display: flex;\n    width: 85%;\n    margin: 0 auto;\n    background-color: white;\n    border-radius: 15px;\n    padding: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    position: absolute;\n    top: 80px;\n    left: 50%;\n    transform: translate(-50%, 0);\n    text-align: left;\n}\n\n.notification-card .profile {\n    display: inline-block;\n    margin-right: 10px;\n}\n\n.notification-card .profile img {\n    width: 23px;\n    height: 23px;\n    border-radius: 50%;\n}\n\n.notification-card .content {\n    display: inline-block;\n}\n\n.notification-card .content p {\n    margin: 0;\n    font-size: 14px;\n    color: #000;\n}\n\n.notification-card .content span {\n    font-size: 12px;\n    color: #777;\n}\n\n#notification-button {\n    background-color: white;\n    border-radius: 10%;\n}\n\n#notification-button:hover {\n    background-color: #e7e7e7;\n    border-radius: 4px;\n}\n\n\n\n\n\n\n\n/* Step Page */\n\n\n.steps_page {\n    padding: 0px 1.5rem;\n    margin-top: 1.5rem;\n    display: grid;\n    grid-template-rows: auto;\n    row-gap: 1.5rem;\n}\n\n.steps_inner {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.steps_heading {\n    margin-bottom: 1.5rem;\n    text-align: center;\n}\n\n.steps_heading h1 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n\n.steps_form_outer {\n    display: flex;\n    flex-direction: column-reverse;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    gap: 1.5rem;\n    width: 100%;\n}\n\n@media (min-width: 48em) {\n    .steps_form_outer {\n        width: auto;\n    }\n}\n\n@media (min-width: 62em) {\n    .steps_form_outer {\n        flex-direction: row;\n    }\n}\n\n.steps_left {\n    padding: 1.5rem;\n    border-radius: 0.5rem;\n    position: relative;\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n    margin-bottom: 1.5rem;\n    width: 100%;\n}\n\n@media (min-width: 48em) {\n    .steps_left {\n        width: 40rem;\n    }\n}\n\n.inner_heading h2 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n\n.steps_sub_heading {\n    margin-top: 0.25rem;\n    margin-bottom: 1rem;\n}\n\n.name_field {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: start;\n    justify-content: start;\n    gap: 0.5rem;\n    width: 100%;\n    margin-bottom: 1rem;\n}\n\n@media (min-width: 48em) {\n    .name_field {\n        flex-direction: row;\n        width: 100%;\n    }\n}\n\n.name_field>* {\n    flex: 1 1 0%;\n}\n\n.name_field label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n}\n\n.name_field label::after {\n    content: \"*\";\n    font-size: 125%;\n    color: rgb(229, 75, 77);\n    margin-left: 3px;\n}\n\n\n.name_field1 {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: start;\n    justify-content: start;\n    gap: 0.5rem;\n    width: 100%;\n    margin-bottom: 1rem;\n}\n\n@media (min-width: 48em) {\n    .name_field1 {\n        flex-direction: row;\n        width: 100%;\n    }\n}\n\n.name_field1>* {\n    flex: 1 1 0%;\n}\n\n.name_field1 label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n}\n\n.name_field1 label::after {\n    content: \"*\";\n    font-size: 125%;\n    color: rgb(229, 75, 77);\n    margin-left: 3px;\n}\n\n\n\n.input_field {\n    width: 100%;\n    position: relative;\n    display: flex;\n}\n\n.input_field input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n}\n\n.validation_error {\n    margin-top: 0.25rem;\n}\n\n.validation_error span {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    -webkit-box-pack: start;\n    justify-content: flex-start;\n    align-items: flex-start;\n    font-size: 1rem;\n    color: rgb(229, 75, 77);\n}\n\n.validation_error img {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n    min-width: 1rem;\n    left: 0px;\n    margin-right: 0.5rem;\n    position: relative;\n    top: 0.25rem;\n    color: rgb(229, 75, 77);\n}\n\n.category_field {\n    margin-bottom: 1rem;\n}\n\n.category_field label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n\n.category_field label::after {\n    content: \"*\";\n    font-size: 125%;\n    color: rgb(229, 75, 77);\n    margin-left: 3px;\n}\n\n.select_field {\n    max-width: 262px;\n}\n\n.select_field select {\n    width: 100%;\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(203, 209, 215);\n    color: rgb(5, 27, 44) !important;\n}\n\n.select_section_label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n\n.select_apply_section {\n    margin-bottom: 1rem;\n}\n\n.select_section_label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n\n.select_section_label label {\n    margin-bottom: 5px;\n}\n\n.select_boxes {\n    display: flex;\n    flex-direction: column;\n}\n\n\n.select_box {\n    min-height: 2rem;\n    position: relative;\n}\n\n.select_box label {\n    padding-left: 0.4rem;\n}\n\n\n\n.phone_section {\n    margin-bottom: 1rem;\n}\n\n.phone_section label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n\n/* .phone_section label::after {\n  content: \"*\";\n  font-size: 125%;\n  color: rgb(229, 75, 77);\n  margin-left: 3px;\n} */\n\n.phone_input {\n    max-width: 262px;\n}\n\n.phone_input input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n}\n\nbutton.form_btn {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(67, 70, 206);\n    line-height: 1.125rem;\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n}\n\n\n\n\n* {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n}\n\nimg {\n    max-width: 100%;\n}\n\na {\n    text-decoration: none !important;\n}\n\n\n\n.signup_page {\n    position: fixed;\n    overflow-x: auto;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    inset: 0;\n    box-sizing: border-box;\n    background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);\n}\n\n.signup_page_inner {\n    box-sizing: border-box;\n    width: 100%;\n    min-height: 100vh;\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.5rem;\n    padding-top: max(clamp(1rem, 3vh, 2.5rem), env(safe-area-inset-top));\n    padding-right: max(0.75rem, env(safe-area-inset-right));\n    padding-bottom: max(clamp(1rem, 3vh, 2.5rem), env(safe-area-inset-bottom));\n    padding-left: max(0.75rem, env(safe-area-inset-left));\n}\n\n.page_logo {\n    width: 100%;\n    display: flex;\n    flex-flow: wrap;\n    gap: 0px;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    text-align: center;\n}\n\n.page_logo a {\n    display: inline-flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    column-gap: 0.25rem;\n    color: rgb(67, 70, 206);\n    overflow-wrap: anywhere;\n}\n\n.signup_page .page_logo img {\n    width: auto;\n    max-width: 150px;\n    height: auto;\n    display: block;\n    flex: 0 0 auto;\n    min-width: 0;\n    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45)) drop-shadow(0 0 1px rgba(255, 255, 255, 0.25));\n}\n\n@media (min-width:30em) {\n    .form_outer {\n        max-width: 28rem;\n    }\n}\n\n.form_outer {\n    width: calc(100% - 3rem);\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border-radius: 1rem;\n    padding: calc(2rem);\n    justify-self: center;\n    display: grid;\n    gap: calc(1rem) !important;\n}\n\n.form_heading {\n    display: flex;\n    flex-flow: column wrap;\n    gap: 0.5rem;\n    -webkit-box-pack: start;\n    justify-content: start;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n    margin: 0px;\n    color: rgb(66, 77, 87);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    letter-spacing: 0px;\n}\n\n.form_heading h1 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n\n.signup_google {\n    display: grid;\n    grid-template-columns: auto min-content min-content;\n    gap: 0.5rem;\n}\n\n.signup_google button {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    padding: 0.35rem;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(192, 193, 245);\n    color: rgb(67, 70, 206) !important;\n    height: 40px;\n    width: 40px;\n}\n\n.signup_google .signup_google_button {\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n}\n\n.signup_google_button img {\n    max-width: 20px;\n    margin-right: 5px;\n}\n\n.separator {\n    display: grid;\n    grid-template-columns: auto max-content auto;\n    width: 100%;\n    -webkit-box-align: center;\n    align-items: center;\n    gap: 1rem;\n    margin: 0px;\n}\n\n.separator hr {\n    display: block;\n    margin: 0px;\n    border-width: 1px 0px 0px;\n    border-color: rgb(203, 209, 215);\n    border-style: solid;\n    width: auto;\n    height: 0px;\n    align-self: unset;\n}\n\n.login_form form {\n    display: grid;\n    row-gap: 1.5rem;\n}\n\n.login_form .input_boxes {\n    display: flex;\n    flex-flow: column wrap;\n    gap: 1rem;\n    -webkit-box-pack: start;\n    justify-content: start;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n}\n\n.email_input {\n    width: 100%;\n    position: relative;\n    display: flex;\n}\n\n.email_input input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n    width: 100%;\n    flex: 1 1 0%;\n    transition: border-color 100ms ease-in-out, background-color 100ms ease-in-out;\n}\n\n.password_input img {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n    cursor: pointer;\n    pointer-events: auto;\n    position: absolute;\n    right: 0.5rem;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0.75rem;\n}\n\n.password_box span {\n    margin: 0px;\n    color: rgba(255, 0, 0, 0.82);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    /* font-size: 0.75rem; */\n    font-weight: 400;\n    line-height: 1rem;\n    letter-spacing: 0.015rem;\n}\n\n.recaptcha {\n    position: relative;\n}\n\n.recaptcha .checkbox {\n    width: 1rem;\n    height: 1rem;\n    left: 0.25rem;\n    top: 0.25rem;\n    appearance: none;\n    opacity: 0.0001;\n    position: absolute;\n    margin: 0px !important;\n    z-index: 1;\n    cursor: pointer;\n}\n\n.recaptcha_lable {\n    display: flex;\n    padding-left: 1.5rem;\n    position: relative;\n}\n\n.recaptcha_lable label {\n    font-weight: normal;\n    color: rgb(5, 27, 44);\n    margin-bottom: 0px;\n    font-size: 1rem;\n}\n\n.recaptcha_lable label:before {\n    width: 1rem;\n    height: 1rem;\n    border-radius: 0.125rem;\n    top: 0.25rem;\n    left: 0px;\n    position: absolute;\n    border: 1px solid rgb(203, 209, 215);\n    display: inline-block;\n    content: \" \";\n    transition: border-color 0.2s ease-in-out;\n    background-color: rgb(255, 255, 255);\n}\n\n.recaptcha_lable label:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0.25rem;\n    display: inline-block;\n    transform: rotate(45deg);\n    height: 11px;\n    width: 6px;\n    margin-left: 0.3em;\n    border-bottom: 2px solid #78b13f;\n    border-right: 2px solid #78b13f;\n    opacity: 0;\n    visibility: hidden;\n    transition: all .3s;\n}\n\n.checkbox:checked~.recaptcha_lable label:after {\n    opacity: 1;\n    visibility: visible;\n}\n\n.signup_button {\n    display: flex;\n    flex-flow: wrap;\n    gap: 0px;\n    -webkit-box-pack: start;\n    justify-content: start;\n    -webkit-box-align: start;\n    align-items: start;\n}\n\n.signup_button button {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: rgb(67, 70, 206);\n    line-height: 1.125rem;\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n    width: 100%;\n}\n\n.already_acc {\n    display: flex;\n    flex-flow: wrap;\n    gap: 0px;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: start;\n    align-items: start;\n    margin-top: 10px\n}\n\n.already_acc span {\n    margin: 0px;\n    color: rgb(66, 77, 87);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0px;\n}\n\n.already_acc span a {\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    column-gap: 0.25rem;\n    color: rgb(67, 70, 206);\n    overflow-wrap: anywhere;\n}\n\n/* Plan Page */\n.plan_page {\n    background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);\n    color: white;\n    height: 100vh;\n    padding: 2.5rem 0px 0px;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-align: center;\n    align-items: center;\n    overflow-y: auto;\n}\n\n.plan_page h1 {\n    margin: 0px;\n    color: inherit;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n\n.plan_page a {\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    column-gap: 0.25rem;\n    color: #fff;\n    overflow-wrap: anywhere;\n}\n\n.plan_boxes {\n    position: relative;\n    display: grid;\n    gap: 1.5rem;\n    padding: 1.5rem;\n    grid-template-columns: 1fr;\n    -webkit-box-align: end;\n    align-items: flex-start;\n}\n\n@media (min-width: 767px) {\n    .plan_boxes {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (min-width: 1220px) {\n    .plan_boxes {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n.plan_box {\n    padding: 1.5rem;\n    border-radius: 0.5rem;\n    position: relative;\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n    border-radius: 1rem;\n    padding: 1.5rem;\n    width: 100%;\n}\n\n.plan_inner {\n    display: flex;\n    flex-flow: column wrap;\n    gap: 1.5rem;\n    -webkit-box-pack: start;\n    justify-content: start;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n}\n\n.plan_content {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    text-align: center;\n}\n\n.plan_content h2 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.5rem;\n    font-weight: 600;\n    line-height: 2rem;\n    letter-spacing: 0px;\n}\n\n.plan_content p {\n    margin: 0px;\n    color: rgb(66, 77, 87);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    letter-spacing: 0px;\n}\n\n.plan_price {\n    display: flex;\n    flex-flow: wrap;\n    gap: 0.25rem;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: end;\n    align-items: end;\n}\n\n.plan_price h3 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.25rem;\n    font-weight: 600;\n    line-height: 1.75rem;\n    letter-spacing: 0.00875rem;\n}\n\n.plan_content p.plan_desc {\n    margin: 0px;\n    color: rgb(66, 77, 87);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 0.75rem;\n    font-weight: 400;\n    line-height: 1.125rem;\n    letter-spacing: 0.015rem;\n}\n\np.plan_desc span {\n    margin: 0px;\n    color: rgb(66, 77, 87);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 0.75rem;\n    font-weight: 400;\n    line-height: 1rem;\n    letter-spacing: 0.015rem;\n}\n\n.plan_page a.plan_button {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(67, 70, 206);\n    line-height: 1.125rem;\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n}\n\n.descriptions {\n    display: flex;\n    flex-flow: column wrap;\n    gap: 0.5rem;\n    -webkit-box-pack: start;\n    justify-content: start;\n    -webkit-box-align: stretch;\n    align-items: stretch;\n}\n\n.descriptions p {\n    margin: 0px;\n    color: rgb(66, 77, 87);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    letter-spacing: 0px;\n}\n\n.descriptions ul {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 0px;\n    margin: 0px;\n}\n\n.descriptions ul li {\n    list-style-type: none;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0px;\n    color: rgb(66, 77, 87);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0px;\n}\n\n.descriptions ul li svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: rgb(59, 182, 116);\n    opacity: 1;\n}\n\n/* Step Page */\n/* .steps_page {\n    padding: 0px 1.5rem;\n    margin-top: 1.5rem;\n    display: grid;\n    grid-template-rows: auto;\n    row-gap: 1.5rem;\n}\n.steps_inner {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    flex-direction: column;\n}\n.steps_heading {\n    margin-bottom: 1.5rem;\n    text-align: center;\n}\n.steps_heading h1 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n.steps_form_outer {\n    display: flex;\n    flex-direction: column-reverse;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    gap: 1.5rem;\n    width: 100%;\n}\n\n@media (min-width: 48em) {\n    .steps_form_outer {\n        width: auto;\n    }\n}\n@media (min-width: 62em) {\n    .steps_form_outer {\n        flex-direction: row;\n    }\n}\n.steps_left {\n    padding: 1.5rem;\n    border-radius: 0.5rem;\n    position: relative;\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n\tmargin-bottom: 1.5rem;\n\twidth: 100%;\n}\n@media (min-width: 48em) {\n    .steps_left {\n        width: 40rem;\n    }\n}\n.inner_heading h2 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n.steps_sub_heading {\n    margin-top: 0.25rem;\n    margin-bottom: 1rem;\n}\n.input_field {\n    width: 100%;\n    position: relative;\n    display: flex;\n}\n.input_field input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n}\n.validation_error {\n    margin-top: 0.25rem;\n}\n.validation_error span {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    -webkit-box-pack: start;\n    justify-content: flex-start;\n    align-items: flex-start;\n    font-size: 1rem;\n    color: rgb(229, 75, 77);\n}\n.validation_error img {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n    min-width: 1rem;\n\tleft: 0px;\n    margin-right: 0.5rem;\n    position: relative;\n    top: 0.25rem;\n\tcolor: rgb(229, 75, 77);\n}\n.category_field {\n    margin-bottom: 1rem;\n}\n.category_field label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n.select_field {\n    max-width: 262px;\n}\n.select_field select {\n    width: 100%;\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(203, 209, 215);\n    color: rgb(5, 27, 44) !important;\n}\n.select_section_label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n.select_section_label label::after {\n  content: \"*\";\n  font-size: 125%;\n  color: rgb(229, 75, 77);\n  margin-left: 3px;\n}\n\n\n.select_apply_section {\n    margin-bottom: 1rem;\n}\n.select_section_label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n.select_section_label label{margin-bottom: 5px;}\n.select_boxes {\n    display: flex;\n    flex-direction: column;\n}\n\n\n.select_box {\n    min-height: 2rem;\n    position: relative;\n}\n.select_box label {\n  padding-left: 0.4rem;\n} */\n\n/* .select_box input {\n    width: 1rem;\n    height: 1rem;\n    left: 0.25rem;\n    top: 0.25rem;\n    appearance: none;\n    opacity: 0.0001;\n    position: absolute;\n    margin: 0px !important;\n\tz-index: 1;\n\tcursor: pointer;\n}\n.select_box label {\n    display: flex;\n    padding-left: 1.5rem;\n    position: relative;\n    margin-bottom: 0px;\n    font-size: 1rem;\n\n}\n.select_box label::before {\n    width: 1rem;\n    height: 1rem;\n    border-radius: 0.125rem;\n    top: 0.25rem;\n    left: 0px;\n    position: absolute;\n    border: 1px solid rgb(203, 209, 215);\n    display: inline-block;\n    content: \" \";\n    transition: border-color 0.2s ease-in-out;\n    background-color: rgb(255, 255, 255);\n}\n.select_box label:after{\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0.25rem;\n\tdisplay: inline-block;\n\ttransform: rotate(45deg);\n\theight: 11px;\n\twidth: 6px;\n\tmargin-left: 0.3em;\n\tborder-bottom: 2px solid #78b13f;\n\tborder-right: 2px solid #78b13f;\n\topacity: 0;\n\tvisibility: hidden;\n\ttransition: all .3s;\n}\n.select_box input:checked ~ .select_box label:after{\n\topacity: 1;\n\tvisibility: visible;\n} */\n.phone_section {\n    margin-bottom: 1rem;\n}\n\n.phone_section label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n\n.phone_input {\n    max-width: 262px;\n}\n\n.phone_input input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n}\n\nbutton.form_btn {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(67, 70, 206);\n    line-height: 1.125rem;\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n}\n\n.steps_right {\n    width: max-content;\n}\n\n.step_right_heading {\n    margin-bottom: 0.5rem;\n}\n\n.step_progress {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 16px;\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(162, 173, 185);\n    display: flex;\n    box-sizing: border-box;\n    overflow: hidden;\n    height: 0.75rem;\n    border-radius: 1rem;\n}\n\n.progress_bar {\n    width: 0%;\n    display: flex;\n    background-color: rgb(59, 182, 116);\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n}\n\n.step_listing {\n    display: flex;\n    flex-direction: column;\n    margin-top: 1.5rem;\n}\n\n.step_list {\n    display: flex;\n    align-items: flex-start;\n}\n\n.step_count {\n    display: flex;\n    flex-direction: column;\n    margin-right: 0.5rem;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    color: rgb(255, 255, 255);\n    background-color: rgb(116, 128, 139);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    line-height: 0;\n    padding: 0px 0.25rem;\n    width: 16px;\n    height: 16px;\n    border-radius: 8px;\n    font-size: 12px;\n}\n\n.step_seperator {\n    background-color: rgb(185, 194, 202);\n    width: 1px;\n    height: 0.875rem;\n    margin-top: 0.375rem;\n    margin-bottom: 0.25rem;\n    margin-left: 0.4375rem;\n}\n\n.step_list label {\n    font-weight: normal;\n    color: rgb(5, 27, 44);\n    font-size: 1rem;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    line-height: 1;\n    padding-bottom: 0.25rem;\n    max-width: 100%;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n}\n\n.step_list.active label {\n    font-weight: bold;\n}\n\n/* Step_1 */\n.step_1 .name_field {\n    display: block;\n    max-width: 400px;\n}\n\n.step_1 .name_field1 {\n    display: block;\n    max-width: 400px;\n}\n\n.step_1 .select_field {\n    max-width: 400px;\n}\n\n.step_1 .progress_bar {\n    width: 33%;\n}\n\n.step_2 .progress_bar {\n    width: 66%;\n}\n\n.step_1 .step_list.filled .step_count {\n    background: rgb(59, 182, 116);\n}\n\n.step_2 .step_list.filled .step_count {\n    background: rgb(59, 182, 116);\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  dashboard  */\n\n/* Main workspace: minmax(0,1fr) prevents wide tables/buttons from stretching past the viewport */\n@media (min-width: 48em) {\n    .dashboard_page {\n        display: grid;\n        grid-template-columns: 265px minmax(0, 1fr);\n        transition: all .4s;\n        overflow: visible;\n    }\n\n    .dashboard_page.collapsed_menu {\n        grid-template-columns: 64px minmax(0, 1fr);\n    }\n}\n\n@media (max-width: 47.99em) {\n    .dashboard_page {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        max-width: 100vw;\n        min-height: 100vh;\n        overflow-x: hidden;\n        box-sizing: border-box;\n    }\n}\n\n.dashboard-main-shell {\n    flex: 1 1 auto;\n    min-width: 0;\n    max-width: 100%;\n    box-sizing: border-box;\n    padding: clamp(0.75rem, 2.2vw, 1.25rem);\n    overflow-x: hidden;\n}\n\n/* Pending-bill notice — full width at the top of every dashboard page */\n.pending-bill-banner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: nowrap;\n    position: fixed;\n    top: 14px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 2000;\n    width: min(760px, calc(100vw - 32px));\n    box-sizing: border-box;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);\n    padding: 12px 44px 12px 16px;\n    border: 1px solid #fde68a;\n    border-radius: 10px;\n    background: #fffbeb;\n    color: #92400e;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.pending-bill-banner__text {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.pending-bill-banner__link {\n    flex: 0 0 auto;\n    white-space: nowrap;\n}\n\n.pending-bill-banner__close {\n    position: absolute;\n    top: 6px;\n    right: 10px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    opacity: 0.7;\n}\n\n.pending-bill-banner--overdue {\n    border-color: #fecaca;\n    background: #fef2f2;\n    color: #b91c1c;\n}\n\n.pending-bill-banner__link {\n    flex-shrink: 0;\n    padding: 6px 14px;\n    border-radius: 8px;\n    background: #d97706;\n    color: #fff;\n    text-decoration: none;\n    font-weight: 600;\n}\n\n.pending-bill-banner--overdue .pending-bill-banner__link {\n    background: #dc2626;\n}\n\n.pending-bill-banner__link:hover {\n    color: #fff;\n    opacity: 0.9;\n}\n\n/* Below open mobile drawer (1100+) so nav links and dropdown receive clicks */\n.dashboard-sidebar-backdrop {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 1020;\n    margin: 0;\n    padding: 0;\n    border: none;\n    background: rgba(0, 0, 0, 0.45);\n    cursor: pointer;\n}\n\n/* Keep the top bar (hamburger + logo) above the dimmer */\n@media (max-width: 47.99em) {\n    .dashboard-sidebar-backdrop {\n        top: 3.5rem;\n    }\n\n    .dashboard_left {\n        position: relative;\n        z-index: 1100;\n    }\n}\n\n.dashboard-mobile-menu-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 2.5rem;\n    height: 2.5rem;\n    margin-right: 0.25rem;\n    padding: 0;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    color: #3f4254;\n    cursor: pointer;\n}\n\n.dashboard-mobile-menu-btn:hover {\n    background: rgba(15, 18, 33, 0.06);\n    color: #0f1221;\n}\n\n@media (min-width: 48em) {\n    .dashboard-mobile-menu-btn {\n        display: none;\n    }\n}\n\n.dashboard_left {\n    position: relative;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 16px;\n    /* On desktop this is the whole left column (logo + nav + footer), so the panel tint\n       and the full-height divider belong here — not on .dashboard_nav, which is only\n       part of the column. On mobile it collapses to a 3.5rem top bar. */\n    background-color: #f8f9fb;\n    border-bottom: 1px solid #e7e9ef;\n    height: 3.5rem;\n    text-rendering: geometricprecision;\n}\n\n@media (min-width: 48em) {\n    .dashboard_left {\n        position: sticky;\n        height: 100vh;\n        top: 0px;\n        left: 0px;\n        bottom: 0px;\n        width: 100%;\n        z-index: 9;\n        overflow: visible;\n        /* Full-height divider against the white page — replaces the mobile top-bar rule. */\n        border-bottom: none;\n        border-right: 1px solid #e7e9ef;\n    }\n}\n\n.dashboard_menus_outer {\n    display: flex;\n    flex-direction: row;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    gap: 1.5rem;\n    padding: 0px 0px 0px 0.5rem;\n    height: 100%;\n}\n\n@media (min-width: 48em) {\n    .dashboard_menus_outer {\n        -webkit-box-pack: start;\n        justify-content: flex-start;\n        flex-direction: column;\n        padding: 0px;\n    }\n}\n\n@media (min-width: 48em) {\n    .dashboard_menus {\n        display: flex;\n        flex-direction: column;\n        gap: 1.5rem;\n        padding: 1.5rem 1.5rem 0px;\n        position: relative;\n        z-index: 1100;\n    }\n}\n\n.site_logo {\n    display: flex;\n    flex-direction: row;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n}\n\n.dashboard_page.collapsed_menu .site_logo {\n    flex-direction: column;\n}\n\n.site_logo a {\n    box-sizing: border-box;\n    position: relative;\n    justify-self: left;\n    line-height: 0;\n}\n\n.sidebar_edge_toggle {\n    display: none;\n}\n\n@media (min-width: 48em) {\n    .sidebar_edge_toggle {\n        display: inline-flex;\n        position: absolute;\n        top: auto;\n        bottom: 0.9rem;\n        right: 0;\n        transform: translateX(50%);\n        z-index: 1200;\n        width: 28px;\n        height: 28px;\n        padding: 0;\n        margin: 0;\n        align-items: center;\n        justify-content: center;\n        font-size: 11px;\n        font-weight: 700;\n        letter-spacing: -0.5px;\n        line-height: 1;\n        color: #3f4254;\n        background: #fff;\n        border: 1px solid #e7e9ef;\n        border-radius: 50%;\n        box-shadow: 0 1px 4px rgba(5, 27, 44, 0.12);\n        cursor: pointer;\n    }\n\n    .sidebar_edge_toggle svg {\n        width: 16px;\n        height: 16px;\n        flex-shrink: 0;\n    }\n\n    .sidebar_edge_toggle:hover {\n        color: #4346ce;\n        border-color: #c5c8f0;\n        background: #fff;\n    }\n\n    .dashboard_page.collapsed_menu .sidebar_edge_toggle {\n        bottom: 2.5rem;\n    }\n\n}\n\n.dashboard_search {\n    -webkit-box-align: center;\n    align-items: center;\n    display: flex;\n    -webkit-box-pack: end;\n    justify-content: flex-end;\n    cursor: pointer;\n    line-height: 0;\n    color: rgb(192, 193, 245);\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n}\n\n.dashboard_page.collapsed_menu .dashboard_search {\n    display: none;\n}\n\n.dashboard_search svg {\n    min-width: 20px;\n    width: 20px;\n    height: 20px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n.dashboard_nav {\n    display: flex;\n    height: calc(-3.5rem + 100vh);\n    width: calc(265px - 2rem);\n    /* Light panel — brand indigo is reserved for the active item, so it stands out.\n       Tinted (not pure white) so it separates from the white page; the column border\n       lives on .dashboard_left, which spans the full height. */\n    background: transparent;\n    box-shadow: none;\n    flex-direction: column;\n    align-items: flex-start;\n    transition: margin-left 0.3s;\n    z-index: 1030;\n    position: fixed;\n    top: 0.5rem;\n    left: 0px;\n    margin-left: -100%;\n    padding: 0.5rem 0.5rem 1rem;\n    overflow-y: auto;\n}\n\n@media (max-width: 47.99em) {\n    .dashboard_nav.dashboard_nav--open {\n        margin-left: 0;\n        width: 100%;\n        max-width: 100vw;\n        z-index: 1101;\n        /* The desktop panel is transparent (tint lives on .dashboard_left), but the\n           mobile drawer floats over the page and needs its own opaque background. */\n        background: #f8f9fb;\n        box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);\n    }\n}\n\n@media (min-width: 48em) {\n    .dashboard_nav {\n        width: auto;\n        flex-direction: column;\n        /* height:100% ki jagah flex:1 1 0 use kiya - \"100%\" ko flex-basis ki tarah apply\n           karne ke baad browser ko shrink-calculation me content size ka reference mil\n           jata tha, jiski wajah se shrink poora reliable nahi tha. flex-basis:0 (flex: 1 1 0)\n           + min-height:0 standard/robust pattern h jisme ye div sirf jitni jagah bachi h\n           (header - footer ke beech) utni hi leta h, aur apne \"overflow-y: auto\" se khud\n           scroll karta h - footer (.sidebar_footer) ab kabhi overlap/chhup nahi hota chahe\n           koi bhi submenu (Customer Support etc.) khula ho. */\n        flex: 1 1 0%;\n        min-height: 0;\n        max-height: 100%;\n        margin-left: 0px;\n        box-shadow: none;\n        -webkit-box-pack: start;\n        justify-content: flex-start;\n        /* static tha pehle - jiski wajah se base rule ka z-index: 1030 inert ho jata tha\n           (z-index sirf positioned elements pe kaam karta h), aur collapsed sidebar ka\n           flyout submenu DOM-order ki wajah se main content ke piche chup jata tha.\n           relative se layout same rehta h (koi top/left offset nahi), bas z-index active ho jata h. */\n        position: relative;\n        padding: 0px 0.5rem 60px 1.5rem;\n        scrollbar-gutter: stable;\n        scrollbar-width: thin;\n        scrollbar-color: rgba(15, 18, 33, 0.2) transparent;\n    }\n}\n\n@media (min-width: 48em) {\n    .dashboard_page.collapsed_menu .dashboard_nav {\n        padding: 0px 0.75rem;\n        -webkit-box-align: center;\n        align-items: center;\n        overflow: visible; /* flyout submenus (.sidebar_drop_menu--flyout) ko escape hone dena h */\n        scrollbar-gutter: unset;\n    }\n}\n\n/* Collapsed sidebar me normal expand/collapse chevron (up/down arrow) icons nahi dikhne\n   chahiye - sirf icon + flyout submenu (hover pe) dikhna chahiye, chota sidebar me arrow\n   ka koi matlab nahi (klik ki jagah hover se khulega). Ye chevrons hi \"sc-jSMfEi gdvaUL\"\n   class ke sath render hote h (main icon ye class use nahi karta). */\n.dashboard_page.collapsed_menu .app_drop_down > svg.sc-jSMfEi {\n    display: none;\n}\n\n.dashboard_nav a,\n.dashboard_nav .app_drop_down {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    position: relative;\n    width: 100%;\n    justify-content: left;\n    border-radius: 8px;\n    gap: 0.625rem;\n    padding: 0.5rem 0.75rem;\n    margin-bottom: 2px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #3f4254;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.dashboard_nav a svg,\n.dashboard_nav .app_drop_down svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n/* These sidebar icons are white-filled .svg files loaded via <img>, so `color`/`fill`\n   can't reach inside them — darken them so they're visible on the light panel.\n   (Does not touch the logo: that lives in .site_logo, outside .dashboard_nav.) */\n.dashboard_nav a img,\n.dashboard_nav .app_drop_down img {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: brightness(0) opacity(0.72);\n    color: inherit;\n    opacity: 1;\n}\n\n.dashboard_nav a label,\n.dashboard_nav .app_drop_down label {\n    max-width: inherit;\n    color: inherit;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n}\n\n.dashboard_nav label:hover {\n    max-width: inherit;\n    color: inherit;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n}\n\n.dashboard_nav a:hover,\n.dashboard_nav .app_drop_down:hover {\n    color: #0f1221;\n    background-color: rgba(15, 18, 33, 0.045);\n}\n\n/* Active = soft tinted pill + indigo text (not a solid block) so it reads clean on white. */\n.dashboard_nav a.active,\n.dashboard_nav .app_drop_down.active {\n    color: #4346ce;\n    background-color: #eef0fd;\n    font-weight: 600;\n}\n\n.dashboard_nav a.active:hover,\n.dashboard_nav .app_drop_down.active:hover {\n    color: #4346ce;\n    background-color: #e6e9fc;\n}\n\n.sidebar_nav {\n    display: block;\n    width: 100%;\n    border-top: 1px solid rgba(15, 18, 33, 0.08);\n    margin: 20px 0px 0px 0px;\n    padding-top: 8px;\n}\n\n/* Thin, unobtrusive scrollbar for the nav panel */\n.dashboard_nav::-webkit-scrollbar {\n    width: 6px;\n}\n\n.dashboard_nav::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.dashboard_nav::-webkit-scrollbar-thumb {\n    background: rgba(15, 18, 33, 0.16);\n    border-radius: 3px;\n}\n\n.dashboard_nav::-webkit-scrollbar-thumb:hover {\n    background: rgba(15, 18, 33, 0.28);\n}\n\n.sidebar_nav_collapsed {\n    display: block;\n    width: 100%;\n    border-top: 1px solid rgb(48, 50, 147);\n    background-color: #78b13f;\n}\n\n/* .sidebar_nav a img{} */\n.sidebar_footer {\n    height: auto;\n    min-height: 3.5rem;\n    display: flex;\n    flex-shrink: 0; /* nav wale area me jitna hi scroll ho, footer apni jagah neeche fixed rahe, kabhi chota na ho */\n    grid-column-end: -1;\n    -webkit-box-pack: end;\n    justify-content: flex-end;\n    background: #f8f9fb;\n    z-index: 1100;\n}\n\n@media (min-width: 48em) {\n    .sidebar_footer {\n        height: auto;\n        flex-direction: row;\n        -webkit-box-pack: justify;\n        justify-content: space-between;\n        -webkit-box-align: center;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 12px 1.5rem;\n    }\n}\n\n.sidebar_footer button svg {\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n    color: #3f4254;\n}\n\n.sidebar_footer button {\n    cursor: pointer;\n    border: 0px none;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgba(255, 255, 255, 0);\n    line-height: 1.125rem;\n    gap: 0.5rem;\n    color: rgb(67, 70, 206) !important;\n    text-decoration: none !important;\n}\n\n.sidebar_footer button.expend_collapsed {\n    display: none;\n}\n\n@media (min-width: 48em) {\n\n    .sidebar_footer button.expend_collapsed,\n    .sidebar_footer button {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 2.25rem;\n        height: 2.25rem;\n        padding: 0.5rem;\n        color: #3f4254;\n        background-color: transparent;\n        border: none;\n        border-radius: 0.25rem;\n    }\n\n    .sidebar_footer button.logout_btn:hover,\n    .sidebar_footer button.expend_collapsed:hover {\n        color: #4346ce;\n        background-color: rgba(15, 18, 33, 0.05);\n    }\n\n    /* Don't leave a filled background after a mouse click — only show a focus ring\n       for keyboard users (focus-visible), matching the now-light sidebar. */\n    .sidebar_footer button.expend_collapsed:focus {\n        outline: none;\n        background-color: transparent;\n    }\n\n    .sidebar_footer button.expend_collapsed:focus-visible {\n        outline: 2px solid rgba(67, 70, 206, 0.45);\n        outline-offset: 1px;\n    }\n}\n\n.dashboard_right {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n}\n\n.dashboard_inner {\n    margin-top: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.org-header-card {\n    display: flex;\n    flex-direction: column;\n    gap: 1.1rem;\n    padding: 1.15rem 1.35rem;\n    background: #fff;\n    /* Match the apps table card (ticket-list style): same border, radius and shadow */\n    border: 1px solid #e9eaee;\n    border-radius: 12px;\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n}\n\n.org-header-top {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.org-header-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    min-width: 0;\n}\n\n.org-header-label {\n    font-size: 0.7rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #8a90a2;\n}\n\n.org-header-name {\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: rgb(5, 27, 44);\n    line-height: 1.2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.org-header-side {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    flex-shrink: 0;\n}\n\n.org-header-plan {\n    padding: 0.25rem 0.7rem;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #4346ce;\n    background: #eef0ff;\n    border-radius: 999px;\n    white-space: nowrap;\n}\n\n.org-header-edit {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    color: #6b7280;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.org-header-edit:hover {\n    background: #eef0ff;\n    color: #4346ce;\n}\n\n.org-header-stats {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 1.75rem;\n}\n\n.org-stat {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    min-width: 0;\n}\n\n.org-stat-value {\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: rgb(5, 27, 44);\n    line-height: 1.1;\n}\n\n.org-stat-label {\n    font-size: 0.74rem;\n    color: #8a90a2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media (max-width: 62em) {\n    .org-header-stats {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        gap: 1.1rem;\n    }\n}\n\n@media (max-width: 30em) {\n    .org-header-stats {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n.dashboard_right_top {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: start;\n    justify-content: flex-start;\n    gap: 1rem;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n}\n\n@media (min-width: 48em) {\n    .dashboard_right_top {\n        flex-direction: row;\n        -webkit-box-pack: justify;\n        justify-content: space-between;\n    }\n}\n\n.dashboard_heading h1 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n\n.add_app {\n    width: 100%;\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    gap: 0.5rem;\n    -webkit-box-flex: 0;\n    flex-grow: 0;\n}\n\n@media (min-width: 30em) {\n    .add_app {\n        flex-direction: row;\n        -webkit-box-pack: start;\n        justify-content: flex-start;\n        align-items: center;\n    }\n}\n\n@media (min-width: 48em) {\n    .add_app {\n        width: auto;\n        flex-wrap: wrap-reverse;\n        -webkit-box-pack: end;\n        justify-content: flex-end;\n        align-items: center;\n    }\n}\n\n@media (min-width: 30em) {\n    .add_app a {\n        width: auto;\n    }\n}\n\n.add_app a {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: 100%;\n    background-color: rgb(67, 70, 206);\n    line-height: 1.125rem;\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n}\n\n.add_app a svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n.add_app a img {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n/* Add-app bar buttons: shared size; pair with btn_theme_* for colors */\n.add_app_btn,\n.add_app_btn_secondary {\n    width: auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.add_app_btn svg,\n.add_app_btn_secondary svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    color: inherit;\n    opacity: 1;\n}\n\n.dashboard_app_table {\n    /* padding: 0.5rem; */\n    border-radius: 0.5rem;\n    position: relative;\n    /* margin-block: 10px; */\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    /* max-width: calc(-3rem + 81vw); */\n}\n\n.dashboard_app_table--list-records {\n    gap: 0.5rem;\n}\n\n/* Subscription Records — filter card (separate from table card), Alembic-style accordion */\n.list-page-filter-card {\n    padding: 0;\n    border-radius: 0.5rem;\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.list-page-filter-accordion-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 12px 16px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    text-align: left;\n}\n\n.list-page-filter-accordion-header:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.list-page-filter-accordion-title {\n    font-size: 0.9375rem;\n    font-weight: 500;\n    color: #6c757d;\n}\n\n.list-page-filter-accordion-chevron {\n    flex-shrink: 0;\n    transition: transform 0.2s ease;\n    color: #6c757d;\n}\n\n.list-page-filter-accordion-chevron--open {\n    transform: rotate(180deg);\n}\n\n.list-page-filter-accordion-body {\n    padding: 16px 16px;\n}\n\n.list-page-filter-accordion-body .list-page-filter-bar {\n    margin-bottom: 0;\n}\n\n.search_app {\n    display: flex;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n}\n\n.search_app_dropdown {\n    width: 200px;\n}\n\n/* Subscription Records — filter row: fields group + actions on one row when space allows (avoids huge wrap gap) */\n.list-page-filter-bar {\n    margin-bottom: 8px;\n}\n\n.list-page-filter-fields {\n    margin: 0;\n    padding: 0;\n}\n\n.list-page-filter-field {\n    margin: 0;\n    padding: 0;\n}\n\n.list-page-filter-field .form-control {\n    margin-bottom: 0;\n}\n\n.list-page-filter-field .ns-daterange__trigger.form-control {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding-left: 14px;\n}\n\n.list-page-filter-field .ns-daterange__trigger-value {\n    padding-left: 2px;\n}\n\n.list-page-tag-filter-group {\n    flex-wrap: nowrap;\n    align-items: stretch;\n}\n\n.list-page-tag-filter-key {\n    flex: 1 1 0;\n    min-width: 0;\n}\n\n.list-page-tag-filter-key .ns-select {\n    width: 100%;\n}\n\n.list-page-tag-filter-key .ns-select__control {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.list-page-tag-filter-key .ns-select__control--is-focused {\n    position: relative;\n    z-index: 2;\n}\n\n.list-page-tag-filter-value {\n    flex: 1 1 0;\n    min-width: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    margin-left: -1px;\n}\n\n.list-page-tag-filter-value:focus {\n    position: relative;\n    z-index: 2;\n}\n\n.list-page-filter-actions {\n    margin-left: auto;\n}\n\n.list-page-filter-actions .add_app {\n    flex-wrap: nowrap;\n    align-items: center;\n}\n\n.dashboard_table {\n    overflow: visible;\n    width: 100%;\n}\n\n.table_inner {\n    border: 1px solid rgb(229, 232, 235);\n    border-radius: 0.25rem;\n    overflow-x: auto;\n    overflow-y: visible;\n    width: 100%;\n    position: relative;\n    /* required for sticky column layering */\n}\n\n/* Keep table header visible while vertical-scrolling rows inside table area. */\n.table_inner.table_y_scroll table.table_outer thead th {\n    position: sticky;\n    top: 0;\n    z-index: 3;\n    background: rgb(246, 247, 248);\n}\n\n/* Compact table spacing when table-sm is applied */\ntable.table_outer.table-sm th,\ntable.table_outer.table-sm td {\n    padding: 0.4rem;\n}\n\ntable.table_outer {\n    font-size: 14px;\n    width: 100%;\n    /* max-width: 800px; */\n    border-collapse: separate;\n    /* sticky columns work reliably */\n    border-spacing: 0;\n    box-shadow: none !important;\n    table-layout: auto;\n}\n\ntable.table_outer tr {\n    height: 3.125rem;\n}\n\ntable.table_outer th {\n    padding: 0.75rem 0.5rem;\n    line-height: 1.1875rem;\n    font-weight: 600;\n    text-align: left;\n    white-space: nowrap;\n    background: rgb(246, 247, 248);\n    border-bottom: 1px solid rgb(229, 232, 235);\n    font-weight: bold;\n    font-size: 13px;\n}\n\ntable.table_outer tr>th:last-of-type {\n    border-top-right-radius: 0.25rem;\n}\n\ntable.table_outer tbody {\n    border-collapse: collapse;\n}\n\ntable.table_outer tbody tr {\n    border-bottom: 1px solid rgb(229, 232, 235);\n    position: relative;\n}\n\ntable.table_outer tbody tr.support-ticket-row--clickable {\n    cursor: pointer;\n}\n\ntable.table_outer tbody tr.support-ticket-row--clickable:hover {\n    background: rgb(246, 247, 248);\n}\n\ntable.table_outer tbody tr:last-of-type {\n    border-bottom: 0\n}\n\ntable.table_outer td {\n    padding: 0.5rem 0.5rem;\n    vertical-align: middle;\n    text-align: left;\n    transition: 0.1s ease-in-out;\n    text-overflow: ellipsis;\n    font-size: 13px;\n}\n\ntable.table_outer td:last-child {\n    overflow: visible;\n}\n\ntable.table_outer td a {\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    column-gap: 0.25rem;\n    color: #000;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-weight: bold;\n}\n\ntable.table_outer td.plan span {\n    font-size: 16px;\n    height: 1.5625rem;\n    padding: 0px 0.5rem;\n    border-radius: 0.25rem;\n    white-space: nowrap;\n    display: inline-flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    color: rgb(40, 51, 62);\n    background-color: rgb(229, 232, 235);\n}\n\ntable.table_outer td svg {\n    min-width: 20px;\n    width: 20px;\n    height: 20px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n    /* margin-right: 0.5rem; */\n}\n\ntable.table_outer td button svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\ntable.table_outer td button {\n    cursor: pointer;\n    border: 0px none;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    font-size: 0.8rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgba(255, 255, 255, 0);\n    line-height: 1.125rem;\n    color: rgb(67, 70, 206);\n}\n\n/* ---------------------------------------------------------\n   Pagination (Alembic-style, Bootstrap-compatible)\n   Applies wherever we use Bootstrap `.pagination` markup.\n   --------------------------------------------------------- */\n.pagination {\n    gap: 0.25rem;\n}\n\n.pagination .page-link {\n    min-width: 2rem;\n    height: 2rem;\n    padding: 0 0.6rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n    font-size: 0.8125rem;\n    /* ~13px */\n    border-radius: 0.5rem;\n    border: 1px solid rgb(229, 232, 235);\n    background: rgb(255, 255, 255);\n    color: rgb(67, 70, 206);\n    box-shadow: rgba(5, 27, 44, 0.08) 0px 1px 2px;\n    transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease, box-shadow 120ms ease;\n}\n\n.pagination .page-link:hover {\n    background: rgb(236, 236, 252);\n    border-color: rgb(192, 193, 245);\n    color: rgb(58, 61, 179);\n}\n\n.pagination .page-link:focus {\n    box-shadow: 0 0 0 0.2rem rgba(67, 70, 206, 0.18);\n}\n\n.pagination .page-item.disabled .page-link,\n.pagination .page-link:disabled {\n    color: rgb(162, 173, 185);\n    background: rgb(246, 247, 248);\n    border-color: rgb(229, 232, 235);\n    box-shadow: none;\n}\n\n.pagination .page-item.active .page-link {\n    background: rgb(67, 70, 206);\n    border-color: rgb(58, 61, 179);\n    color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n}\n\n.pagination.pagination-sm .page-link {\n    min-width: 1.75rem;\n    height: 1.75rem;\n    border-radius: 0.45rem;\n    box-shadow: none;\n    font-size: 0.75rem;\n    /* 12px */\n}\n\n/* Pagination bar alignment (Showing... + pager stay one line) */\n.pagination_align {\n    flex-wrap: nowrap;\n    gap: 0.75rem;\n}\n\n.pagination_align>* {\n    min-width: 0;\n}\n\n.pagination_align .pagination {\n    flex-wrap: nowrap;\n}\n\n.pagination_align .text-muted,\n.pagination_showing {\n    white-space: nowrap;\n    font-size: 12px;\n}\n\n.pagination_align .text-muted b,\n.pagination_showing b {\n    font-size: inherit;\n    font-weight: 600;\n}\n\n/* Subscription table specific column widths */\ntable.table_outer td.col-action {\n    width: 40px;\n    max-width: 40px;\n    background: #fff;\n}\n\n/* Text buttons in action column (e.g. API Keys \"Disable\") — not kebab-only width */\ntable.table_outer th.col-action.col-action-wide,\ntable.table_outer td.col-action.col-action-wide {\n    width: auto;\n    min-width: 7.5rem;\n    max-width: none;\n}\n\n.table_inner:not(.at-scroll-end) table.table_outer td.col-action.col-action-wide {\n    min-width: 7.5rem;\n    width: auto;\n    max-width: none;\n}\n\n/* Sticky Action column (OneSignal-like) */\n.table_inner:not(.at-scroll-end) table.table_outer th.col-action,\n.table_inner:not(.at-scroll-end) table.table_outer td.col-action {\n    position: sticky;\n    right: 0;\n}\n\n/* Make sticky column look like a single layered strip */\n.table_inner:not(.at-scroll-end) table.table_outer th.col-action,\n.table_inner:not(.at-scroll-end) table.table_outer td.col-action {\n    border-left: 1px solid rgb(229, 232, 235);\n    box-shadow: -6px 0 10px rgba(16, 24, 40, 0.08);\n    background-clip: padding-box;\n}\n\n.table_inner:not(.at-scroll-end) table.table_outer th.col-action {\n    z-index: 4;\n    /* above body cells */\n    background: rgb(246, 247, 248);\n    /* match header background */\n}\n\n.table_inner:not(.at-scroll-end) table.table_outer td.col-action {\n    z-index: 3;\n    min-width: 40px;\n    padding-right: 6px;\n}\n\n/* When sticky is disabled at far-right, make it look normal (no hint it was sticky) */\n.table_inner.at-scroll-end table.table_outer th.col-action {\n    /* position: unset; */\n}\n\n.table_inner.at-scroll-end table.table_outer td.col-action {\n    position: static;\n    right: auto;\n    border-left: 0;\n    box-shadow: none;\n    background: inherit;\n}\n\n/* Kebab cell is always centred in its column (same as Subscription Records) */\ntable.table_outer th.col-action:not(.col-action-wide),\ntable.table_outer td.col-action:not(.col-action-wide) {\n    text-align: center !important;\n}\n\n/* Ensure action (kebab) button is always visible */\ntable.table_outer td.col-action .dropdown-trigger-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: rgb(67, 70, 206);\n}\n\ntable.table_outer td.col-action .dropdown-trigger-btn svg {\n    display: block;\n}\n\ntable.table_outer td.col-subscription-id,\ntable.table_outer td.col-notify-sphere-id {\n    width: 140px;\n    /* max-width: 140px; */\n}\n\ntable.table_outer td.col-device-name {\n    width: 120px;\n    /* max-width: 120px; */\n}\n\ntable.table_outer td.col-android-version {\n    width: 100px;\n    /* max-width: 100px; */\n}\n\ntable.table_outer td.col-token {\n    width: 180px;\n    /* max-width: 180px; */\n}\n\ntable.table_outer td.col-latitude,\ntable.table_outer td.col-longitude {\n    width: 90px;\n    /* max-width: 90px; */\n}\n\ntable.table_outer td.col-status {\n    width: 70px;\n    /* max-width: 70px; */\n}\n\ntable.table_outer td span {\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n.dashboardsvg {\n    min-width: 16px;\n    width: 25px !important;\n    height: 20px !important;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdown-button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 24px;\n}\n\n.dropdown-menu1 {\n    position: fixed;\n    background-color: white;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 9999;\n    width: 180px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 4px;\n    right: 10px\n}\n\n.dropdown-menu1 button {\n    display: block;\n    width: 100% !important;\n    padding: 10px;\n    text-align: left;\n    background: none;\n    border: none;\n    justify-content: flex-start !important;\n    cursor: pointer;\n    color: #000 !important;\n    white-space: nowrap;\n}\n\n.dropdown-menu1 .delete-class {\n    color: red !important;\n    border-top: 1px solid lightgray;\n}\n\n\n.dropdown-menu1 button:hover {\n    background-color: #f0f0f0;\n}\n\n.dropdown-menu2 {\n    position: absolute;\n    background-color: white;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 10000;\n    width: 200px;\n}\n\n.dropdown-menu2 button {\n    display: block;\n    width: 100% !important;\n    padding: 10px;\n    text-align: left;\n    background: none;\n    border: none;\n    justify-content: flex-start !important;\n    cursor: pointer;\n    color: #000 !important;\n}\n\n.dropdown-menu2 .delete-class {\n    color: red !important;\n    border-top: 1px solid lightgray;\n}\n\n\n.dropdown-menu2 button:hover {\n    background-color: #f0f0f0;\n}\n\n.dropdown-menu-user {\n    position: absolute;\n    background-color: white;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 1;\n    width: 250px;\n}\n\n.dropdown-menu-user button {\n    display: block;\n    width: 100% !important;\n    padding: 10px;\n    text-align: left;\n    background: none;\n    border: none;\n    justify-content: flex-start !important;\n    cursor: pointer;\n    color: #000 !important;\n}\n\n.dropdown-menu-user .delete-class {\n    color: red !important;\n    border-top: 1px solid lightgray;\n}\n\n\n.dropdown-menu-user button:hover {\n    background-color: #f0f0f0;\n}\n\n.dropdown-menu-subscription {\n    position: absolute;\n    background-color: white;\n    border: 1px solid rgb(229, 232, 235);\n    border-radius: 0.375rem;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 10000;\n    width: 225px;\n    padding: 0.2rem 0.2rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.dropdown-menu-subscription button {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100% !important;\n    box-sizing: border-box; /* width:100% + left/right padding ko ek sath fit kare, warna button\n                               container se thoda bahar nikal jata h aur hover-highlight sirf\n                               right side pe flush/clipped dikhta h (left side theek rehta h) */\n    padding: 0.75rem 0.5rem;\n    text-align: left;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #051b2c !important;\n    font-size: 14px;\n    font-weight: 400;\n    transition: background-color 0.15s ease;\n    white-space: nowrap;\n}\n\n/* Match icon size/weight across Users + Subscriptions row menus (react-icons render as SVG). */\n.dropdown-menu-subscription button>svg {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    min-width: 20px;\n}\n\n.dropdown-menu-subscription button:hover:not(:disabled) {\n    background-color: #693cac1e;\n}\n\n.dropdown-menu-subscription button:disabled {\n    pointer-events: auto;\n}\n\n.dropdown-menu-subscription .delete-class {\n    color: rgb(229, 75, 77) !important;\n    border-top: 1px solid rgb(229, 232, 235);\n    margin-top: 0.25rem;\n    padding-top: 0.75rem;\n}\n\n.dropdown-menu-subscription .delete-class:hover {\n    background-color: #693cac1e;\n}\n\n\n\n\n\n.dropdown-menu3 {\n    position: absolute;\n    background-color: white;\n    /* border: 1px solid #ccc; */\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 1;\n    width: 80px;\n}\n\n.dropdown-menu3 button {\n    display: block;\n    height: 37px;\n    width: 100% !important;\n    padding: 10px;\n    text-align: left;\n    background: none;\n    border: none;\n    justify-content: flex-start !important;\n    cursor: pointer;\n    color: #000 !important;\n}\n\n.dropdown-menu3 .delete-class {\n    color: #e54b4d !important;\n    /* border-top: 1px solid lightgray; */\n}\n\n\n.dropdown-menu3 button:hover {\n    background-color: #f0f0f0;\n}\n\n\n\n.tabButton {\n    width: 36px;\n    padding: 0.4rem 0.25rem !important;\n}\n\n.tabButton:hover {\n    background-color: rgb(236, 250, 255);\n}\n\n\n\n\n\n\n\n\n\n/* Increase the width and height of the Selectize dropdown */\n.selectize-dropdown {\n    font-size: 30px;\n    /* Adjust font size */\n    max-height: 300px;\n    /* Adjust dropdown height */\n    width: 400px;\n    /* Adjust dropdown width */\n    overflow-y: auto;\n    /* Enable scrolling if dropdown exceeds max-height */\n}\n\n.selectize-input {\n    font-size: 30px;\n    /* Adjust input size */\n    height: 40px;\n    /* Adjust height of the input */\n}\n\n.selectize-input input {\n    height: 100%;\n    /* Ensure input takes up the full height */\n    padding: 40px;\n    /* Add padding to increase size */\n}\n\n/* Change the background and text color of the highlighted option */\n.selectize-dropdown .active {\n    background-color: #4c6faf;\n    /* Change this to your desired highlight color */\n    color: white;\n    /* Change text color */\n}\n\n/* Change the background color of hovered options (when the mouse is over an option) */\n.selectize-dropdown .option:hover {\n    background-color: #667bb438;\n    /* Change this to your desired hover color */\n    color: black;\n    /*  Change text color */\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.dashboard_dropdown {\n    position: relative;\n    z-index: 1200;\n}\n\n.dropdown_menu {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    float: left;\n    min-width: 160px;\n    padding: 5px 0;\n    margin: 2px 0 0;\n    list-style: none;\n    font-size: 16px;\n    text-align: left;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border: 1px solid rgba(0, 0, 0, .15);\n    border-radius: 4px;\n    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n    box-shadow: 0 6px 12px #0000002d;\n    background-clip: padding-box;\n    font-size: 0.875rem;\n    margin: 0.4rem 0px 0px;\n    padding: 0;\n    border: 1px solid rgba(15, 18, 33, 0.10);\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 4px 6px -2px rgba(5, 27, 44, 0.08), 0 12px 32px -6px rgba(5, 27, 44, 0.22);\n}\n\n.dashboard_dropdown.show .dropdown_menu {\n    display: block;\n}\n\n.dashboard_dropdown .dropdown_menu .nav-tabs {\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n    width: 18rem;\n    border-bottom: 1px solid rgba(15, 18, 33, 0.09);\n    display: flex;\n}\n\n/* App/Org tabs — desktop had no active indicator at all; give them a proper underline. */\n.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link {\n    padding: 0.75rem 0;\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: #6b7280;\n    transition: color 0.15s ease;\n}\n\n.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link:hover {\n    color: rgb(5, 27, 44);\n}\n\n.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link.active {\n    color: rgb(67, 70, 206);\n    font-weight: 600;\n}\n\n.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button.nav-link.active::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    height: 2px;\n    border-radius: 2px 2px 0 0;\n    background: rgb(67, 70, 206);\n}\n\n.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item {\n    display: flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    position: relative;\n    width: 100%;\n    background-color: transparent;\n    border-radius: 0px;\n    border: none;\n    padding: 0px;\n    color: rgb(5, 27, 44);\n    max-width: 50%;\n}\n\n.dashboard_dropdown .dropdown_menu .nav-tabs li.nav-item button {\n    display: flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    position: relative;\n    width: 100%;\n    background-color: transparent;\n    border-radius: 0px;\n    border: none;\n    padding: 1rem 0px;\n    color: rgb(5, 27, 44);\n}\n\n@media (min-width: 48em) {\n    .dashboard_dropdown {\n        display: flex;\n        position: relative;\n    }\n}\n\n/* App/Org dropdown: desktop = top bar; mobile = duplicate inside slide-out `dashboard_nav` */\n@media (max-width: 47.99em) {\n    .dashboard-app-dropdown--desktop {\n        display: none !important;\n    }\n}\n\n@media (min-width: 48em) {\n    .dashboard-app-dropdown--mobile {\n        display: none !important;\n    }\n}\n\n@media (max-width: 47.99em) {\n    .dashboard-app-dropdown--mobile {\n        width: 100%;\n        max-width: 100%;\n        padding: 0 0.5rem 0.75rem;\n        margin: 0 0 0.75rem;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.09);\n        flex-shrink: 0;\n        align-self: stretch;\n    }\n\n    .dashboard-app-dropdown--mobile .dropdown_menu {\n        left: 0;\n        right: auto;\n        width: min(100%, 20rem);\n        max-width: calc(100vw - 2rem);\n        background-color: #fff;\n        color: rgb(5, 27, 44);\n    }\n\n    .dashboard-app-dropdown--mobile .dropdown_menu .nav-tabs {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .dashboard-app-dropdown--mobile .dropdown_menu .nav-tabs button.nav-link {\n        color: rgb(5, 27, 44) !important;\n    }\n\n    .dashboard-app-dropdown--mobile .dropdown_menu .nav-tabs button.nav-link.active {\n        color: rgb(67, 70, 206) !important;\n        font-weight: 600;\n    }\n}\n\n.dropdown_outer {\n    width: 100%;\n}\n\n.dashboard_dropdown button {\n    width: 100%;\n    background-color: #f6f7fb;\n    border: 1px solid #e4e6ef;\n    border-radius: 8px;\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #1f2433;\n    transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.dashboard_dropdown button:hover {\n    background-color: #eef0f6;\n    border-color: #d7dae8;\n    /* Bootstrap's .btn-primary:hover forces white text — keep it dark/readable. */\n    color: #1f2433;\n}\n\n.dashboard_dropdown.show button {\n    background-color: #eef0fd;\n    border-color: #b9bdf2;\n    color: #1f2433;\n}\n\n.dashboard_dropdown span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-right: 0.5rem;\n}\n\n.dashboard_dropdown svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n    margin-left: auto;\n}\n\n.dashboard_dropdown li.nav-item button.active::after {\n    content: \"\";\n    position: absolute;\n    background-color: rgb(129, 131, 236);\n    width: 0.25rem;\n    left: 0px;\n    height: 100%;\n}\n\n@media (min-width: 48em) {\n    .dashboard_dropdown li.nav-item button.active::after {\n        left: auto;\n        bottom: 0px;\n        height: 0.25rem;\n        width: 100%;\n    }\n}\n\n.sidebar_footer button.logout_btn {\n    display: inline-flex;\n    width: auto;\n    flex-shrink: 0;\n    color: #3f4254 !important;\n    font-size: 13px;\n}\n\n.sidebar_user {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n    flex: 1;\n}\n.sidebar_user_avatar {\n    width: 36px;\n    height: 36px;\n    font-size: 12px;\n    font-weight: 600;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n.sidebar_user_meta {\n    min-width: 0;\n}\n.sidebar_user_name {\n    font-size: 13px;\n    font-weight: 600;\n    color: #212529;\n    line-height: 1.25;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.sidebar_user_email {\n    font-size: 11px;\n    color: #6c757d;\n    line-height: 1.3;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media (min-width: 48em) {\n    .dashboard_page.collapsed_menu .sidebar_footer {\n        padding: 0 0.5rem 1rem;\n        justify-content: center;\n        flex-direction: column;\n        gap: 0.35rem;\n    }\n    .dashboard_page.collapsed_menu .sidebar_user {\n        justify-content: center;\n        flex: 0;\n    }\n}\n\n\n\n\n\n\n/* New App */\n\n\n.sub_heading {\n    margin-top: 1rem;\n}\n\n.app_plateform {\n    padding: 1.5rem;\n    border-radius: 0.5rem;\n    position: relative;\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n}\n\n@media (min-width: 48em) {\n    .app_plateform_field {\n        width: 29.25rem;\n    }\n}\n\n.app_input {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    margin-top: 5px;\n}\n\n.app_input input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n}\n\n.app_plateform_field .search_app_dropdown {\n    width: 100%;\n}\n\n.next_button button {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(67, 70, 206);\n    line-height: 1.125rem;\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n}\n\n.select_app {\n    margin-top: 5px;\n}\n\n.select_app ul {\n    padding-left: 0;\n    list-style: none;\n    --controlWidth: calc(8.75rem + 0.5rem);\n    display: grid;\n    gap: 1.5rem;\n}\n\n@media (min-width: 48em) {\n    .select_app ul {\n        grid-template-columns: repeat(auto-fill, var(--controlWidth));\n    }\n}\n\n.select_app ul li {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-align: center;\n    align-items: center;\n    position: relative;\n    z-index: 0;\n    cursor: pointer;\n}\n\n.select_inner {\n    --button-radius: 4px;\n    transition: 0.1s ease-in;\n    width: 100%;\n    height: 8.75rem;\n    cursor: pointer;\n    padding: 0.5rem;\n    color: rgb(66, 77, 87);\n    background-color: rgb(255, 255, 255);\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgb(203, 209, 215);\n    border-radius: var(--button-radius);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.select_app ul li input {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    z-index: 0;\n    cursor: pointer;\n}\n\n.select_app ul li input:checked+.select_inner {\n    border-color: rgb(67, 70, 206);\n    background-color: rgb(236, 236, 252);\n}\n\n\n\n\n\n\n\n\n/* configuration Ap */\n\n.app_setting_steps_outer {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\n.app_setting_steps_inner {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n}\n\n.app_setting_steps_form_outer {\n    display: flex;\n    flex-direction: column-reverse;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    gap: 1.5rem;\n    width: 100%;\n    max-width: 100%;\n}\n\n.app_setting_step_1 .progress_bar {\n    width: 25%;\n}\n\n.app_setting_step_2 .progress_bar {\n    width: 50%;\n}\n\n.app_setting_step_3 .progress_bar {\n    width: 75%;\n}\n\n.app_setting_step_1 .step_list.filled .step_count {\n    background: rgb(59, 182, 116);\n}\n\n.app_setting_step_2 .step_list.filled .step_count {\n    background: rgb(59, 182, 116);\n}\n\n.app_setting_step_3 .step_list.filled .step_count {\n    background: rgb(59, 182, 116);\n}\n\n@media (min-width: 62em) {\n    .app_setting_steps_form_outer {\n        flex-direction: row;\n    }\n}\n\n.app_setting_steps_left {\n    padding: 1.5rem;\n    border-radius: 0.5rem;\n    position: relative;\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n    margin-bottom: 1.5rem;\n    width: 100%;\n    flex: 1;\n    min-width: 0;\n}\n\n@media (min-width: 48em) {\n    .app_setting_steps_left {\n        max-width: 63rem;\n    }\n}\n\n.app_setting_steps_form_outer .steps_right {\n    flex-shrink: 0;\n    width: auto;\n    min-width: 180px;\n}\n\n/* Dashboard right panel - prevent overflow */\n.dashboard_right {\n    width: 100%;\n    max-width: 100%;\n    /* overflow-x: hidden; */\n}\n\n.dashboard_right .dashboard_inner {\n    width: 100%;\n    max-width: 100%;\n}\n\n.configuration_page {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\n/* .inner_heading h2 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: -0.00875rem;\n}\n.steps_sub_heading {\n    margin-top: 0.25rem;\n    margin-bottom: 1rem;\n}\n.name_field {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: start;\n    justify-content: start;\n    gap: 0.5rem;\n    width: 100%;\n\tmargin-bottom: 1rem;\n}\n@media (min-width: 48em) {\n    .name_field {\n        flex-direction: row;\n        width: 100%;\n    }\n}\n.name_field > * {\n    flex: 1 1 0%;\n}\n.name_field label{\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n}\n.name_field label::after {\n    content: \"*\";\n    font-size: 125%;\n    color: rgb(229, 75, 77);\n    margin-left: 3px;\n}\n.input_field {\n    width: 100%;\n    position: relative;\n    display: flex;\n}\n.input_field input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n}\n.validation_error {\n    margin-top: 0.25rem;\n}\n.validation_error span {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    -webkit-box-pack: start;\n    justify-content: flex-start;\n    align-items: flex-start;\n    font-size: 1rem;\n    color: rgb(229, 75, 77);\n}\n.validation_error img {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n    min-width: 1rem;\n\tleft: 0px;\n    margin-right: 0.5rem;\n    position: relative;\n    top: 0.25rem;\n\tcolor: rgb(229, 75, 77);\n}\n.category_field {\n    margin-bottom: 1rem;\n}\n.category_field label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n.select_field {\n    max-width: 262px;\n}\n.select_field select {\n    width: 100%;\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(203, 209, 215);\n    color: rgb(5, 27, 44) !important;\n}\n.select_section_label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n.select_apply_section {\n    margin-bottom: 1rem;\n}\n.select_section_label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n.select_section_label label{margin-bottom: 5px;}\n.select_boxes {\n    display: flex;\n    flex-direction: column;\n}\n.select_box {\n    min-height: 2.25rem;\n    position: relative;\n}\n.select_box input {\n    width: 1rem;\n    height: 1rem;\n    left: 0.25rem;\n    top: 0.25rem;\n    appearance: none;\n    opacity: 0.0001;\n    position: absolute;\n    margin: 0px !important;\n\tz-index: 1;\n\tcursor: pointer;\n}\n.select_box label {\n    display: flex;\n    padding-left: 1.5rem;\n    position: relative;\n    margin-bottom: 0px;\n    font-size: 1rem;\n\n}\n.select_box label::before {\n    width: 1rem;\n    height: 1rem;\n    border-radius: 0.125rem;\n    top: 0.25rem;\n    left: 0px;\n    position: absolute;\n    border: 1px solid rgb(203, 209, 215);\n    display: inline-block;\n    content: \" \";\n    transition: border-color 0.2s ease-in-out;\n    background-color: rgb(255, 255, 255);\n}\n.select_box label:after{\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0.25rem;\n\tdisplay: inline-block;\n\ttransform: rotate(45deg);\n\theight: 11px;\n\twidth: 6px;\n\tmargin-left: 0.3em;\n\tborder-bottom: 2px solid #78b13f;\n\tborder-right: 2px solid #78b13f;\n\topacity: 0;\n\tvisibility: hidden;\n\ttransition: all .3s;\n}\n.select_box input:checked ~ .select_box label:after{\n\topacity: 1;\n\tvisibility: visible;\n}\n.phone_section {\n    margin-bottom: 1rem;\n}\n.phone_section label {\n    font-weight: normal;\n    color: rgb(66, 77, 87);\n    font-size: 1rem;\n    margin-bottom: 5px;\n}\n.phone_input {\n    max-width: 262px;\n}\n.phone_input input {\n    height: 2.25rem;\n    padding: 0.5rem 0.75rem;\n    outline: none 0px;\n    width: 100%;\n    color: rgb(5, 27, 44);\n    border-radius: 0.25rem;\n    border: 1px solid rgb(203, 209, 215);\n    background: rgb(255, 255, 255);\n}\nbutton.form_btn {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(67, 70, 206);\n    line-height: 1.125rem;\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n}\n.steps_right {\n    width: max-content;\n}\n.step_right_heading {\n    margin-bottom: 0.5rem;\n}\n.step_progress {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 16px;\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(162, 173, 185);\n    display: flex;\n    box-sizing: border-box;\n    overflow: hidden;\n    height: 0.75rem;\n    border-radius: 1rem;\n}\n.progress_bar {\n    width: 0%;\n    display: flex;\n    background-color: rgb(59, 182, 116);\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n}\n.step_listing {\n    display: flex;\n    flex-direction: column;\n    margin-top: 1.5rem;\n}\n.step_list {\n    display: flex;\n    align-items: flex-start;\n}\n.step_count {\n    display: flex;\n    flex-direction: column;\n    margin-right: 0.5rem;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    color: rgb(255, 255, 255);\n    background-color: rgb(116, 128, 139);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    line-height: 0;\n    padding: 0px 0.25rem;\n    width: 16px;\n    height: 16px;\n    border-radius: 8px;\n    font-size: 12px;\n}\n.step_seperator {\n    background-color: rgb(185, 194, 202);\n    width: 1px;\n    height: 0.875rem;\n    margin-top: 0.375rem;\n    margin-bottom: 0.25rem;\n    margin-left: 0.4375rem;\n}\n.step_list label {\n    font-weight: normal;\n    color: rgb(5, 27, 44);\n    font-size: 1rem;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    line-height: 1;\n    padding-bottom: 0.25rem;\n    max-width: 100%;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n}\n.step_list.active label {\n    font-weight: bold;\n} */\n\n/* Step_1 */\n/* .step_1 .name_field {\n\tdisplay: block;\n\tmax-width: 400px;\n}\n.step_1 .select_field {\n    max-width: 400px;\n}\n.step_1 .progress_bar {\n    width: 33%;\n}\n.step_2 .progress_bar {\n    width: 66%;\n}\n.step_1 .step_list.filled .step_count {\n    background: rgb(59, 182, 116);\n}\n.step_2 .step_list.filled .step_count {\n    background: rgb(59, 182, 116);\n}\n*/\n\n.upload_file label {\n    width: 100%;\n}\n\n.configuration_page .steps_form {\n    width: 66%;\n}\n\n.configuration_page .select_field {\n    max-width: 100%\n}\n\n.file_type {\n    width: 100%;\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(203, 209, 215);\n    color: rgb(5, 27, 44) !important;\n}\n\n.configuration_page .select_apply_section {\n    margin-top: 40px\n}\n\n.configuration_page .go_back {\n    background: transparent;\n    color: #000 !important;\n    border: 0;\n}\n\n\n\n\n\n.retrieve_pera {\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n.retrieve_pera a {\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    column-gap: 0.25rem;\n    color: rgb(67, 70, 206);\n    overflow-wrap: anywhere;\n}\n\n.need_help {\n    background: rgb(246, 247, 248);\n    border: 1px solid rgb(229, 232, 235);\n    border-radius: 0.5rem;\n    padding: 1rem;\n    gap: 1rem;\n    display: flex;\n    -webkit-box-pack: justify;\n    justify-content: space-between;\n    -webkit-box-align: center;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 20px;\n}\n\n.need_help button {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: 100%;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(192, 193, 245);\n    color: rgb(67, 70, 206) !important;\n}\n\n@media (min-width: 30em) {\n    .need_help button {\n        width: auto;\n    }\n}\n\n.need_help button svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n.need_help button span {\n    margin-left: 0.5rem;\n}\n\n\n\n\n/* Select SDK */\n.sdk_outer {\n    display: grid;\n    gap: 1.5rem;\n    grid-template-columns: 1fr;\n}\n\n.sdk_outer h2 {\n    color: rgb(5, 27, 44);\n    font-size: 1.375rem;\n    font-weight: 500;\n    margin-top: 0px;\n    margin-bottom: 0.5rem;\n}\n\n.sdk_outer code {\n    padding: 2px 4px;\n    font-size: 90%;\n    color: inherit;\n    background-color: #b3b3b31a;\n    word-break: break-all;\n    white-space: normal;\n    border-radius: 2px;\n}\n\n.sdk_outer button {\n    cursor: pointer;\n    border: 0px none;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(255, 255, 255);\n    line-height: 2rem;\n    color: rgb(116, 128, 139) !important;\n}\n\n.sdk_outer svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n.check_subscribe button {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(192, 193, 245);\n    color: rgb(67, 70, 206) !important;\n}\n\n.check_subscribe button span {\n    margin-left: 0.5rem;\n}\n\n.sidebar_dropdown_link {\n    color: rgb(5, 27, 44);\n}\n\n.sidebar_dropdown_link:hover {\n    color: rgb(67, 70, 206);\n}\n\n/* App/Org picker: links sit in a white .dropdown_menu but inherit .dashboard_nav a (lavender) — force readable text */\n.dashboard_nav .dashboard_dropdown .dropdown_menu a.sidebar_dropdown_link,\n.dashboard_nav .dashboard_dropdown .dropdown_menu a {\n    color: rgb(5, 27, 44) !important;\n}\n\n.dashboard_nav .dashboard_dropdown .dropdown_menu a.sidebar_dropdown_link:hover,\n.dashboard_nav .dashboard_dropdown .dropdown_menu a:hover {\n    color: rgb(67, 70, 206) !important;\n    background-color: rgba(67, 70, 206, 0.07);\n    border-radius: 6px;\n}\n\n.dashboard_nav .dashboard_dropdown .dropdown_menu .tab-content ul li {\n    padding: 0.15rem 0;\n}\n\n.dashboard_nav .dashboard_dropdown .dropdown_menu svg {\n    color: rgb(67, 70, 206);\n    opacity: 1;\n}\n\n\n.sidebar_footer button.expend_collapsed {\n    transition: all .4s;\n}\n\n\n.dashboard_nav .nav_dropdown {\n    position: relative; /* collapsed state ke flyout submenu ke liye anchor */\n    color: #3f4254;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Collapsed sidebar me submenu inline expand hone ki jagah icon ke right side flyout ki tarah khulta h */\n.dashboard_nav .sidebar_drop_menu.sidebar_drop_menu--flyout {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    margin-left: 0;\n    width: 200px;\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n    padding: 6px 0;\n    z-index: 1040;\n}\n.dashboard_nav .sidebar_drop_menu.sidebar_drop_menu--flyout ul {\n    margin: 0;\n    border-left: none;\n    padding-left: 0;\n}\n.dashboard_nav .sidebar_drop_menu.sidebar_drop_menu--flyout ul li a {\n    padding-left: 0.9rem;\n}\n\n/* Sub-menu: same indent and dot marker for every parent (Messages, Audience, Setting, Delivery, Support) */\n.dashboard_nav .sidebar_drop_menu {\n    width: 100%;\n}\n\n.dashboard_nav .sidebar_drop_menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.dashboard_nav .sidebar_drop_menu ul li {\n    list-style: none;\n}\n\n/* Sub-items sit under a subtle guide line instead of bullet dots (dots read as dated). */\n.dashboard_nav .sidebar_drop_menu ul {\n    margin: 2px 0 6px 1.4rem;\n    border-left: 1px solid rgba(15, 18, 33, 0.10);\n    padding-left: 0.35rem;\n}\n\n.dashboard_nav .sidebar_drop_menu ul li a {\n    padding-left: 0.75rem;\n    font-size: 0.82rem;\n    font-weight: 400;\n    color: #6b7280;\n}\n\n.dashboard_nav .sidebar_drop_menu ul li a::before {\n    display: none;\n}\n\n.dashboard_nav .sidebar_drop_menu ul li a.active {\n    color: #4346ce;\n    background-color: #eef0fd;\n    font-weight: 600;\n}\n\n.dashboard_nav .app_drop_down label {\n    flex: 1 1 auto;\n    margin-right: 0;\n}\n\n.dashboard_nav .app_drop_down > svg:last-child {\n    margin-left: auto;\n    flex-shrink: 0;\n}\n\n\n\n\n\n\n\n\n\n\n/* platform  */\n\n\n.plateform_section {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.plateform_section h2 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.5rem;\n    font-weight: 600;\n    line-height: 2rem;\n    letter-spacing: 0px;\n}\n\n.plateform_cards {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    padding-block: 10px;\n}\n\n@media (min-width: 48em) {\n    .plateform_cards {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.plateform_card {\n    border-radius: 0.5rem;\n    position: relative;\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n    border: none;\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n}\n\n.card_top {\n    display: flex;\n    flex-direction: row;\n    -webkit-box-flex: 1;\n    flex-grow: 1;\n    column-gap: 1.5rem;\n    padding-bottom: 1.5rem;\n}\n\n.card_top_left {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0%;\n    row-gap: 0.75rem;\n}\n\n.card_top_inner {\n    display: flex;\n    flex-direction: column;\n    row-gap: 0.5rem;\n}\n\n@media (min-width: 30em) {\n    .card_top_inner {\n        -webkit-box-align: center;\n        align-items: center;\n        flex-direction: row;\n        column-gap: 0.75rem;\n    }\n}\n\n.card_top_inner h3 {\n    margin: 0px;\n    color: rgb(5, 27, 44);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n    font-size: 1.25rem;\n    font-weight: 600;\n    line-height: 1.75rem;\n    letter-spacing: 0.00875rem;\n}\n\n.active_inactive {\n    display: flex;\n    flex-flow: row;\n    gap: 0.75rem;\n}\n\n.active_inactive span {\n    height: 1.5625rem;\n    padding: 0px 0.5rem;\n    border-radius: 0.25rem;\n    white-space: nowrap;\n    display: inline-flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    color: rgb(38, 119, 76);\n    background-color: rgb(231, 246, 238);\n    margin: 0px;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1.125rem;\n    letter-spacing: 0.00875rem;\n}\n\n.card_top_right {\n    display: flex;\n    flex-direction: column;\n    -webkit-box-pack: start;\n    justify-content: start;\n}\n\n.card_top_right svg {\n    min-width: 48px;\n    width: 48px;\n    height: 48px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n.card_footer {\n    display: flex;\n    flex-flow: column wrap;\n    row-gap: 1rem;\n}\n\n@media (min-width: 30em) {\n    .card_footer {\n        -webkit-box-align: center;\n        align-items: center;\n        -webkit-box-pack: justify;\n        justify-content: space-between;\n        flex-direction: row;\n    }\n}\n\n.card_setting {\n    display: flex;\n    flex-flow: column wrap;\n    row-gap: 0.75rem;\n    align-content: flex-start;\n}\n\n@media (min-width: 30em) {\n    .card_setting {\n        flex-direction: row;\n        column-gap: 0.5rem;\n    }\n}\n\n.card_setting a {\n    cursor: pointer;\n    display: inline-flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    width: auto;\n    background-color: rgb(255, 255, 255);\n    line-height: 1.125rem;\n    border: 1px solid rgb(192, 193, 245);\n    color: rgb(67, 70, 206) !important;\n    transition: all .3s;\n}\n\n.inactive_plateform .card_setting a {\n    background-color: rgb(67, 70, 206);\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n    transition: all .3s;\n}\n\n.card_setting a svg {\n    min-width: 16px;\n    width: 16px;\n    height: 16px;\n    filter: none;\n    color: inherit;\n    opacity: 1;\n}\n\n.card_setting a span {\n    margin-left: 0.5rem;\n}\n\n.card_setting a:hover,\n.card_setting a:focus {\n    background-color: rgb(236, 236, 252);\n    border-color: rgb(67, 70, 206);\n    color: rgb(67, 70, 206) !important;\n}\n\n.inactive_plateform .card_setting a:hover,\n.inactive_plateform .card_setting a:focus {\n    background-color: rgb(58, 61, 179);\n    border-color: rgb(58, 61, 179);\n    color: rgb(255, 255, 255) !important;\n}\n\n\n.log-img,\n.ns-app-logo--collapsed {\n    max-width: 36px !important;\n    width: 36px !important;\n    height: auto;\n    object-fit: contain;\n}\n\n.ns-app-logo {\n    height: 38px;\n    width: auto;\n    max-width: 160px;\n    display: block;\n    object-fit: contain;\n}\n\n.loader-div {\n    background-color: rgb(220 220 220) !important;\n    border: 1px solid lightgray !important;\n    width: 214px !important;\n}\n\n.loader-img {\n    width: fit-content !important;\n    height: inherit !important;\n}\n\n\n\n\n\n\n\n\n\n/* CustomModal.css */\n.custom-modal-size .modal-dialog {\n    max-width: 580px;\n    /* Set the width */\n}\n\n.custom-modal-size .modal-content {\n    height: 666px;\n    /* Set the total height of the modal */\n    display: flex;\n    flex-direction: column;\n}\n\n.custom-modal-size .modal-body {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    padding: 1.25rem 0.75rem 1.25rem 1.25rem;\n}\n\n.custom-modal-size .modal-footer {\n    height: 80px;\n    border-top: 1px solid #dee2e6;\n}\n\n/* Create Ticket modal: fixed header/footer, scrollable body */\n.create-ticket-modal .modal-dialog {\n    max-height: calc(100vh - 2rem);\n    margin: 1rem auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.create-ticket-modal .modal-content {\n    max-height: calc(100vh - 2rem);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.create-ticket-modal .modal-header {\n    flex-shrink: 0;\n}\n\n.create-ticket-modal-form {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.create-ticket-modal .modal-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n}\n\n.create-ticket-modal .modal-footer {\n    flex-shrink: 0;\n}\n\n/* History modal: scroll only on inner body, not whole modal */\n.history-modal-no-scroll .modal-content {\n    overflow: visible;\n}\n\n.history-modal-no-scroll .modal-body {\n    overflow: hidden;\n    padding: 1rem;\n    /* max-height: 55vh; */\n    display: flex;\n    flex-direction: column;\n}\n\n.history-modal-body-inner {\n    overflow: auto;\n    flex: 1;\n    min-height: 0;\n}\n\n/* SkeletonLoader.css */\n.skeleton-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.skeleton-table th,\n.skeleton-table td {\n    padding: 10px;\n    /* border: 1px solid #e0e0e0; */\n}\n\n.skeleton-cell {\n    width: 100%;\n    height: 20px;\n    background-color: #e0e0e0;\n    border-radius: 4px;\n    animation: shimmer 1.5s infinite linear;\n}\n\n@keyframes shimmer {\n    0% {\n        background-position: -100px 0;\n    }\n\n    100% {\n        background-position: 100px 0;\n    }\n}\n\n\n\n/* Button Loader */\n.btn-loader {\n    width: 18px;\n    height: 18px;\n    border: 2px solid #ffffff;\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    display: inline-block;\n    animation: btn-spin 1s linear infinite;\n}\n\n@keyframes btn-spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\nbutton.form_btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* SSL Domain Check */\n.modal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.modal_content {\n    background: #fff;\n    border-radius: 8px;\n    padding: 24px;\n    max-width: 480px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.modal_content.modal_large {\n    max-width: 800px;\n}\n\n.modal_content h3 {\n    margin-top: 0;\n}\n\n.form_group {\n    margin-bottom: 16px;\n}\n\n.form_group label {\n    display: block;\n    margin-bottom: 6px;\n    font-weight: 500;\n}\n\n.form_group .form_control {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n}\n\n.modal_actions {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.add_app_link_btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    background: #2563eb;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.add_app_link_btn:hover {\n    background: #1d4ed8;\n}\n\n.btn_sm {\n    padding: 4px 10px;\n    font-size: 12px;\n    margin-right: 6px;\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n    background: #f9fafb;\n    cursor: pointer;\n}\n\n.btn_sm:hover {\n    background: #e5e7eb;\n}\n\n.btn_danger {\n    color: #dc2626;\n    border-color: #fca5a5;\n    background: #fef2f2;\n}\n\n.btn_danger:hover {\n    background: #fee2e2;\n}\n\n.btn_primary {\n    background: #2563eb;\n    color: #fff;\n    border: none;\n}\n\n.btn_primary:hover {\n    background: #1d4ed8;\n}\n\n.btn_primary:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* ---- Common theme buttons (reuse in add_app, modals, anywhere) ---- */\n.btn_theme_primary {\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    line-height: 1.125rem;\n    background-color: rgb(67, 70, 206);\n    border: 1px solid rgb(58, 61, 179);\n    box-shadow: rgba(5, 27, 44, 0.16) 0px 1px 1px, rgba(255, 255, 255, 0.05) 0px 1px 0px inset;\n    color: rgb(255, 255, 255) !important;\n}\n\n.btn_theme_primary:hover {\n    background-color: rgb(58, 61, 179);\n}\n\n.btn_theme_primary:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.btn_theme_secondary {\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(209, 213, 219);\n    color: rgb(55, 65, 81);\n    line-height: 1.125rem;\n}\n\n.btn_theme_secondary:hover {\n    background-color: rgb(249, 250, 251);\n}\n\n.btn_theme_secondary:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.btn_theme_orange {\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: #f59e0b;\n    border: 1px solid #d97706;\n    color: rgb(255, 255, 255) !important;\n    line-height: 1.125rem;\n}\n\n.btn_theme_orange:hover {\n    background-color: #d97706;\n}\n\n.btn_theme_orange:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* Same height / radius / padding for every list-page action (primary + adjacent) */\n.add_app_btn,\n.add_app_btn_secondary,\n.add_app a.add_app_btn,\n.add_app a.add_app_btn_secondary {\n    box-sizing: border-box;\n    width: auto;\n    height: 2.25rem;\n    padding: 0 0.75rem;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1;\n    border-radius: 0.25rem;\n    white-space: nowrap;\n    text-decoration: none;\n}\n\n.add_app_btn span,\n.add_app_btn_secondary span {\n    display: inline-flex;\n    align-items: center;\n    line-height: 1;\n}\n\n.btn_theme_danger {\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    border-radius: 0.25rem;\n    background-color: #dc2626;\n    border: 1px solid #b91c1c;\n    color: #fff;\n}\n\n.btn_theme_danger:hover {\n    background-color: #b91c1c;\n}\n\n.btn_theme_danger:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* =========================================================\n   Light semantic badges — Bootstrap 5 palette (soft bg + emphasis text)\n   Use with: className=\"badge rounded-pill bg-light-success\" etc.\n   (Subscription status + reusable across the app)\n   ========================================================= */\n.badge.bg-light-primary {\n    background-color: #cfe2ff !important;\n    color: #084298 !important;\n}\n\n.badge.bg-light-secondary {\n    background-color: #e2e3e5 !important;\n    color: #41464b !important;\n}\n\n.badge.bg-light-success {\n    background-color: #d1e7dd !important;\n    color: #0f5132 !important;\n}\n\n.badge.bg-light-danger {\n    background-color: #f8d7da !important;\n    color: #842029 !important;\n}\n\n.badge.bg-light-warning {\n    background-color: #fff3cd !important;\n    color: #664d03 !important;\n}\n\n.badge.bg-light-info {\n    background-color: #cff4fc !important;\n    color: #055160 !important;\n}\n\n/* \"Ended\" automations etc. - had no rule before, so the badge rendered white-on-white (invisible). */\n.badge.bg-light-dark {\n    background-color: #d3d3d4 !important;\n    color: #212529 !important;\n}\n\n/* Slightly clearer pill for status labels (optional; works with Bootstrap .badge) */\n.badge.rounded-pill.bg-light-primary,\n.badge.rounded-pill.bg-light-secondary,\n.badge.rounded-pill.bg-light-success,\n.badge.rounded-pill.bg-light-danger,\n.badge.rounded-pill.bg-light-warning,\n.badge.rounded-pill.bg-light-info,\n.badge.rounded-pill.bg-light-dark {\n    padding: 0.275rem 0.75rem;\n    font-size: 0.7125rem;\n    font-weight: 500;\n    line-height: 1.25;\n}\n\n/* WhatsApp · Template Records — toolbar: keep row aligned with Refresh / Add Template */\n.wa-template-records-toolbar.add_app {\n    flex-direction: row !important;\n    flex-wrap: nowrap;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    width: auto;\n    max-width: min(100%, 52rem);\n}\n@media (max-width: 47.99em) {\n    .wa-template-records-toolbar.add_app {\n        flex-wrap: wrap;\n        max-width: 100%;\n    }\n}\n.wa-template-records-toolbar.add_app .wa-template-toolbar-delete.add_app_btn_secondary {\n    border-color: #dc2626;\n    color: #dc2626;\n    background: #fff;\n}\n.wa-template-records-toolbar.add_app .wa-template-toolbar-delete.add_app_btn_secondary:hover:not(:disabled) {\n    background: #fef2f2;\n    border-color: #b91c1c;\n    color: #b91c1c;\n}\n.wa-template-records-toolbar.add_app .wa-template-toolbar-delete.add_app_btn_secondary:disabled {\n    opacity: 0.55;\n    border-color: #e5e7eb;\n    color: #9ca3af;\n    background: #f9fafb;\n}\n\n.form-options-list .form-group {\n    margin-bottom: 0;\n}\n\n.form-options-list .form-control {\n    margin-bottom: 0;\n}\n\n/* App dashboard */\n.app-dashboard {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.app-dashboard__filter-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.75rem 1rem;\n}\n\n.app-dashboard__date-range {\n    flex: 0 1 auto;\n    width: auto;\n    min-width: 220px;\n    max-width: 300px;\n}\n\n.app-dashboard__date-range .ns-daterange {\n    width: auto;\n    max-width: 300px;\n}\n\n.app-dashboard__range-label {\n    font-size: 0.875rem;\n    color: #64748b;\n}\n\n.app-dashboard__intro {\n    margin: 0;\n    color: #6b7280;\n    font-size: 0.95rem;\n}\n\n.app-dashboard__section-title {\n    margin: 0 0 0.75rem;\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #6b7280;\n}\n\n.app-dashboard__kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 1rem;\n}\n\n.app-dashboard__kpi {\n    background: #fff;\n    border-radius: 12px;\n    padding: 1.15rem 1.25rem;\n    box-shadow: rgba(5, 27, 44, 0.08) 0 1px 8px -1px, rgba(5, 27, 44, 0.06) 0 3px 4px -1px;\n    display: flex;\n    align-items: flex-start;\n    gap: 0.85rem;\n    text-decoration: none;\n    color: inherit;\n    transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.app-dashboard__kpi--link:hover {\n    transform: translateY(-2px);\n    box-shadow: rgba(5, 27, 44, 0.12) 0 4px 16px -2px;\n}\n\n.app-dashboard__kpi-icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.app-dashboard__kpi-value {\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1.2;\n    color: #051b2c;\n}\n\n.app-dashboard__kpi-label {\n    font-size: 0.8125rem;\n    color: #6b7280;\n    margin-top: 0.15rem;\n}\n\n.app-dashboard__kpi-sub {\n    font-size: 0.75rem;\n    color: #10b981;\n    margin-top: 0.25rem;\n}\n\n.app-dashboard__charts {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1rem;\n}\n\n@media (min-width: 960px) {\n    .app-dashboard__charts {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n.app-dashboard__chart-card {\n    background: #fff;\n    border-radius: 12px;\n    padding: 1.25rem;\n    box-shadow: rgba(5, 27, 44, 0.08) 0 1px 8px -1px;\n    min-height: 300px;\n}\n\n.app-dashboard__chart-card h3 {\n    margin: 0 0 1rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #051b2c;\n}\n\n.app-dashboard__chart-empty {\n    margin: 2.5rem 0 1rem;\n    text-align: center;\n    color: #9ca3af;\n    font-size: 0.875rem;\n}\n\n.app-dashboard__chart-skeleton {\n    height: 240px;\n    width: 100%;\n    border-radius: 8px;\n    margin-top: 0.5rem;\n}\n\n.app-dashboard__empty {\n    background: #fff;\n    border-radius: 12px;\n    padding: 2rem;\n    text-align: center;\n    color: #6b7280;\n    box-shadow: rgba(5, 27, 44, 0.06) 0 1px 8px -1px;\n}\n\n.app-dashboard__skeleton {\n    width: 72px;\n    height: 28px;\n}\n\n/* Shared list styling (tickets, customers, staff, …). Scoped under\n   .ns-support-list so global tables (Users, Subscriptions, etc.) are untouched. */\n\n.ns-support-list .ns-tabs {\n  display: inline-flex;\n  background: #f1f3f5;\n  border-radius: 8px;\n  padding: 3px;\n  gap: 2px;\n  margin: 0 0 16px;\n}\n.ns-support-list .ns-tab {\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  padding: 6px 15px;\n  border-radius: 6px;\n  color: #6c757d;\n  font-weight: 400;\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s;\n}\n.ns-support-list .ns-tab:hover {\n  color: #212529;\n}\n.ns-support-list .ns-tab--active {\n  background: #fff;\n  color: #212529;\n  font-weight: 500;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.ns-support-list .dashboard_app_table {\n  border: 1px solid #e9eaee;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.ns-support-list table.table_outer thead th {\n  background: #f8f9fb;\n  color: #8a8f98;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: none;\n  padding: 11px 16px;\n  border-bottom: 1px solid #eceef1;\n}\n\n.ns-support-list table.table_outer tbody td {\n  padding: 12px 16px;\n  border-top: 1px solid #f1f3f5;\n  vertical-align: middle;\n  font-size: 13px;\n  color: #212529;\n}\n.ns-support-list table.table_outer tbody tr:first-child td {\n  border-top: none;\n}\n.ns-support-list .support-ticket-row--clickable {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.ns-support-list .support-ticket-row--clickable:hover td {\n  background: #f8f9fb;\n}\n\n.ns-support-list .ns-requester {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n.ns-support-list .ns-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n.ns-support-list .ns-requester-name {\n  color: #212529;\n  font-size: 13px;\n}\n.ns-support-list .ns-requester-email {\n  color: #9aa0a6;\n  font-size: 11px;\n}\n\n.ns-support-list .ns-pill {\n  display: inline-block;\n  font-size: 12px;\n  padding: 2px 9px;\n  border-radius: 6px;\n  background: #f1f3f5;\n  color: #495057;\n  text-transform: capitalize;\n}\n\n.ns-modal .modal-content {\n  border: none;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.16);\n}\n.ns-modal .modal-header {\n  padding: 15px 20px;\n  border-bottom: 1px solid #eceef1;\n  align-items: center;\n}\n.ns-modal .modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #212529;\n}\n.ns-modal .modal-body {\n  padding: 20px;\n}\n.ns-modal .modal-body .form-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6c757d;\n  margin-bottom: 5px;\n}\n.ns-modal .modal-body .form-control {\n  height: 38px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  font-size: 13px;\n  padding: 0 12px;\n  box-shadow: none;\n}\n.ns-modal .modal-body textarea.form-control {\n  height: auto;\n  padding: 8px 12px;\n}\n.ns-modal .modal-body .form-control:focus {\n  border-color: rgb(67, 70, 206);\n  box-shadow: 0 0 0 3px rgba(67, 70, 206, 0.12);\n}\n.ns-modal .modal-footer {\n  padding: 14px 20px;\n  border-top: 1px solid #eceef1;\n  gap: 8px;\n}\n.ns-modal .modal-footer .add_app_btn.btn_theme_primary {\n  display: inline-flex;\n  align-items: center;\n  background: rgb(67, 70, 206);\n  color: #fff;\n  border: none;\n  height: 38px;\n  padding: 0 18px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n}\n.ns-modal .modal-footer .add_app_btn.btn_theme_primary:hover {\n  background: rgb(56, 59, 180);\n}\n.ns-modal .modal-footer .add_app_btn.btn_theme_primary span {\n  color: #fff;\n}\n.ns-modal .modal-footer .btn_theme_secondary {\n  height: 38px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  background: #fff;\n  color: #495057;\n  font-size: 13px;\n  font-weight: 500;\n}\n.ns-modal .modal-footer .btn_theme_secondary:hover {\n  background: #f8f9fa;\n}\n/* ===== Collaborate / Partner Integrations ===== */\n.pi-page {\n  padding: 20px 24px;\n  min-height: 100vh;\n}\n\n.pi-page-title {\n  font-size: 28px;\n  font-weight: 600;\n  margin: 4px 0 16px;\n  color: #1a1a1a;\n}\n\n.pi-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 16px;\n}\n\n.pi-tab {\n  appearance: none;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  margin-bottom: -1px;\n}\n\n.pi-tab:hover {\n  color: #111827;\n}\n\n.pi-tab.active {\n  color: #111827;\n  border-bottom-color: #111827;\n}\n\n.pi-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.pi-search {\n  flex: 1 1 220px;\n  max-width: 320px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.pi-search:focus {\n  outline: none;\n  border-color: #4c5fd5;\n  box-shadow: 0 0 0 2px rgba(76, 95, 213, 0.15);\n}\n\n.pi-filter-select {\n  height: 36px;\n  min-width: 140px;\n  padding: 0 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  background: #fff;\n  color: #374151;\n}\n\n.pi-cards {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n}\n\n@media (min-width: 48em) {\n  .pi-cards {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (min-width: 75em) {\n  .pi-cards {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n\n.pi-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  min-height: 200px;\n  box-shadow: rgba(5, 27, 44, 0.06) 0px 1px 6px -1px;\n}\n\n.pi-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.pi-logo {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 15px;\n  object-fit: contain;\n  object-position: center;\n  background: #fff;\n  border: 1px solid #d1d5db;\n  box-sizing: border-box;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n.pi-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n  background: #f3f4f6;\n  border-radius: 999px;\n  padding: 4px 10px;\n}\n\n.pi-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #9ca3af;\n}\n\n.pi-status--active .pi-status-dot {\n  background: #16a34a;\n}\n\n.pi-status--active {\n  background: #ecfdf5;\n  color: #166534;\n}\n\n.pi-card-name {\n  margin: 0 0 4px;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pi-card-category {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.pi-card-stat {\n  margin: 0;\n  font-size: 13px;\n  color: #4b5563;\n  flex: 1;\n}\n\n.pi-card-actions {\n  display: flex;\n  gap: 16px;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.pi-card-actions a,\n.pi-card-actions button {\n  appearance: none;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #4c5fd5;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.pi-card-actions a:hover,\n.pi-card-actions button:hover {\n  text-decoration: underline;\n}\n\n.pi-empty {\n  padding: 48px 24px;\n  text-align: center;\n  color: #6b7280;\n  border: 1px dashed #d1d5db;\n  border-radius: 10px;\n  background: #fafafa;\n}\n\n.pi-detail-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: #4c5fd5;\n  text-decoration: none;\n  margin-bottom: 0;\n}\n\n.pi-detail-back:hover {\n  text-decoration: underline;\n}\n\n.pi-detail-shell {\n  margin-top: 0;\n  height: calc(100vh - 4.5rem);\n  min-height: 0;\n}\n\n.pi-detail-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.pi-detail-top {\n  flex-shrink: 0;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 16px 20px 14px;\n}\n\n.pi-detail-tabs {\n  flex-shrink: 0;\n  display: flex;\n  gap: 0;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 0 20px;\n  margin-top: 10px;\n}\n\n.pi-detail-tabs .pi-tab {\n  margin-bottom: -1px;\n}\n\n.pi-detail-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n.pi-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 0;\n}\n\n.pi-detail-header h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.pi-schema-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pi-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.pi-field input,\n.pi-field select {\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #111827;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.pi-field input:disabled,\n.pi-field select:disabled {\n  background: #f9fafb;\n  color: #6b7280;\n}\n\n.pi-remove-btn {\n  appearance: none;\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 12px;\n  color: #dc2626;\n  cursor: pointer;\n}\n\n.pi-remove-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pi-section {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 4px 20px 18px;\n  margin-bottom: 0;\n}\n\n.pi-section > .pi-block:first-child {\n  border-top: none;\n  padding-top: 14px;\n}\n\n.pi-block {\n  padding: 18px 0;\n  border-top: 1px solid #f3f4f6;\n}\n\n.pi-block h2 {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pi-block p,\n.pi-section > p {\n  margin: 0 0 8px;\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n.pi-section h2 {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pi-section p {\n  margin: 0 0 8px;\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n.pi-kv {\n  display: grid;\n  gap: 10px;\n}\n\n.pi-kv-row {\n  display: grid;\n  grid-template-columns: 180px 1fr auto;\n  gap: 10px;\n  align-items: start;\n  padding: 10px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.pi-kv-row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.pi-kv-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.pi-kv-value {\n  font-size: 13px;\n  color: #111827;\n  word-break: break-all;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.pi-kv-value.plain {\n  font-family: inherit;\n}\n\n.pi-copy-btn {\n  appearance: none;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 12px;\n  color: #374151;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.pi-copy-btn:hover {\n  background: #f9fafb;\n}\n\n.pi-params {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pi-param-chip {\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  background: #f3f4f6;\n  color: #374151;\n  border-radius: 6px;\n  padding: 4px 8px;\n}\n\n.pi-token-toggle {\n  appearance: none;\n  border: none;\n  background: none;\n  color: #4c5fd5;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 8px;\n}\n\n@media (max-width: 640px) {\n  .pi-kv-row {\n    grid-template-columns: 1fr;\n  }\n\n  .pi-page {\n    padding: 16px;\n  }\n}\n\n.pi-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n}\n\n.pi-toggle-row.compact {\n  margin: 0;\n}\n\n/* Same checkbox look across activate / postbacks / schema toggles */\n.pi-detail-layout input[type=\"checkbox\"],\n.pi-toggle-row input[type=\"checkbox\"],\n.pi-map-row input[type=\"checkbox\"] {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  border: 2px solid #c7cad1;\n  border-radius: 4px;\n  background: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n  display: inline-grid;\n  place-content: center;\n  vertical-align: middle;\n}\n\n.pi-detail-layout input[type=\"checkbox\"]::before,\n.pi-toggle-row input[type=\"checkbox\"]::before,\n.pi-map-row input[type=\"checkbox\"]::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  transform: scale(0);\n  transition: transform 0.12s ease-in-out;\n  box-shadow: inset 1em 1em #fff;\n  transform-origin: center;\n  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);\n}\n\n.pi-detail-layout input[type=\"checkbox\"]:checked,\n.pi-toggle-row input[type=\"checkbox\"]:checked,\n.pi-map-row input[type=\"checkbox\"]:checked {\n  background: #4c5fd5;\n  border-color: #4c5fd5;\n}\n\n.pi-detail-layout input[type=\"checkbox\"]:checked::before,\n.pi-toggle-row input[type=\"checkbox\"]:checked::before,\n.pi-map-row input[type=\"checkbox\"]:checked::before {\n  transform: scale(1);\n}\n\n.pi-detail-layout input[type=\"checkbox\"]:disabled,\n.pi-toggle-row input[type=\"checkbox\"]:disabled,\n.pi-map-row input[type=\"checkbox\"]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pi-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.pi-section-head h2 {\n  margin: 0;\n}\n\n.pi-window-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 8px 0 12px;\n}\n\n.pi-radio {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #374151;\n}\n\n.pi-window-value {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  font-size: 13px;\n  color: #4b5563;\n}\n\n.pi-window-slider {\n  flex: 1;\n  max-width: 420px;\n  min-width: 0;\n}\n\n.pi-window-value input[type=\"range\"] {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n}\n\n.pi-window-ticks {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 4px;\n  font-size: 11px;\n  color: #9ca3af;\n  padding: 0 2px;\n}\n\n.pi-window-readout {\n  flex-shrink: 0;\n  padding-top: 2px;\n  font-weight: 500;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.pi-map-table {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pi-map-table--default .pi-map-head,\n.pi-map-table--default .pi-map-row {\n  display: grid;\n  grid-template-columns: 160px 220px;\n  gap: 12px;\n  align-items: center;\n  justify-content: start;\n}\n\n.pi-map-table--default .pi-map-row input[disabled] {\n  background: #f3f4f6;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.pi-map-table--3 .pi-map-head,\n.pi-map-table--3 .pi-map-row {\n  display: grid;\n  grid-template-columns: 160px minmax(160px, 220px) auto;\n  gap: 12px;\n  align-items: center;\n}\n\n.pi-map-table--5 .pi-map-head,\n.pi-map-table--5 .pi-map-row {\n  display: grid;\n  grid-template-columns: minmax(120px, 1fr) minmax(140px, 1.2fr) minmax(140px, 180px) minmax(140px, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.pi-map-head {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.pi-map-row select,\n.pi-map-row input[type=\"text\"],\n.pi-map-row input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]) {\n  width: 100%;\n  height: 34px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 0 8px;\n  font-size: 13px;\n}\n\n.pi-map-empty {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 8px 0;\n}\n\n.pi-check-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  cursor: pointer;\n  margin: 4px 0 0;\n}\n\n.pi-check-label--title {\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.pi-check-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n}\n\n.pi-map-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n\n.pi-bulk-wrap {\n  position: relative;\n}\n\n.pi-bulk-btn {\n  appearance: none;\n  background: #fff;\n  border: 1px solid #4c5fd5;\n  color: #4c5fd5;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pi-bulk-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pi-bulk-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 20;\n  width: 280px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n  padding: 12px;\n}\n\n.pi-bulk-group {\n  margin-bottom: 12px;\n}\n\n.pi-bulk-group-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6b7280;\n  margin-bottom: 6px;\n  text-transform: lowercase;\n}\n\n.pi-bulk-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #374151;\n  margin: 6px 0;\n  cursor: pointer;\n}\n\n.pi-bulk-confirm {\n  width: 100%;\n  justify-content: center;\n}\n\n.pi-map-table--events .pi-map-head,\n.pi-map-table--events .pi-map-row {\n  display: grid;\n  grid-template-columns: 36px minmax(120px, 1fr) minmax(150px, 1.2fr) minmax(140px, 180px) minmax(140px, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.pi-map-event {\n  padding: 8px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.pi-map-event:last-child {\n  border-bottom: none;\n}\n\n.pi-map-partner-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.pi-map-partner-cell .pi-map-creatable {\n  flex: 1;\n  min-width: 0;\n}\n\n.pi-map-creatable--cond {\n  flex: 1;\n  min-width: 140px;\n}\n\n.pi-map-partner-cell input {\n  flex: 1;\n  min-width: 0;\n}\n\n.pi-map-chevron {\n  color: #9ca3af;\n  font-size: 18px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.pi-map-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pi-icon-btn {\n  appearance: none;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.pi-icon-btn:hover {\n  background: #f3f4f6;\n}\n\n.pi-icon-btn--danger {\n  color: #dc2626;\n}\n\n.pi-icon-btn--danger:hover {\n  background: #fef2f2;\n}\n\n.pi-icon-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pi-conditions {\n  margin: 8px 0 4px 36px;\n  padding-left: 12px;\n  border-left: 2px dashed #d1d5db;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pi-condition-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.pi-condition-row input {\n  height: 34px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 0 8px;\n  font-size: 13px;\n  min-width: 110px;\n  flex: 1;\n}\n\n.pi-condition-when {\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.pi-add-condition {\n  appearance: none;\n  border: none;\n  background: none;\n  color: #4c5fd5;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n  align-self: flex-start;\n}\n\n.pi-add-event {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #4c5fd5;\n  background: #fff;\n  color: #4c5fd5;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 8px 14px;\n  border-radius: 8px;\n  margin-top: 12px;\n}\n\n.pi-add-event:hover {\n  background: #eef2ff;\n}\n\n.pi-footer-bar {\n  flex-shrink: 0;\n  position: relative;\n  bottom: auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 20px;\n  margin-top: 0;\n  background: #fff;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pi-footer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.pi-unsaved {\n  font-size: 13px;\n  color: #b45309;\n  background: #fffbeb;\n  border: 1px solid #fcd34d;\n  border-radius: 6px;\n  padding: 6px 10px;\n}\n\n.pi-btn-primary,\n.pi-btn-ghost {\n  appearance: none;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pi-btn-primary {\n  background: #4c5fd5;\n  color: #fff;\n  border: none;\n}\n\n.pi-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pi-btn-ghost {\n  background: #fff;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.pi-btn-ghost:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .pi-map-table--default .pi-map-head,\n  .pi-map-table--default .pi-map-row,\n  .pi-map-table--3 .pi-map-head,\n  .pi-map-table--3 .pi-map-row,\n  .pi-map-table--5 .pi-map-head,\n  .pi-map-table--5 .pi-map-row,\n  .pi-map-table--events .pi-map-head,\n  .pi-map-table--events .pi-map-row {\n    grid-template-columns: 1fr;\n  }\n\n  .pi-conditions {\n    margin-left: 0;\n  }\n}\n\n/* Message report (push + WhatsApp campaign detail) */\n.message-report-container {\n    padding: 20px;\n    background-color: #f8f9fa;\n    min-height: 100vh;\n    width: 100%;\n    max-width: none;\n}\n\n.wa-campaign-report.message-report-container {\n    width: 100%;\n    max-width: none;\n}\n\n.report-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.report-breadcrumb {\n    font-size: 14px;\n    color: #6c757d;\n}\n\n.breadcrumb-link {\n    color: #6c5ce7;\n    cursor: pointer;\n}\n\n.breadcrumb-link:hover {\n    text-decoration: underline;\n}\n\n.breadcrumb-separator {\n    margin: 0 8px;\n    color: #6c757d;\n}\n\n.breadcrumb-current {\n    color: #212529;\n}\n\n.message-title-section {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 10px;\n}\n\n.message-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #212529;\n    margin: 0;\n    max-width: 80%;\n}\n\n.message-meta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    font-size: 13px;\n    color: #6c757d;\n    margin-bottom: 25px;\n}\n\n.message-meta-started {\n    white-space: nowrap;\n    margin-right: 6px;\n}\n\n/* Stats Cards */\n.stats-cards {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    margin-bottom: 30px;\n}\n\n.stat-card {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.stat-label {\n    font-size: 12px;\n    color: #6c757d;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n}\n\n.stat-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: #212529;\n}\n\n.stat-sublabel {\n    font-size: 12px;\n    color: #6c757d;\n}\n\n/* Chart Section */\n.chart-section {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 30px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.chart-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.chart-header h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.chart-filters {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.chart-note {\n    font-size: 12px;\n    color: #6c757d;\n    margin-bottom: 20px;\n}\n\n.chart-container {\n    height: 200px;\n    border: 1px solid #e9ecef;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.chart-placeholder {\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n}\n\n.chart-line {\n    width: 100%;\n    height: 100%;\n}\n\n.chart-legend {\n    display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: #495057;\n}\n\n.legend-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n}\n\n.legend-dot.clicks {\n    background-color: #6c5ce7;\n}\n\n.legend-dot.confirmed {\n    background-color: #00b894;\n}\n\n.legend-dot.sessions {\n    background-color: #e17055;\n}\n\n.legend-item.add-outcome {\n    color: #6c5ce7;\n    cursor: pointer;\n}\n\n/* Outcomes Table */\n.outcomes-section {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 30px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.outcomes-table {\n    margin-bottom: 10px;\n}\n\n.outcomes-table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n    font-size: 13px;\n}\n\n.show-all-link {\n    color: #6c5ce7;\n    font-size: 13px;\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n}\n\n.show-all-link:hover {\n    text-decoration: underline;\n}\n\n/* Statistics Row */\n.statistics-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    margin-bottom: 30px;\n}\n\n.delivery-stats,\n.platform-stats {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.delivery-stats h4,\n.platform-stats h4 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n.platform-label {\n    font-size: 13px;\n    color: #6c757d;\n    margin-bottom: 10px;\n}\n\n.progress-bar-container {\n    height: 8px;\n    background-color: #e9ecef;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    overflow: hidden;\n}\n\n.progress-bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #6c5ce7, #a29bfe);\n    border-radius: 4px;\n}\n\n.progress-bar-fill.android {\n    background: #4CAF50;\n}\n\n.stats-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.stats-list li {\n    display: flex;\n    align-items: center;\n    padding: 8px 0;\n    font-size: 13px;\n    border-bottom: 1px solid #f1f3f5;\n}\n\n.stats-list li:last-child {\n    border-bottom: none;\n}\n\n.stats-list .dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.stats-list .value {\n    margin-left: auto;\n    font-weight: 500;\n}\n\n.dot.audience {\n    background-color: #6c5ce7;\n}\n\n.dot.sent {\n    background-color: #a29bfe;\n}\n\n.dot.delivered {\n    background-color: #00b894;\n}\n\n.dot.confirmed {\n    background-color: #00cec9;\n}\n\n.dot.unsubscribed {\n    background-color: #e17055;\n}\n\n.dot.error {\n    background-color: #d63031;\n}\n\n.dot.remaining {\n    background-color: #fdcb6e;\n}\n\n.dot.canceled {\n    background-color: #636e72;\n}\n\n.dot.android {\n    background-color: #4CAF50;\n}\n\n/* Audience Activity */\n.audience-activity {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 30px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.activity-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.activity-header h4 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.activity-filters {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-bottom: 15px;\n}\n\n.filter-chip {\n    padding: 6px 12px;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 20px;\n    font-size: 12px;\n    color: #495057;\n    cursor: pointer;\n}\n\n.filter-chip:hover {\n    background-color: #e9ecef;\n}\n\n.filter-chip--active {\n    background-color: #e8f0fe;\n    border: 2px solid #6c5ce7;\n    color: #3d2fb8;\n    font-weight: 600;\n    box-shadow: 0 0 0 1px rgba(108, 92, 231, 0.25);\n}\n\n.filter-chip:focus-visible {\n    outline: 2px solid #6c5ce7;\n    outline-offset: 2px;\n}\n\n.activity-table-wrap {\n    position: relative;\n}\n\n.activity-table-wrap--loading {\n    opacity: 0.65;\n    pointer-events: none;\n}\n\n.activity-pagination {\n    border-top: 1px solid #f1f3f5;\n    margin-top: 4px;\n}\n\n.activity-table {\n    margin-bottom: 15px;\n}\n\n.activity-table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n    font-size: 12px;\n}\n\n.activity-table td {\n    font-size: 13px;\n}\n\n.truncate {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.failure-reason-cell {\n    max-width: 320px;\n}\n\n.device-badge {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 8px;\n    background-color: #e8f5e9;\n    border-radius: 4px;\n    font-size: 12px;\n}\n\n.subscription-badge {\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 500;\n}\n\n.subscription-badge.subscribed {\n    background-color: #d4edda;\n    color: #155724;\n}\n\n.subscription-badge.pending {\n    background-color: #fff3cd;\n    color: #856404;\n}\n\n.subscription-badge.failed {\n    background-color: #f8d7da;\n    color: #721c24;\n}\n\n.activity-note {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    color: #6c757d;\n    margin: 0;\n}\n\n/* Message Settings */\n.message-settings-section {\n    background: white;\n    border-radius: 8px;\n    padding: 25px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.message-settings-section>h4 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 25px;\n    color: #212529;\n}\n\n.settings-content {\n    display: flex;\n    gap: 40px;\n}\n\n.settings-details {\n    border-right: 1px solid #e9ecef;\n    padding-right: 40px;\n    flex: 1;\n}\n\n.settings-group-header {\n    font-size: 14px;\n    font-weight: 600;\n    color: #212529;\n    margin-top: 20px;\n    margin-bottom: 12px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.settings-group-header:first-child {\n    margin-top: 0;\n}\n\n.settings-group-header.android-header {\n    color: #212529;\n}\n\n.settings-row {\n    display: grid;\n    grid-template-columns: 200px 1fr;\n    padding: 10px 0;\n    border-bottom: 1px solid #f1f3f5;\n    font-size: 13px;\n}\n\n.settings-row:last-of-type {\n    border-bottom: none;\n}\n\n.settings-label {\n    color: #495057;\n}\n\n.settings-value {\n    color: #212529;\n}\n\n.message-row {\n    border-bottom: none;\n    padding-bottom: 5px;\n}\n\n.message-content-row {\n    padding-top: 0;\n}\n\n.language-label {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n}\n\n.language-indicator {\n    width: 2px;\n    height: 100%;\n    min-height: 40px;\n    background-color: #dee2e6;\n    display: inline-block;\n}\n\n.message-text {\n    color: #495057;\n    line-height: 1.5;\n}\n\n/* Phone Preview - Same style as PushNotification */\n.phone-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 20px;\n}\n\n.mobile-image-report {\n    width: 320px;\n    height: 640px;\n    background-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 280 500\"><rect width=\"280\" height=\"500\" rx=\"30\" fill=\"%23f5f5f5\" stroke=\"%23e0e0e0\" stroke-width=\"2\"/><rect x=\"10\" y=\"10\" width=\"260\" height=\"480\" rx=\"25\" fill=\"%23ffffff\"/><circle cx=\"140\" cy=\"25\" r=\"5\" fill=\"%23333\"/></svg>');\n    background-size: cover;\n    background-position: center;\n    border-radius: 30px;\n    padding: 50px 20px 20px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n    position: relative;\n    background-color: #f8f9fa;\n    border: 8px solid #e0e0e0;\n}\n\n.notification-card-report {\n    display: flex;\n    background: white;\n    border-radius: 12px;\n    padding: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    gap: 12px;\n}\n\n.profile-report {\n    flex-shrink: 0;\n}\n\n.profile-report img {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n}\n\n.notification-content-report {\n    flex: 1;\n    min-width: 0;\n}\n\n.app-name-report {\n    font-size: 12px;\n    color: #666;\n    margin-bottom: 4px;\n}\n\n.notification-title-report {\n    font-size: 14px;\n    margin-bottom: 2px;\n    color: #212529;\n}\n\n.notification-body-report {\n    font-size: 14px;\n    color: #333;\n    margin-bottom: 0;\n    line-height: 1.4;\n    word-wrap: break-word;\n}\n\n.preview-label {\n    margin-top: 20px;\n    font-size: 13px;\n    color: #6c757d;\n    text-align: center;\n}\n\n/* Status Badge */\n.status-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.status-badge.delivered {\n    background-color: #d4edda;\n    color: #155724;\n}\n\n.status-badge.failed {\n    background-color: #f8d7da;\n    color: #721c24;\n}\n\n.status-badge.pending {\n    background-color: #fff3cd;\n    color: #856404;\n}\n\n.status-badge.processing {\n    background-color: #d1ecf1;\n    color: #0c5460;\n}\n\n.status-badge.cancelled {\n    background-color: #e2e3e5;\n    color: #383d41;\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n    .stats-cards {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .statistics-row {\n        grid-template-columns: 1fr;\n    }\n\n    .settings-content {\n        grid-template-columns: 1fr;\n    }\n\n    .settings-details {\n        border-right: none;\n        padding-right: 0;\n        border-bottom: 1px solid #e9ecef;\n        padding-bottom: 30px;\n        margin-bottom: 30px;\n    }\n\n    .phone-preview {\n        order: 1;\n    }\n\n    .settings-row {\n        grid-template-columns: 1fr;\n        gap: 5px;\n    }\n}\n\n@media (max-width: 576px) {\n    .stats-cards {\n        grid-template-columns: 1fr;\n    }\n\n    .phone-frame-modern {\n        width: 220px;\n        height: 400px;\n    }\n}\n\n/* WhatsApp platform (inbox, contacts, campaigns, phones, …) */\n.wa-platform {\n  padding: 1rem 1.25rem 2rem;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n}\n\n.wa-platform__header {\n  margin-bottom: 1.25rem;\n}\n\n.wa-platform__title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem 1rem;\n  flex-wrap: wrap;\n}\n\n.wa-platform__header-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n.wa-platform__title {\n  font-size: 1.35rem;\n  font-weight: 600;\n  margin: 0;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.wa-platform__phone-tools {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-left: auto;\n}\n\n.wa-platform__active-phone {\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: #111b21;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n\n.wa-msg-link {\n  display: inline-flex;\n  align-items: center;\n}\n\n.wa-msg-link__copy {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  padding: 0.2rem;\n  color: #6c757d;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.wa-msg-link__copy:hover {\n  color: #198754;\n  background: rgba(25, 135, 84, 0.08);\n}\n\n.wa-platform__subtitle {\n  margin: 0.25rem 0 0;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.wa-md strong {\n  font-weight: 700;\n}\n\n.wa-md em {\n  font-style: italic;\n}\n\n.wa-md s {\n  text-decoration: line-through;\n}\n\n.wa-md code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.92em;\n}\n\n/* WhatsApp template CTA row — keep fields + remove on one line, equal heights */\n.ns-wa-tpl-btn-row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  gap: 0.5rem;\n  overflow-x: auto;\n}\n.ns-wa-tpl-btn-row .form-control,\n.ns-wa-tpl-btn-row .form-select {\n  height: 38px;\n  min-height: 38px;\n  font-size: 0.875rem;\n}\n.ns-wa-tpl-btn-field {\n  min-width: 0;\n}\n.ns-wa-tpl-btn-field--type {\n  flex: 0 1 11rem;\n}\n.ns-wa-tpl-btn-field--text {\n  flex: 0 1 10rem;\n}\n.ns-wa-tpl-btn-field--urltype {\n  flex: 0 0 8.5rem;\n}\n.ns-wa-tpl-btn-field--grow {\n  flex: 1 1 12rem;\n}\n.ns-wa-tpl-btn-remove {\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  flex: 0 0 38px;\n  line-height: 1;\n}\n.ns-wa-tpl-btn-remove svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.wa-tpl-body-wrap {\n  position: relative;\n}\n.wa-tpl-body-wrap .form-control {\n  padding-right: 4.5rem;\n}\n.ns-wa-tpl-btn-row .ns-wa-tpl-btn-type__control {\n  min-height: 38px !important;\n  height: 38px !important;\n}\n.wa-tpl-body-count {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  font-size: 12px;\n  color: #6c757d;\n  pointer-events: none;\n}\n.wa-tpl-body-toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 2px;\n  margin-top: 6px;\n}\n.wa-tpl-body-toolbar button {\n  border: none;\n  background: transparent;\n  color: #54656f;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 1;\n}\n.wa-tpl-body-toolbar button:hover {\n  background: #f0f2f5;\n}\n.wa-tpl-body-toolbar .wa-tpl-body-toolbar-addvar {\n  color: rgb(67, 70, 206);\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.wa-muted {\n  color: #6c757d;\n  font-size: 0.875rem;\n}\n\n.wa-card {\n  border: none;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.wa-usage-type {\n  min-width: 160px;\n}\n\n/* Inbox uses the full window — no max-width cap, full viewport height */\n.wa-platform--full {\n  max-width: none;\n  padding-bottom: 1rem;\n}\n\n.wa-platform--full .wa-platform__header {\n  margin-bottom: 0.75rem;\n}\n\n.wa-inbox {\n  display: grid;\n  grid-template-columns: minmax(280px, 360px) 1fr;\n  gap: 1rem;\n  height: calc(100vh - 150px);\n  min-height: 480px;\n}\n\n@media (max-width: 991px) {\n  .wa-inbox {\n    grid-template-columns: 1fr;\n    height: auto;\n  }\n}\n\n.wa-inbox__list,\n.wa-inbox__thread {\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.wa-inbox__list-head {\n  padding: 0.85rem 1rem;\n  font-weight: 600;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  background: #f7f8fa;\n}\n\n.wa-inbox__list-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.wa-inbox__list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 2.5rem 1.25rem;\n}\n\n.wa-inbox__row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  text-align: left;\n  border: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  background: #fff;\n  padding: 0.7rem 0.9rem;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.wa-inbox__row:hover {\n  background: #f5f6f6;\n}\n\n.wa-inbox__row.active {\n  background: #ecedfb;\n}\n\n.wa-avatar {\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4346ce, #6b6ee8);\n  color: #fff;\n  font-weight: 600;\n  font-size: 1.05rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wa-avatar--lg {\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n}\n\n.wa-inbox__row-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.wa-inbox__row-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 0.5rem;\n}\n\n.wa-inbox__phone {\n  font-size: 0.92rem;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wa-inbox__time {\n  font-size: 0.72rem;\n  color: #8696a0;\n  flex: 0 0 auto;\n}\n\n.wa-inbox__row-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.15rem;\n}\n\n.wa-badge {\n  background: #4346ce;\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  flex: 0 0 auto;\n}\n\n.wa-inbox__preview {\n  font-size: 0.82rem;\n  color: #6c757d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wa-inbox__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  text-align: center;\n  padding: 2rem;\n  gap: 0.35rem;\n  background: #f8f9fa;\n}\n\n.wa-inbox__empty-icon {\n  width: 44px;\n  height: 44px;\n  opacity: 0.45;\n  color: #6c757d;\n  flex-shrink: 0;\n}\n\n.wa-inbox__list-empty .wa-inbox__empty-icon {\n  width: 36px;\n  height: 36px;\n}\n\n.wa-inbox__empty-title {\n  font-weight: 600;\n  font-size: 1.05rem;\n}\n\n.wa-tick {\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  color: #8696a0;\n  margin-left: 2px;\n}\n\n.wa-tick--read {\n  color: #53bdeb;\n}\n\n.wa-tick--fail {\n  color: #d92d20;\n}\n\n.wa-inbox__thread-head {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  padding: 0.6rem 1rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  background: #f7f8fa;\n}\n\n.wa-inbox__thread-title {\n  flex: 1;\n  min-width: 0;\n  line-height: 1.25;\n}\n\n.wa-session-pill {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.25rem 0.6rem;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.wa-session-pill--open {\n  background: #d9f3e5;\n  color: #0f7a4d;\n}\n\n.wa-session-pill--closed {\n  background: #feecec;\n  color: #b42318;\n}\n\n.wa-inbox__messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.25rem 1.5rem;\n  background: #efeae2;\n  background-image: radial-gradient(rgba(0, 0, 0, 0.025) 1px, transparent 1px);\n  background-size: 22px 22px;\n}\n\n.wa-bubble {\n  max-width: 68%;\n  padding: 0.45rem 0.7rem 0.3rem;\n  border-radius: 10px;\n  margin-bottom: 0.4rem;\n  font-size: 0.9rem;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);\n  width: fit-content;\n}\n\n/* WhatsApp-like: media bubbles use a fixed wider width so images aren't cramped/cropped */\n.wa-bubble--media {\n  width: min(330px, 88%);\n  max-width: min(330px, 88%);\n  padding: 0.2rem 0.2rem 0.3rem;\n}\n\n.wa-bubble--media .wa-bubble__tpl-label,\n.wa-bubble--media .wa-bubble__text,\n.wa-bubble--media .wa-bubble__footer {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.wa-bubble--in {\n  background: #fff;\n  margin-right: auto;\n  border-top-left-radius: 2px;\n}\n\n.wa-bubble--out {\n  background: #e6e7fa;\n  margin-left: auto;\n  border-top-right-radius: 2px;\n}\n\n.wa-bubble__text {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.wa-bubble__tpl-label {\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 0.2rem;\n}\n\n.wa-inbox__composer-closed {\n  width: 100%;\n  padding: 0.25rem 0;\n}\n\n.wa-inbox__composer-stack {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.wa-inbox__composer-block-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n  color: #374151;\n}\n\n.wa-inbox__composer-block--tpl {\n  padding-top: 0.65rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.wa-inbox__tpl-preview {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 0.65rem 0.85rem;\n}\n\n.wa-inbox__tpl-preview-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #6c757d;\n  margin-bottom: 0.35rem;\n}\n\n.wa-inbox__tpl-preview-body {\n  font-size: 0.9rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: #1f2937;\n  line-height: 1.4;\n}\n\n.wa-bubble__media {\n  margin: 0 0 0.35rem;\n  overflow: hidden;\n  border-radius: 6px;\n  background: #e9edef;\n}\n\n.wa-bubble__media--image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 80px;\n}\n\n.wa-bubble__media--image img,\n.wa-bubble__media--video video {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 420px;\n  object-fit: contain;\n  object-position: center;\n  background: #e9edef;\n}\n\n.wa-bubble__media--video video {\n  background: #000;\n  max-height: 420px;\n}\n\n.wa-bubble__media--pending,\n.wa-bubble__media--doc {\n  padding: 0.45rem 0.55rem;\n  font-size: 0.8rem;\n  color: #667781;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.wa-bubble__media--location {\n  margin: 0 0 0.35rem;\n}\n\n.wa-bubble__location-card {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n  padding: 0.5rem 0.55rem;\n  text-decoration: none;\n  color: inherit;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 6px 6px 0 0;\n}\n\n.wa-bubble__location-pin {\n  font-size: 1.1rem;\n  line-height: 1.2;\n}\n\n.wa-bubble__location-title {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #111b21;\n}\n\n.wa-bubble__location-sub,\n.wa-bubble__location-coords {\n  font-size: 0.72rem;\n  color: #667781;\n  margin-top: 0.1rem;\n}\n\n.wa-bubble__media a {\n  text-decoration: none;\n}\n\n.wa-bubble__footer {\n  font-size: 0.66rem;\n  color: #8696a0;\n  text-align: right;\n  margin-top: 0.15rem;\n}\n\n.wa-inbox__composer {\n  padding: 0.5rem 0.75rem 0.4rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  background: #f7f8fa;\n}\n\n.wa-inbox__composer-box {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.wa-inbox__composer-top {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.wa-inbox__tpl-select {\n  width: auto;\n  max-width: 220px;\n  min-width: 140px;\n  flex: 0 1 auto;\n}\n\n.wa-inbox__tpl-vars {\n  flex: 1 1 120px;\n  max-width: 200px;\n  min-width: 100px;\n}\n\n.wa-inbox__tpl-header-file {\n  flex: 0 1 150px;\n  min-width: 110px;\n  max-width: 180px;\n}\n\n.wa-inbox__tpl-header-url {\n  flex: 1 1 140px;\n  min-width: 120px;\n  max-width: 220px;\n}\n\n.wa-inbox__tpl-header-coord {\n  flex: 0 1 90px;\n  min-width: 70px;\n  max-width: 110px;\n}\n\n.wa-inbox__composer-main {\n  display: flex;\n  gap: 0.45rem;\n  align-items: flex-end;\n}\n\n.wa-composer-input {\n  resize: vertical;\n  border-radius: 12px;\n  padding: 0.4rem 0.75rem;\n  min-height: 40px;\n  max-height: 280px;\n  flex: 1;\n  line-height: 1.35;\n  font-size: 0.875rem;\n}\n\n.wa-composer-input--preview {\n  background: #fff;\n  color: #374151;\n  cursor: default;\n}\n\n.wa-inbox__session-bar {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.7rem;\n  line-height: 1.3;\n  padding: 0.15rem 0 0;\n}\n\n.wa-inbox__session-bar--open {\n  color: #027a48;\n}\n\n.wa-inbox__session-bar--closed {\n  color: #b42318;\n}\n\n.wa-inbox__session-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex: 0 0 auto;\n  background: currentColor;\n}\n\n.wa-send-btn {\n  border-radius: 20px;\n  min-width: 42px;\n  height: 36px;\n  flex: 0 0 auto;\n  background: #4346ce !important;\n  border-color: #4346ce !important;\n  color: #fff !important;\n  padding: 0 0.75rem;\n}\n\n.wa-send-btn:hover:not(:disabled) {\n  background: #3538b8 !important;\n  border-color: #3538b8 !important;\n}\n\n.wa-kpi {\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.wa-kpi__val {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #4346ce;\n}\n\n.wa-profile-img {\n  max-width: 120px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n/* SweetAlert above page drawers/portals (e.g. z-index 1065); Safari scrollbar overlap */\n.swal2-container {\n  z-index: 20000 !important;\n}\n\n\n\n.automation-builder {\n    width: 100%;\n    height: calc(100vh - 60px);\n    display: flex;\n    flex-direction: column;\n    background: #f8fafc;\n    overflow: hidden;\n}\n\n/* =========================\n   HEADER\n========================= */\n\n.automation-live-errors {\n    background: #fef2f2;\n    border-bottom: 1px solid #fecaca;\n    color: #991b1b;\n    font-size: 13px;\n    line-height: 1.45;\n    padding: 8px 20px;\n}\n.automation-live-errors div + div {\n    margin-top: 4px;\n}\n\n.automation-header {\n    min-height: 70px;\n    padding: 12px 20px;\n    background: #ffffff;\n    border-bottom: 1px solid #e5e7eb;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    flex-shrink: 0;\n}\n\n.automation-back-btn {\n    width: 38px;\n    height: 38px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    vertical-align: middle;\n}\n\n.automation-header h4 {\n    margin: 0 0 4px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #111827;\n}\n\n.automation-header span {\n    font-size: 13px;\n    color: #6b7280;\n}\n\n.automation-header button {\n    margin-left: 0;\n}\n\n/* =========================\n   MAIN WORKSPACE\n========================= */\n\n.automation-workspace {\n    position: relative;\n    flex: 1;\n    min-height: 0;\n\n    display: flex;\n\n    overflow: hidden;\n}\n\n\n/* =========================\n   INSERT MENU\n========================= */\n\n.automation-insert-menu {\n    position: absolute;\n    pointer-events: all;\n\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(0,0,0,0.15);\n    padding: 8px;\n    z-index: 1000;\n    width: 220px;\n    max-height: 60vh;\n    overflow-y: auto;\n}\n\n.automation-insert-menu .menu-group-title {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: #9ca3af;\n    padding: 8px 10px 4px;\n}\n.automation-insert-menu button {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    text-align: left;\n    padding: 8px 10px;\n    border: none;\n    background: none;\n    border-radius: 6px;\n    font-size: 13px;\n}\n.automation-insert-menu button:hover { background: #f3f4f6; }\n.automation-insert-menu .menu-icon {\n    width: 22px; height: 22px; border-radius: 6px;\n    display: flex; align-items: center; justify-content: center;\n    color: #fff; flex-shrink: 0; font-size: 13px;\n}\n.automation-edge-plus-btn {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    border: 1.5px solid #c7c9d9;\n    background: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    line-height: 0;\n    color: #4c5fd5;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.automation-edge-plus-btn:hover {\n    background: #eef0ff;\n    border-color: #4c5fd5;\n    box-shadow: 0 0 0 6px rgba(76, 95, 213, 0.12);\n}\n.automation-edge-plus-btn svg {\n    width: 12px;\n    height: 12px;\n    display: block;\n}\n\n\n.automation-header > div:last-child {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.automation-more-options .dropdown-toggle::after {\n    transition: transform 0.15s ease;\n}\n.automation-more-options.show .dropdown-toggle::after {\n    transform: rotate(180deg);\n}\n\n.automation-more-options .dropdown-menu-subscription {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 6px;\n    overflow: hidden; /* hover-highlight ko rounded border ke andar clip karne ke liye */\n}\n\n/* =========================\n   SET LIVE CHECKLIST MODAL\n========================= */\n\n.automation-setlive-modal .modal-body {\n    max-height: 60vh;\n    overflow-y: auto;\n}\n\n.automation-setlive-checking {\n    padding: 24px 0;\n    text-align: center;\n    color: #6b7280;\n    font-size: 14px;\n}\n\n.automation-setlive-checklist {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.automation-setlive-checklist li {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 9px 0;\n    border-bottom: 1px solid #f1f2f6;\n    font-size: 13.5px;\n    color: #374151;\n}\n\n.automation-setlive-checklist li:last-child {\n    border-bottom: none;\n}\n\n.automation-setlive-checklist-icon {\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 1px;\n}\n\n.automation-setlive-checklist li {\n    transition: opacity 0.2s ease;\n}\n\n.automation-setlive-checklist li.is-pending {\n    opacity: 0.55;\n}\n\n.automation-setlive-checklist li.is-ok .automation-setlive-checklist-icon {\n    background: rgba(34, 197, 94, 0.12);\n    color: #16a34a;\n}\n\n.automation-setlive-checklist li.is-fail .automation-setlive-checklist-icon {\n    background: rgba(239, 68, 68, 0.12);\n    color: #dc2626;\n}\n\n.automation-setlive-checklist li.is-pending .automation-setlive-checklist-icon {\n    background: rgba(107, 114, 128, 0.1);\n}\n\n.automation-setlive-spinner {\n    width: 13px;\n    height: 13px;\n    border: 2px solid rgba(107, 114, 128, 0.35);\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    display: inline-block;\n    animation: btn-spin 0.8s linear infinite;\n}\n\n.automation-setlive-checklist-label {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.automation-setlive-checklist li.is-fail .automation-setlive-checklist-label {\n    color: #991b1b;\n    font-weight: 500;\n}\n\n.automation-setlive-checklist-detail {\n    font-size: 12.5px;\n    font-weight: 400;\n    color: #991b1b;\n    opacity: 0.85;\n}\n\n.automation-setlive-summary {\n    margin-top: 14px;\n    padding: 10px 12px;\n    border-radius: 0.375rem;\n    font-size: 13.5px;\n    font-weight: 500;\n}\n\n.automation-setlive-summary.is-ok {\n    background: rgba(34, 197, 94, 0.08);\n    color: #15803d;\n    border: 1px solid rgba(34, 197, 94, 0.25);\n}\n\n.automation-setlive-summary.is-fail {\n    background: rgba(239, 68, 68, 0.08);\n    color: #b91c1c;\n    border: 1px solid rgba(239, 68, 68, 0.25);\n}\n\n\n\n/* =========================\n   CONFIG DRAWER\n========================= */\n\n.automation-config-drawer {\n    /* Base width node-config drawers (Wait / Send Email / Send push / Add User) ke liye -\n       Automation Settings drawer isi variable ke upar +340px jyada rakhta h (neeche\n       inline style me calc() se), taaki agar yeh base kabhi badlein to settings wala\n       drawer khud-ba-khud usse bada hi rahe, dono jagah alag-alag number update na karna pade. */\n    --automation-drawer-width: 640px;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    height: 100vh;\n    width: var(--automation-drawer-width);\n    background: #fff;\n    box-shadow: -2px 0 12px rgba(0,0,0,0.15);\n    display: flex;\n    flex-direction: column;\n    z-index: 1050;\n}\n\n.automation-config-drawer-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e5e5e5;\n    flex-shrink: 0;\n}\n\n.automation-config-drawer-header h5 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #111827;\n}\n\n.automation-config-drawer-header .drawer-actions {\n    display: flex;\n    gap: 8px;\n}\n\n/* Config drawer (node config + Automation Settings) ke andar ka text thoda chota/compact -\n   ek 460px chaudi drawer me bootstrap ka default (16px) form text bahut bada/cramped lagta\n   h isliye yahan scoped override h (sirf drawer ke andar, baaki app me kahi aur asar nahi\n   padega). Section-title pehle inline style={{fontSize:14}} se chota kiya jata tha har\n   jagah alag se - ab ek hi jagah class se ho raha h. */\n.automation-config-drawer-body .automation-settings-section-title {\n    font-size: 14px;\n    margin-bottom: 10px;\n}\n.automation-config-drawer-body .automation-settings-help-text {\n    font-size: 12px;\n}\n.automation-config-drawer-body .form-control,\n.automation-config-drawer-body .form-select,\n.automation-config-drawer-body select,\n.automation-config-drawer-body input,\n.automation-config-drawer-body textarea {\n    font-size: 13px;\n}\n.automation-config-drawer-body .btn {\n    font-size: 13px;\n}\n.automation-config-drawer-body .automation-settings-radio-title {\n    font-size: 13px;\n}\n.automation-config-drawer-body .automation-settings-radio-desc {\n    font-size: 12px;\n}\n/* Metric / Template / Wait-unit jaise custom select-dropdowns (native <select> ki jagah\n   bane h) bhi drawer ke baaki text se bade (14px, zyada padding) the - yahan bhi 13px/\n   compact padding pe la rahe h taaki poori drawer ek hi consistent size me dikhe. */\n.automation-config-drawer-body .automation-settings-select-trigger {\n    padding: 7px 10px;\n    font-size: 13px;\n}\n.automation-config-drawer-body .automation-settings-select-dropdown-menu.dropdown-menu-subscription button {\n    padding: 0.45rem 0.6rem;\n    font-size: 13px;\n}\n.automation-config-drawer-body .automation-settings-select-group-title {\n    padding: 6px 12px 2px;\n}\n\n/* Baaki app me jaisa automation-header ke Cancel/Save buttons ka purple theme h (upar\n   AUTOMATION HEADER section me), yahan bhi wahi match karte h - taaki drawer ke buttons\n   bootstrap ke default blue/gray jaise na dikhe. */\n.automation-config-drawer-header button.btn-primary {\n    background: #4c5fd5;\n    border-color: #4c5fd5;\n}\n.automation-config-drawer-header button.btn-primary:hover:not(:disabled) {\n    background: #3d4fc2;\n    border-color: #3d4fc2;\n}\n.automation-config-drawer-header button.btn-secondary,\n.automation-config-drawer-header button.btn-outline-secondary {\n    background: #fff;\n    border-color: #d1d5db;\n    color: #374151;\n}\n.automation-config-drawer-header button.btn-secondary:hover,\n.automation-config-drawer-header button.btn-outline-secondary:hover {\n    background: #693cac1e;\n}\n\n.automation-config-drawer-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 20px;\n}\n\n.automation-config-drawer-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: transparent;\n    z-index: 1049;\n}\n\n.automation-node-info-banner {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 10px;\n    background: #eef2ff;\n    border-radius: 8px;\n    padding: 10px 12px;\n    margin-bottom: 14px;\n    font-size: 13px;\n    color: #374151;\n}\n\n.automation-node-info-banner-text {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n}\n\n.automation-node-info-banner-icon {\n    flex-shrink: 0;\n    margin-top: 2px;\n    color: #4c5fd5;\n}\n\n.automation-node-info-banner-text a {\n    color: #5b4ddb;\n    font-weight: 500;\n}\n\n.automation-node-info-banner-close {\n    cursor: pointer;\n    flex-shrink: 0;\n    color: #6b7280;\n}\n\n.automation-node-tip-box {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    background: #f9fafb;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 10px 12px;\n    font-size: 12px;\n    color: #6b7280;\n}\n\n.automation-node-tip-icon {\n    flex-shrink: 0;\n    margin-top: 1px;\n    color: #9ca3af;\n}\n\n.automation-node-adv-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 0;\n    font-size: 13px;\n    color: #374151;\n}\n\n.automation-settings-option-cards {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.automation-settings-option-card {\n    flex: 1;\n    border: 2px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 20px;\n    cursor: pointer;\n    text-align: center;\n    background: #f9fafb;\n}\n\n.automation-settings-option-card.active {\n    border-color: #5b4ddb;\n    background: #f5f3ff;\n}\n\n.automation-settings-option-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #e5e7eb;\n    color: #6b7280;\n    margin-bottom: 8px;\n}\n\n.automation-settings-option-card.active .automation-settings-option-icon {\n    background: #e3defc;\n    color: #5b4ddb;\n}\n\n.automation-settings-option-card h6 {\n    margin: 8px 0 4px;\n    font-weight: 600;\n}\n\n.automation-settings-option-card p {\n    margin: 0;\n    font-size: 13px;\n    color: #6b7280;\n}\n\n/* Entry/Exit/Re-entry/Schedule - sabhi Automation Settings tabs ke andar yahi shared design\n   language use ho (section title, field labels, dividers, segment add-links) */\n.automation-settings-section-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: #111827;\n    margin: 0 0 16px;\n}\n\n.automation-settings-field-label {\n    display: block;\n    font-size: 13px;\n    color: #374151;\n    margin-bottom: 8px;\n}\n\n.automation-settings-segment-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border: none;\n    background: none;\n    padding: 0;\n    color: #5b4ddb;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.automation-settings-segment-link:hover {\n    color: #4a3dc9;\n    text-decoration: underline;\n}\n\n.automation-settings-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 20px 0;\n}\n\n.automation-settings-help-text {\n    margin: 4px 0 0;\n    font-size: 12px;\n    color: #6b7280;\n}\n\n/* \"+ Add Template\" link next to Push/WhatsApp dropdown labels - reuses the same link look as\n   the existing automation-settings-segment-link, just sized to sit inline with a field label. */\n.automation-settings-add-template-link {\n    font-size: 12px;\n    font-weight: 500;\n    color: #5b4ddb;\n    text-decoration: none;\n}\n.automation-settings-add-template-link:hover {\n    color: #4a3dc9;\n    text-decoration: underline;\n}\n\n/* WhatsApp template preview now uses the shared WhatsAppMessagePreview component (same chat-bubble\n   look as WhatsApp > Templates) instead of its own bubble styles here. */\n.automation-settings-push-preview-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 6px;\n}\n\n/* Push template preview (point 5) - phone-notification-style card. */\n.automation-settings-push-preview-phone {\n    background: #f3f4f6;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 10px 12px;\n    max-width: 320px;\n}\n.automation-settings-push-preview-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: #111827;\n    margin-bottom: 2px;\n}\n.automation-settings-push-preview-message {\n    font-size: 12px;\n    color: #4b5563;\n}\n\n.automation-branch-radio-row {\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 12px 14px;\n    margin-bottom: 10px;\n}\n\n.automation-branch-radio {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #111827;\n    cursor: pointer;\n    margin: 0;\n}\n\n.automation-branch-radio input[type=\"radio\"] {\n    accent-color: #4c5fd5;\n    width: 16px;\n    height: 16px;\n    margin: 0;\n}\n\n.automation-branch-radio-body {\n    margin-top: 10px;\n    margin-left: 24px;\n}\n\n.automation-branch-error {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color: #dc2626;\n    font-size: 13px;\n    margin-top: 8px;\n}\n\n.automation-branch-tip {\n    display: flex;\n    gap: 8px;\n    background: #f9fafb;\n    border-radius: 6px;\n    padding: 10px 12px;\n    margin-top: 10px;\n    font-size: 12px;\n    color: #4b5563;\n}\n\n.automation-branch-segment-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: #693cac1e;\n    color: #4c5fd5;\n    border-radius: 14px;\n    padding: 4px 10px;\n    font-size: 13px;\n    margin: 0 6px 6px 0;\n}\n\n.automation-branch-segment-chip svg {\n    cursor: pointer;\n}\n\n.automation-branch-include-segment-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    background: none;\n    border: none;\n    color: #4c5fd5;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 4px 0;\n    cursor: pointer;\n}\n\n.automation-settings-channels-box {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 14px 18px;\n}\n\n.automation-settings-channel-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 0;\n}\n\n.automation-settings-channel-row + .automation-settings-channel-row {\n    border-top: 1px solid #f1f2f6;\n}\n\n.automation-settings-channel-label {\n    width: 90px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #111827;\n}\n\n.automation-settings-channel-bar {\n    flex: 1;\n    height: 4px;\n    border-radius: 2px;\n    background: #e5e7eb;\n    max-width: 160px;\n    position: relative;\n    overflow: hidden;\n}\n\n.automation-settings-channel-bar-fill {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    border-radius: 2px;\n    background: #22c55e;\n}\n\n.automation-settings-channel-value {\n    font-size: 13px;\n    font-weight: 600;\n    color: #111827;\n    min-width: 16px;\n    text-align: right;\n}\n\n/* Generic helper: hide anything labeled/marked \"beta\" for now (point 3 - feature paused,\n   will be revisited later). Apply this class directly on the box/row that should be hidden. */\n.beta_hide {\n    display: none !important;\n}\n\n/* Goals tab: \"Beta\" pill next to \"Set an Automation Goal\" */\n.automation-settings-beta-badge {\n    font-size: 11px;\n    font-weight: 600;\n    color: #5b4ddb;\n    background: #ede9fe;\n    padding: 2px 8px;\n    border-radius: 999px;\n    line-height: 1.4;\n}\n\n/* Goals tab: custom \"Metric\" dropdown (native <select> ki jagah OneSignal jesa panel) */\n.automation-settings-select-wrap {\n    position: relative;\n}\n\n.automation-settings-select-trigger {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    border: 1px solid #5b4ddb;\n    border-radius: 6px;\n    background: #fff;\n    color: #111827;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.automation-settings-select-placeholder {\n    color: #9ca3af;\n}\n\n/* Metric/Template/Wait-unit dropdown ke liye `.dropdown-menu-subscription` hi underlying\n   component/markup h (App ke standard \"More options\"/card 3-dot/list row-actions wala), lekin\n   ek \"select\" field ki tarah dikhna chahiye, ek action-menu ki tarah nahi - isliye apna khud ka\n   tighter/form-jesa skin is class se milta h: poori trigger-width (native <select> jaisa),\n   compact row-height, aur selected value pe checkmark (icon-heavy action-row jesa nahi). */\n.automation-settings-select-dropdown-menu.dropdown-menu-subscription {\n    width: 100%;\n    min-width: 100%;\n    max-height: 260px;\n    overflow-y: auto;\n    padding: 4px;\n}\n.automation-settings-select-dropdown-menu.dropdown-menu-subscription button {\n    padding: 8px 10px;\n    font-size: 13px;\n    border-radius: 4px;\n    justify-content: space-between;\n}\n\n.automation-settings-select-empty {\n    padding: 10px 14px;\n    font-size: 13px;\n    color: #9ca3af;\n}\n\n/* Selected option ko checkmark + halka purple text se highlight karte h (select jaisa), aur\n   locked (jese \"Sessions Attribution\") option ko disabled jaisa dikhate h. */\n.automation-settings-select-dropdown-menu.dropdown-menu-subscription button.active {\n    background: #693cac1e;\n    color: #4c5fd5;\n    font-weight: 500;\n}\n.automation-settings-select-dropdown-menu.dropdown-menu-subscription button:disabled {\n    color: #9ca3af;\n    cursor: not-allowed;\n}\n.automation-settings-select-dropdown-menu .automation-settings-select-check {\n    flex-shrink: 0;\n    margin-left: auto;\n    color: #4c5fd5;\n}\n.automation-settings-select-dropdown-menu .automation-settings-select-lock {\n    flex-shrink: 0;\n    margin-left: auto;\n}\n\n.automation-settings-select-group-title {\n    padding: 8px 14px 4px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #9ca3af;\n}\n\n.automation-settings-select-locked-action {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    background: none;\n    padding: 10px 14px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #5b4ddb;\n    cursor: not-allowed;\n}\n\n/* Exit rules tab (and reused for Entry/Re-entry style \"which option\" choices): full-width\n   radio cards stacked vertically, with the active one's nested content (checkboxes/segment\n   picker/tags) rendered INSIDE the card, matching the OneSignal reference screenshots */\n.automation-settings-radio-card {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    border: 1.5px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 16px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    background: #fff;\n}\n\n.automation-settings-radio-card.active {\n    border-color: #5b4ddb;\n}\n\n.automation-settings-radio {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 1.5px solid #d1d5db;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.automation-settings-radio.checked {\n    border-color: #5b4ddb;\n    border-width: 5px;\n}\n\n.automation-settings-radio-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n}\n\n.automation-settings-radio-desc {\n    font-size: 13px;\n    color: #6b7280;\n    margin-top: 2px;\n}\n\n.automation-settings-radio-card-body {\n    margin-top: 14px;\n    cursor: default;\n}\n\n.automation-settings-radio-card-body .form-check {\n    margin-bottom: 10px;\n}\n\n/* Segment/tag chips (Exit rules \"Enters a segment\" + \"Tag users when they exit early\") */\n.automation-settings-chip-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n}\n\n.automation-settings-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    background: #eef0fd;\n    color: #3f3fae;\n    border-radius: 6px;\n    padding: 4px 8px;\n    font-size: 13px;\n}\n\n.automation-settings-chip-remove {\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.automation-settings-chip-remove:hover {\n    color: #1f1f6b;\n}\n\n/* \"Previous\" / \"Next\" pagination footer across all Automation Settings tabs - dono buttons\n   LEFT side pe rakhe h (space-between se right wala \"Next\" button page ke bottom-right\n   corner me chup jata tha, jaha chat-widget ka floating icon rehta h). */\n.automation-settings-pagination {\n    display: flex;\n    justify-content: flex-start;\n    gap: 8px;\n    padding: 14px 20px;\n    border-top: 1px solid #e5e7eb;\n    flex-shrink: 0;\n}\n\n/* Select Segment modal */\n.automation-settings-modal-search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: 1px solid #5b4ddb;\n    border-radius: 6px;\n    padding: 8px 12px;\n    margin-bottom: 12px;\n    color: #9ca3af;\n}\n\n.automation-settings-modal-search input {\n    border: none;\n    outline: none;\n    flex: 1;\n    font-size: 14px;\n    color: #111827;\n}\n\n.automation-settings-segment-list {\n    max-height: 280px;\n    overflow-y: auto;\n}\n\n.automation-settings-segment-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 4px;\n    border-bottom: 1px solid #f1f2f6;\n}\n\n.automation-settings-segment-row-icon {\n    display: inline-flex;\n    color: #5b4ddb;\n    flex-shrink: 0;\n}\n\n.automation-settings-segment-row-name {\n    flex: 1;\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n}\n\n.automation-settings-segment-row-add {\n    border: none;\n    background: none;\n    color: #5b4ddb;\n    display: inline-flex;\n    cursor: pointer;\n}\n\n.automation-settings-segment-row-add:disabled {\n    color: #d1d5db;\n    cursor: default;\n}\n\n.automation-settings-modal-footnote {\n    text-align: center;\n    font-size: 13px;\n    margin-top: 10px;\n}\n\n/* =========================\n   CANVAS\n========================= */\n\n.automation-canvas {\n    flex: 1;\n    min-width: 0;\n    min-height: 0;\n\n    position: relative;\n\n    background: #f8fafc;\n}\n\n.automation-canvas .react-flow {\n    width: 100%;\n    height: 100%;\n}\n\n\n/* =========================\n   NODE\n========================= */\n\n.automation-node {\n    position: relative;\n    width: 220px;\n    padding: 0;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    /* overflow:hidden hata diya - isse Handle circles (card edge pe half-in/half-out) aur\n       ConditionNode ke Yes/No labels (card ke bahar bottom pe) clip ho jate the */\n}\n\n/* Har node card ke top-right wala \"...\" (three-dot) actions menu - Edit/Duplicate/Delete\n   (Entrance/Exit pe sirf Edit) */\n.node-actions-menu {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    z-index: 2;\n}\n\n.node-actions-toggle {\n    width: 22px;\n    height: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    line-height: 0;\n    border-radius: 4px;\n    border: 1px solid transparent;\n    background: transparent;\n    color: #9ca3af;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n.node-actions-toggle:hover,\n.node-actions-toggle:focus {\n    background: #f3f4f6;\n    color: #374151;\n    border-color: #e5e7eb;\n}\n.node-actions-toggle::after {\n    display: none; /* bootstrap ka default caret arrow yahan nahi chahiye, sirf dots icon */\n}\n.node-actions-toggle svg {\n    width: 14px;\n    height: 14px;\n}\n\n\n.node-actions-menu .dropdown-menu-subscription {\n    width: 104px;\n    margin-top: 4px;\n}\n\n/* Node card (220px chaudi) ke 3-dot menu ka dropdown card ke hisab se hi chota/compact hona\n   chahiye - header ke \"More options\" wale dropdown se bhi aur zyada chota, isliye\n   width/padding/font-size/icon-size yahan alag se override kiye h. */\n.node-actions-dropdown-menu.dropdown-menu-subscription {\n    padding: 0.1rem;\n}\n.node-actions-dropdown-menu.dropdown-menu-subscription button {\n    padding: 0.22rem 0.3rem;\n    font-size: 11px;\n    gap: 5px;\n}\n.node-actions-dropdown-menu.dropdown-menu-subscription button > svg {\n    width: 11px;\n    height: 11px;\n    min-width: 11px;\n}\n.node-actions-dropdown-menu.dropdown-menu-subscription .delete-class {\n    padding-top: 0.3rem;\n}\n\n/* Automation Settings drawer ke left side wali tabs list (Entry rules / Re-entry rules /\n   Schedule / Goals) - pehle raw inline style se banti thi (16px jesa default font, light-gray\n   active background) jo bootstrap-size text jesa bada dikh raha tha; ab app ke purple theme\n   se match karti compact class h. */\n.automation-settings-tabs-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n.automation-settings-tab-item {\n    padding: 8px 10px;\n    font-size: 13px;\n    font-weight: 400;\n    color: #4b5563;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n.automation-settings-tab-item:hover {\n    background: #693cac1e;\n}\n.automation-settings-tab-item.active {\n    font-weight: 600;\n    color: #4c5fd5;\n    background: #4c5fd51a;\n}\n\n/* Drag-drop reorder: jis \"+\" edge ke paas card drop hoga vo highlight ho jayega */\n.automation-edge-plus-btn.drop-target-active {\n    background: var(--primary-color, #6366f1);\n    border-color: var(--primary-color, #6366f1);\n    color: #fff;\n    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.4);\n}\n/* Jaise hi koi card drag hota h, HAR \"+\" apni jagah ek card-width rectangle drop-zone\n   dikhata h (jaha bhi drop ho sakta h) - jo sabse nazdeek h vo \".active\" se highlight ho jata h */\n.automation-edge-drop-zone {\n    width: 220px; /* .automation-node ke width (220px) ke barabar */\n    height: 44px;\n    border-radius: 10px;\n    border: 2px dashed #c7cad9;\n    background: rgba(148, 163, 184, 0.06);\n    pointer-events: none;\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n.automation-edge-drop-zone.active {\n    border-color: var(--primary-color, #6366f1);\n    background: rgba(99, 102, 241, 0.1);\n}\n\n/* Drag-drop reorder: jahan se card uthaya gaya h, vahan uski jagah card ke exact\n   width/height ka ek dashed placeholder box dikhta h (jab tak drop nahi ho jata) */\n.automation-drag-ghost {\n    opacity: 0.55; /* OneSignal jesa - asli card jesa hi dikhega, bas thoda halka (placeholder) */\n}\n\n.automation-node-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 28px 10px 12px; /* right side .node-delete-btn (top-right) ke liye jagah */\n    border-bottom: 1px solid #f1f1f1;\n    border-radius: 4px 4px 0 0; /* overflow:hidden parent se hatane ke baad bhi top corners rounded rahe */\n}\n\n.automation-node-icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    flex-shrink: 0;\n}\n\n.automation-node.entrance-node .automation-node-icon { background: #16a34a; }\n.automation-node.exit-node .automation-node-icon     { background: #dc2626; }\n.automation-node.send-node .automation-node-icon     { background: #4c5fd5; }\n.automation-node.email-node .automation-node-icon    { background: #0891b2; }\n.automation-node.in-app-node .automation-node-icon   { background: #7c3aed; }\n.automation-node.sms-node .automation-node-icon      { background: #0d9488; }\n.automation-node.wait-node .automation-node-icon     { background: #f59e0b; }\n.automation-node.condition-node .automation-node-icon{ background: #ec4899; }\n\n/* Condition node ke \"Yes\"/\"No\" branch tags - node card ke bottom se thoda neeche, chhoti\n   pill/chip jaisi dikhe (plain text ki jagah) - OneSignal jese reference design se match\n   karne ke liye. */\n.automation-node-branch-label {\n    position: absolute;\n    bottom: -22px;\n    transform: translateX(-50%);\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 1px 8px;\n    font-size: 11px;\n    font-weight: 500;\n    color: #4b5563;\n    white-space: nowrap;\n}\n/* PlusEdge ke andar Condition branch ke turn-point par \"Yes\"/\"No\" label - automation-node-branch-label\n   jesa hi dikhta h, bas ab yeh edge ke actual turn-coordinate (turnX/turnY) par render hota h\n   (parent transform already translate(x,y) kar deta h), isliye apna position/bottom nahi chahiye. */\n.automation-edge-branch-label {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 1px 8px;\n    font-size: 11px;\n    font-weight: 500;\n    color: #4b5563;\n    white-space: nowrap;\n    pointer-events: none;\n}\n.automation-node.tag-node .automation-node-icon      { background: #d97706; }\n.automation-node.whatsapp-node .automation-node-icon { background: #25d366; }\n\n.automation-node-body {\n    padding: 10px 12px;\n}\n\n.automation-node-badge {\n    display: inline-block;\n    margin-top: 6px;\n    padding: 2px 8px;\n    border-radius: 4px;\n    background: #fef3c7;\n    color: #92400e;\n    font-size: 11px;\n}\n\n\n/* =========================\n   NODE TYPES\n========================= */\n\n/* Node type ka color sirf header icon badge se dikhta h (NODE_TYPE_ICONS backgrounds) -\n   card border sabhi types me same (plain gray) rakha h taki consistent dikhe; selected hone pe\n   React Flow ki apni default highlight (blue outline) lagti h, vo bhi sabhi types pe equally. */\n\n\n/* =========================\n   NODE CONFIG PANEL\n========================= */\n\n.node-config-panel {\n    width: 280px;\n    min-width: 280px;\n\n    padding: 18px;\n\n    background: #ffffff;\n\n    border-left: 1px solid #e5e7eb;\n\n    overflow-y: auto;\n}\n\n.node-config-panel h5 {\n    margin: 0;\n\n    font-size: 15px;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.node-config-panel .d-flex {\n    margin-bottom: 20px;\n}\n\n.node-config-panel .d-flex button {\n    border: 0;\n    background: transparent;\n\n    font-size: 20px;\n\n    cursor: pointer;\n}\n\n.node-config-panel label {\n    display: block;\n\n    margin: 14px 0 6px;\n\n    font-size: 13px;\n    font-weight: 500;\n\n    color: #374151;\n}\n\n.node-config-panel input,\n.node-config-panel select {\n    width: 100%;\n\n    padding: 8px 10px;\n\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n\n    font-size: 13px;\n\n    outline: none;\n}\n\n.node-config-panel input:focus,\n.node-config-panel select:focus {\n    border-color: #3b82f6;\n}\n\n\n/* =========================\n   REACT FLOW CONTROLS\n========================= */\n\n.automation-canvas .react-flow__controls {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.automation-canvas .react-flow__minimap {\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n\n/* =========================\n   CONNECTION\n========================= */\n\n.automation-canvas .react-flow__edge-path {\n    stroke-width: 2;\n}\n\n.automation-canvas .react-flow__handle {\n    width: 8px;\n    height: 8px;\n}\n\n\n/* =========================\n   MOBILE / SMALL SCREEN\n========================= */\n\n@media (max-width: 900px) {\n\n    .automation-sidebar {\n        width: 150px;\n        min-width: 150px;\n        padding: 10px;\n    }\n\n    .node-config-panel {\n        width: 240px;\n        min-width: 240px;\n    }\n\n}\n\n\n\n\n/* Live per-node enrollment count badge (Automation Builder) - top-left corner of a message/wait/\n   condition card, opposite the \"...\" actions menu. Clickable: opens the user list behind it. */\n/* Body row that holds the card's own text on the left + the live user-count badge on the\n   right (bottom of the card, next to whatever text already shows there) - flex, not absolute\n   positioning, so the badge sits inline with the text instead of floating over the card. */\n.automation-node-body-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n}\n.automation-node-body-row > *:first-child {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.automation-node-user-count-badge {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    padding: 1px 6px;\n    border-radius: 999px;\n    border: 1px solid #bfdbfe;\n    background: #eff6ff;\n    color: #1d4ed8;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.4;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n.automation-node-user-count-badge:hover {\n    background: #dbeafe;\n    border-color: #93c5fd;\n}\n.automation-node-user-count-wrap {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n.automation-node-user-error-badge {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    padding: 1px 6px;\n    border-radius: 999px;\n    border: 1px solid #fecaca;\n    background: #fef2f2;\n    color: #b91c1c;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.4;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n.automation-node-user-error-badge:hover {\n    background: #fee2e2;\n    border-color: #fca5a5;\n}\n\n/* Invisible merge point that closes an automation Condition block (JoinNode in AutomationBuilder.js) */\n.automation-join-node {\n    width: 2px;\n    height: 2px;\n    background: transparent;\n    pointer-events: none;\n}\n.automation-join-node .react-flow__handle {\n    opacity: 0;\n    width: 2px;\n    height: 2px;\n    min-width: 0;\n    min-height: 0;\n    border: 0;\n    top: 0;\n    bottom: auto;\n}\n.automation-join-node .react-flow__handle-bottom {\n    top: auto;\n    bottom: 0;\n}\n\n/* ---- Automation: failed pre-launch check highlight ---- */\n.react-flow__node.automation-node-has-error .automation-node {\n  border: 2px solid #dc2626 !important;\n  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.15), 0 4px 12px rgba(220, 38, 38, 0.18);\n  animation: automation-error-pulse 1.4s ease-in-out 3;\n}\n@keyframes automation-error-pulse {\n  0%, 100% { box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.15), 0 4px 12px rgba(220, 38, 38, 0.18); }\n  50% { box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.25), 0 4px 12px rgba(220, 38, 38, 0.25); }\n}\n.automation-setlive-checklist li.is-clickable { cursor: pointer; }\n.automation-setlive-checklist li.is-clickable:hover { background: rgba(220, 38, 38, 0.06); }\n.automation-setlive-checklist-goto {\n  display: block;\n  margin-top: 2px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #dc2626;\n}\n\n/* ---- Automation: view-only (live / ended / archived) ---- */\n.automation-readonly-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 8px;\n  padding: 10px 14px;\n  border: 1px solid #fcd9a6;\n  background: #fff8ec;\n  color: #7a4a05;\n  border-radius: 8px;\n  font-size: 0.85rem;\n}\n.automation-readonly-note {\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: #f3f4f6;\n  color: #4b5563;\n  font-size: 0.8rem;\n}\n.automation-readonly-fieldset {\n  border: 0;\n  padding: 0;\n  margin: 0;\n  min-width: 0;\n}\n\n/* ============================================================\n   Engage → Funnel (components/engage/FunnelAnalysis.js)\n   KPI tiles reuse .campaign-summary-*, chips reuse .badge.bg-light-*,\n   buttons reuse .btn_theme_*, help icons reuse HelpTooltip.\n   Theme: primary #4346ce, ink #1a2332, muted #6b7785, border #e8ecf1.\n   ============================================================ */\n\n\n.funnel-card {\n    background: #fff;\n    border: 1px solid #e8ecf1;\n    border-radius: 10px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n    padding: 18px 20px;\n    margin-bottom: 16px;\n}\n\n.funnel-card-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 14px;\n}\n\n.funnel-card-head h2 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1a2332;\n    margin: 0;\n}\n\n.funnel-card-head p {\n    margin: 2px 0 0;\n    font-size: 13px;\n    color: #6b7785;\n}\n\n/* ---- step builder ---- */\n\n.funnel-steps {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    gap: 8px;\n}\n\n.funnel-step {\n    flex: 1 1 200px;\n    max-width: 280px;\n    min-width: 190px;\n    border: 1px solid #e8ecf1;\n    border-radius: 10px;\n    padding: 10px;\n    background: #fff;\n    transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.funnel-step:hover,\n.funnel-step:focus-within {\n    border-color: #4346ce;\n    box-shadow: 0 0 0 3px #eef0fc;\n}\n\n.funnel-step--empty {\n    background: #fbfcfe;\n}\n\n.funnel-step-top {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.funnel-step-num {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: #4346ce;\n    color: #fff;\n    font-size: 12px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 22px;\n    min-width: 22px;\n    padding: 0 !important;\n    line-height: 1;\n    box-sizing: border-box;\n}\n\n.funnel-step-label {\n    font-size: 12px;\n    font-weight: 500;\n    color: #6b7785;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.funnel-step-actions {\n    margin-left: auto;\n    display: flex;\n    gap: 2px;\n}\n\n.funnel-step-actions button {\n    border: none;\n    background: none;\n    color: #6b7785;\n    width: 26px;\n    height: 26px;\n    border-radius: 6px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.funnel-step-actions button:hover:not(:disabled) {\n    background: #f4f6fa;\n    color: #1a2332;\n}\n\n.funnel-step-actions button:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.funnel-step-arrow {\n    display: flex;\n    align-items: center;\n    color: #b4bccb;\n    font-size: 20px;\n}\n\n.funnel-step-add {\n    flex: 0 0 auto;\n    min-width: 130px;\n    border: 1.5px dashed #c9cfdc;\n    border-radius: 10px;\n    background: none;\n    color: #4346ce;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 10px 14px;\n}\n\n.funnel-step-add:hover {\n    border-color: #4346ce;\n    background: #eef0fc;\n}\n\n.funnel-error {\n    margin-top: 8px;\n    font-size: 13px;\n    color: #b42318;\n}\n\n.funnel-settings {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n    align-items: end;\n    margin-top: 18px;\n    padding-top: 16px;\n    border-top: 1px solid #e8ecf1;\n}\n\n.funnel-setting label,\n.funnel-more label {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #6b7785;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    margin-bottom: 6px;\n}\n\n.funnel-setting--actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n.funnel-setting--actions .btn_theme_secondary,\n.funnel-setting--actions .btn_theme_primary {\n    gap: 6px;\n    min-height: 38px;\n}\n\n.funnel-more-toggle {\n    margin-top: 14px;\n    border: none;\n    background: none;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #4346ce;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.funnel-more-toggle svg:last-child {\n    transition: transform 0.2s;\n}\n\n.funnel-more-toggle svg.open {\n    transform: rotate(180deg);\n}\n\n.funnel-more {\n    padding-top: 12px;\n}\n\n/* segmented control (step order + users modal tabs) */\n.funnel-seg {\n    display: inline-flex;\n    flex-wrap: wrap;\n    background: #f4f6fa;\n    border: 1px solid #e8ecf1;\n    border-radius: 8px;\n    padding: 3px;\n    gap: 2px;\n    margin-bottom: 14px;\n}\n\n.funnel-seg--inline {\n    display: flex;\n    margin-bottom: 0;\n}\n\n.funnel-seg--inline button {\n    flex: 1;\n}\n\n.funnel-seg button {\n    border: none;\n    background: none;\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-size: 14px;\n    color: #6b7785;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    min-height: 30px;\n}\n\n.funnel-seg button.active {\n    background: #fff;\n    color: #4346ce;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);\n}\n\n/* ---- results ---- */\n\n.funnel-results.is-loading {\n    opacity: 0.55;\n    pointer-events: none;\n    transition: opacity 0.2s;\n}\n\n.funnel-applied {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.funnel-applied-path {\n    display: inline-flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px;\n    color: #1a2332;\n    margin-right: 6px;\n}\n\n.funnel-applied-path svg {\n    color: #b4bccb;\n}\n\n.funnel-page .campaign-summary-row {\n    margin-bottom: 16px;\n}\n\n.funnel-page .campaign-summary-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.funnel-meter {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.funnel-meter span {\n    min-width: 48px;\n    text-align: right;\n    font-size: 13px;\n    color: #1a2332;\n}\n\n.funnel-meter-bar {\n    flex: 1;\n    height: 6px;\n    border-radius: 6px;\n    background: #f4f6fa;\n    overflow: hidden;\n}\n\n.funnel-meter-bar i {\n    display: block;\n    height: 100%;\n    background: #4346ce;\n    border-radius: 6px;\n}\n\n.funnel-insight {\n    background: #eef0fc;\n    border: 1px solid #dcdffa;\n    border-radius: 10px;\n    padding: 12px 16px;\n    color: #1a2332;\n    font-size: 14px;\n    line-height: 1.55;\n    margin-bottom: 16px;\n}\n\n/* ---- chart ---- */\n\n.funnel-chart {\n    position: relative;\n    padding-left: 44px;\n}\n\n.funnel-chart-plot {\n    position: relative;\n    height: 300px;\n    margin-top: 36px;\n}\n\n.funnel-chart-yaxis span {\n    position: absolute;\n    left: -44px;\n    width: 36px;\n    text-align: right;\n    font-size: 11px;\n    color: #98a2b3;\n    transform: translateY(50%);\n}\n\n.funnel-chart-grid i {\n    position: absolute;\n    left: 0;\n    right: 0;\n    height: 0;\n    border-top: 1px solid #eef1f5;\n}\n\n.funnel-chart-grid i:first-child,\n.funnel-chart-grid i:last-child {\n    border-top-color: #e3e7ee;\n}\n\n.funnel-chart-cols {\n    position: absolute;\n    inset: 0;\n    display: grid;\n    gap: 2px;\n}\n\n.funnel-col {\n    position: relative;\n    display: flex;\n    justify-content: center;\n}\n\n.funnel-col-track {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: min(64%, 120px);\n}\n\n.funnel-col-bar,\n.funnel-col-drop {\n    position: absolute;\n    left: 0;\n    right: 0;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n}\n\n.funnel-col-bar {\n    bottom: 0;\n    background: #4346ce;\n    border-radius: 4px 4px 0 0;\n    transition: background 0.15s;\n}\n\n.funnel-col-bar.is-hover,\n.funnel-col-bar:focus-visible {\n    background: #3a3db3;\n    outline: none;\n}\n\n.funnel-col-drop {\n    background: repeating-linear-gradient(135deg, #d9dde8 0 2px, #f4f6fa 2px 7px);\n    border-radius: 4px 4px 0 0;\n    /* 2px surface gap between the drop-off area and the reached bar */\n    box-shadow: inset 0 -2px 0 #fff;\n}\n\n.funnel-col-drop.is-hover,\n.funnel-col-drop:focus-visible {\n    background: repeating-linear-gradient(135deg, #bfc5d4 0 2px, #eceff5 2px 7px);\n    outline: none;\n}\n\n.funnel-col-value {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    line-height: 1.15;\n    pointer-events: none;\n}\n\n.funnel-col-value strong {\n    display: block;\n    font-size: 15px;\n    color: #1a2332;\n}\n\n.funnel-col-value span {\n    font-size: 12px;\n    color: #6b7785;\n}\n\n.funnel-col-conv {\n    position: absolute;\n    left: 0;\n    bottom: 8px;\n    transform: translateX(-50%);\n    z-index: 2;\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    background: #fff;\n    border: 1px solid #e8ecf1;\n    border-radius: 999px;\n    padding: 2px 8px 2px 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #1a2332;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);\n    white-space: nowrap;\n}\n\n.funnel-col-conv svg {\n    color: #4346ce;\n}\n\n.funnel-chart-labels {\n    display: grid;\n    gap: 2px;\n    margin-top: 10px;\n}\n\n.funnel-chart-label {\n    text-align: center;\n    min-width: 0;\n    padding: 0 4px;\n}\n\n.funnel-chart-label small {\n    display: block;\n    font-size: 11px;\n    color: #98a2b3;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.funnel-chart-label strong {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: #1a2332;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.funnel-legend {\n    justify-content: center;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 16px;\n    margin-top: 16px;\n    padding-top: 12px;\n    border-top: 1px solid #e8ecf1;\n    font-size: 13px;\n    color: #475467;\n}\n\n.funnel-legend span {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.funnel-legend-swatch {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    border-radius: 3px;\n}\n\n.funnel-legend-swatch--reached {\n    background: #4346ce;\n}\n\n.funnel-legend-swatch--drop {\n    background: repeating-linear-gradient(135deg, #d9dde8 0 2px, #f4f6fa 2px 5px);\n    border: 1px solid #d0d5e0;\n}\n\n\n.funnel-tip {\n    position: absolute;\n    z-index: 5;\n    width: 240px;\n    background: #fff;\n    border: 1px solid #e8ecf1;\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.14);\n    padding: 10px 12px;\n    pointer-events: none;\n    font-size: 13px;\n}\n\n.funnel-tip-title {\n    font-weight: 600;\n    color: #1a2332;\n    margin-bottom: 6px;\n}\n\n.funnel-tip-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    color: #6b7785;\n    line-height: 1.7;\n}\n\n.funnel-tip-row strong {\n    color: #1a2332;\n}\n\n\n/* ---- step breakdown table + users modal table ---- */\n\n.funnel-users-table {\n    margin: 0;\n    font-size: 14px;\n}\n\n.funnel-users-table th {\n    font-size: 12px;\n    font-weight: 500;\n    color: #6b7785;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    border-bottom: 1px solid #e8ecf1;\n    background: #fafbfc;\n    white-space: nowrap;\n}\n\n.funnel-users-table td {\n    vertical-align: middle;\n    border-bottom: 1px solid #f0f2f5;\n    color: #1a2332;\n}\n\n.funnel-table-step {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.funnel-table-actions {\n    white-space: nowrap;\n}\n\n.funnel-link {\n    border: none;\n    background: none;\n    padding: 0;\n    margin-left: 14px;\n    color: #4346ce;\n    font-weight: 500;\n    font-size: 13px;\n}\n\n.funnel-link:hover:not(:disabled) {\n    text-decoration: underline;\n}\n\n.funnel-link--muted {\n    color: #475467;\n}\n\n.funnel-link:disabled {\n    color: #c0c6d1;\n    cursor: not-allowed;\n}\n\n.funnel-users-sub {\n    display: block;\n    font-size: 13px;\n    font-weight: 400;\n    color: #6b7785;\n    margin-top: 2px;\n}\n\n.funnel-user {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.funnel-user-name {\n    font-weight: 500;\n    color: #1a2332;\n}\n\n.funnel-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: #eef0fc;\n    color: #4346ce;\n    font-size: 12px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n}\n\n.funnel-avatar--anon {\n    background: #f2f4f7;\n    color: #98a2b3;\n}\n\n.funnel-dots {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    cursor: help;\n}\n\n.funnel-dots i {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #e4e7ec;\n}\n\n.funnel-dots i.on {\n    background: #4346ce;\n}\n\n.funnel-dots small {\n    margin-left: 4px;\n    color: #6b7785;\n}\n\n/* ---- empty states ---- */\n\n.funnel-empty {\n    text-align: center;\n    padding: 40px 20px;\n    color: #6b7785;\n}\n\n.funnel-empty h3 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1a2332;\n    margin: 12px 0 6px;\n}\n\n.funnel-empty p {\n    max-width: 460px;\n    margin: 0 auto;\n    font-size: 14px;\n}\n\n.funnel-empty--sm {\n    padding: 28px 10px;\n}\n\n.funnel-empty-art {\n    width: 150px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n}\n\n.funnel-empty-art span {\n    display: block;\n    height: 14px;\n    border-radius: 4px;\n    background: #4346ce;\n    opacity: 0.85;\n}\n\n.funnel-empty-art span:nth-child(2) {\n    opacity: 0.55;\n}\n\n.funnel-empty-art span:nth-child(3) {\n    opacity: 0.3;\n}\n\n/* ---- responsive ---- */\n\n@media (max-width: 992px) {\n    .funnel-settings {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .funnel-step-arrow {\n        display: none;\n    }\n}\n\n@media (max-width: 768px) {\n    .funnel-settings {\n        grid-template-columns: 1fr;\n    }\n\n    .funnel-setting--actions .btn_theme_primary,\n    .funnel-setting--actions .btn_theme_secondary {\n        width: 100%;\n    }\n\n    .funnel-step {\n        max-width: none;\n    }\n\n    .funnel-chart-plot {\n        height: 240px;\n    }\n\n    .funnel-col-value strong {\n        font-size: 13px;\n    }\n\n}\n\n.funnel-label-val {\n    display: block;\n    margin-top: 2px;\n    font-size: 12px;\n    color: #6b7785;\n}\n\n.funnel-label-val b {\n    font-size: 14px;\n    color: #1a2332;\n}\n\n.funnel-step--dup {\n    border-color: #e5484d;\n    box-shadow: 0 0 0 3px rgba(229, 72, 77, 0.12);\n}\n\n.funnel-steps .funnel-step-arrow {\n    flex: 0 0 auto;\n}\n\n.funnel-table-actions {\n    white-space: nowrap;\n    padding-right: 72px;\n}\n\n.funnel-steps--many .funnel-step-arrow {\n    display: none;\n}\n\n@media (max-width: 576px) {\n    .funnel-col-conv {\n        display: none;\n    }\n}\n\n/* ---- Engage → Funnel: saved funnels (FunnelList.js + name/description on FunnelAnalysis.js) ---- */\n.funnel-meta {\n    margin-bottom: 14px;\n}\n\n.funnel-meta label {\n    display: block;\n    font-size: 12px;\n    font-weight: 500;\n    color: #6b7785;\n    margin-bottom: 4px;\n}\n\n.funnel-dirty-badge {\n    margin-left: 10px;\n    font-size: 11px;\n    font-weight: 500;\n    vertical-align: middle;\n}\n\n.funnel-list-steps {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 4px;\n    max-width: 420px;\n}\n\n.funnel-list-steps-arrow {\n    color: #b4bccb;\n    flex: 0 0 auto;\n}\n\n.funnel-kpi-sub {\n  margin-top: 2px;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Table cells force `span { display:block }` — keep the step number a centred circle */\ntable.table_outer .funnel-step-num {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    line-height: 1;\n}\n\n.funnel-users-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: nowrap;\n}\n\n.funnel-next-summary {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 12px;\n    font-size: 13px;\n    color: #475467;\n}\n\n.funnel-segment-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 12px;\n}\n\n.funnel-actions-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 14px;\n}\n\n.funnel-actions-row .funnel-more-toggle {\n    margin-top: 0;\n}\n\n/* A step can hold several events: keep the step cards the same height and let the chips wrap inside */\n.funnel-step .ns-funnel-step__control {\n    min-height: 40px;\n}\n\n.funnel-step .ns-funnel-step__multi-value {\n    max-width: 100%;\n}\n\n.funnel-applied-label {\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #6b7785;\n}\n\n.funnel-path {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 4px;\n    min-width: 260px;\n    max-width: 460px;\n}\n\n.funnel-path-chip {\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: #f2f4f7;\n    color: #475467;\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n.funnel-path-chip--step {\n    background: #eef0ff;\n    color: #3f3fbf;\n    font-weight: 600;\n}\n\n.funnel-path-arrow,\n.funnel-path-more {\n    color: #98a2b3;\n    font-size: 12px;\n}\n\n\n/* DateRangePicker: portaled panel always stays reachable - scrolls inside itself when the window is short */\n.ns-daterange__popover.ns-daterange__popover--portal {\n  max-height: calc(100vh - 24px);\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
